// import React, { useState, useRef, useEffect } from "react";
// import Modal from "../../POP/Modal"; // Import the modal component
// import MathLive from "../../POP/FileComp7"; // Import MathLive component
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
// import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
// const TextboxWithImageSecond = ({
//   width = "100%",
//   height = "auto",
//   htmlContent,
//   questionCounter,
//   currentQuestion,
//   questionText,
//   option,
//   quesType,
// }) => {
//   console.log("option", option);
//   console.log("questionText", questionText);
//   console.log("current question type ", quesType);
//   const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
//   const recognitionRef = useRef(null); // Ref for the speech recognition object
//   const contentEditableRef = useRef(null);
//   const [images, setImages] = useState([]); // Stores actual image files
//   const [showModal, setShowModal] = useState(false); // Modal state
//   const [latex, setLatex] = useState(""); // MathLive LaTeX content state
//   const [content, setContent] = useState(htmlContent || "");
//   const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
//   const [isClicked, setIsClicked] = useState(false);
//   const fileInputRef = useRef(null); // Ref for the hidden file input
//   const [questionType, setQuestionType] = useState("single-select"); // Tracks question type0
//   const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
//   const [hasCounterChanged, setHasCounterChanged] = useState(false);

//   const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)

//   const [options, setOptions] = useState([
//     { id: 1, content: "" },
//     { id: 2, content: "" },
//     { id: 3, content: "" },
//     { id: 4, content: "" },
//   ]); // Editable options
//   const mainEditableRef = useRef(null);
//   const refs = useRef([]); // Refs for all editable options
//   // const [content, setContent] = useState(questionText || "");
//   const [editableOptions, setEditableOptions] = useState(
//     options.map((option, index) => ({
//       id: index + 1,
//       content: option.option_text,
//     }))
//   );

//   // Populate refs dynamically for all options
//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   useEffect(() => {
//     if (htmlContent !== content) {
//       setContent(htmlContent);
//     }
//   }, [htmlContent]);
//   const renderLatexToHTML = (text) => {
//     try {
//       let html = text;

//       // Replace LaTeX
//       html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//           displayMode: true,
//         })
//       );

//       html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//         })
//       );

//       // Replace image placeholders with actual images
//       images.forEach((image) => {
//         const placeholder = `[${image.id}_${image.alt}]`;
//         const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
//         html = html.replace(placeholder, imgTag);
//       });

//       return html;
//     } catch (error) {
//       console.error("Error rendering HTML:", error);
//       return text;
//     }
//   };

//   const handleInput = (id = "main") => {
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const contentHTML = ref.innerHTML; // Get HTML content to retain images

//     if (id === "main") {
//       setContent(contentHTML.trim());
//     } else {
//       setEditableOptions((prevOptions) =>
//         prevOptions.map((option) =>
//           option.id === id ? { ...option, content: contentHTML.trim() } : option
//         )
//       );
//     }
//   };

//   const startSpeechToText = () => {
//     if (
//       !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
//     ) {
//       alert("Speech-to-text is not supported in this browser.");
//       return;
//     }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!recognitionRef.current) {
//       const recognition = new SpeechRecognition();
//       recognition.lang = "en-US";
//       recognition.interimResults = true;
//       recognition.continuous = true;

//       recognition.onstart = () => setIsRecording(true);

//       recognition.onresult = (event) => {
//         const mainDiv = mainEditableRef.current; // Main contentEditable div
//         const selection = window.getSelection();
//         const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

//         for (let i = event.resultIndex; i < event.results.length; i++) {
//           const transcript = event.results[i][0].transcript;

//           if (event.results[i].isFinal) {
//             const textNode = document.createTextNode(transcript + " ");
//             if (range) {
//               range.deleteContents();
//               range.insertNode(textNode);
//               range.setStartAfter(textNode);
//               range.setEndAfter(textNode);
//               selection.removeAllRanges();
//               selection.addRange(range);
//             } else {
//               mainDiv.appendChild(textNode);
//             }
//             handleInput("main"); // Update state after inserting speech text
//           }
//         }
//       };

//       recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error);
//         setIsRecording(false);
//       };

//       recognition.onend = () => setIsRecording(false);

//       recognitionRef.current = recognition;
//     }

//     recognitionRef.current.start();
//   };

//   const stopSpeechToText = () => {
//     if (recognitionRef.current) {
//       recognitionRef.current.stop();
//       setIsRecording(false);
//     }
//   };
//   const toggleSpeechToText = () => {
//     if (isRecording) {
//       stopSpeechToText();
//     } else {
//       startSpeechToText();
//     }
//   };
//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const img = document.createElement("img");
//         img.src = event.target.result;
//         img.alt = file.name || "selected-image";
//         img.classList.add("inserted-image"); // Add the CSS class

//         // Insert image at the current cursor position
//         const selection = window.getSelection();
//         const range = selection.getRangeAt(0);
//         range.deleteContents();
//         range.insertNode(img);

//         handleInput();
//       };
//       reader.readAsDataURL(file);
//     }
//   };
//   const handlePaste = (e, id = "main") => {
//     e.preventDefault();
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const items = e.clipboardData.items;

//     for (let item of items) {
//       if (item.type.startsWith("image/")) {
//         const blob = item.getAsFile();
//         const imageId = images.length + 1; // Assign serial number
//         const imageName = blob.name || `pasted-image-${imageId}`;

//         // Create a placeholder text for the image
//         const placeholderText = `[${imageId}_${imageName}]`;

//         // Insert placeholder text in the editable div
//         document.execCommand("insertText", false, placeholderText);

//         // Read and store the actual image for rendering
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImages((prevImages) => [
//             ...prevImages,
//             { id: imageId, src: event.target.result, alt: imageName },
//           ]);
//         };
//         reader.readAsDataURL(blob);

//         handleInput(id);
//       } else if (item.type === "text/plain") {
//         const text = e.clipboardData.getData("text/plain");
//         document.execCommand("insertText", false, text);
//         handleInput(id);
//       }
//     }
//   };

//   useEffect(() => {
//     refs.current = options.map((_, i) => refs.current[i] || React.createRef());
//     fileInputRefs.current = options.map(
//       (_, i) => fileInputRefs.current[i] || React.createRef()
//     );
//   }, [options]);
//   const handleFocus = (id) => {
//     setFocusedOption(id);
//     const focusedContent =
//       id === "main"
//         ? content
//         : options.find((option) => option.id === id)?.content || "";
//     setRenderHtml(renderLatexToHTML(focusedContent));
//   };

//   const addNewOption = () => {
//     setOptions((prevOptions) => [
//       ...prevOptions,
//       { id: prevOptions.length + 1, content: "" },
//     ]);
//   };

//   const handleLatexChange = (newLatex) => {
//     setLatex(newLatex);
//   };

//   const sendToTextBox = () => {
//     const mathLatex = `\\(${latex}\\)`;
//     const textNode = document.createTextNode(mathLatex);

//     contentEditableRef.current.appendChild(textNode);
//     setShowModal(false);
//     handleInput();
//   };
//   const fileInputRefs = useRef([]); // File input refs for each option
//   const renderActionButtons = (index, id) => {
//     return (
//       focusedOption === id && (
//         <>
//           {/* Formula Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "110px",
//               cursor: "pointer",
//             }}
//             onClick={() => setShowModal(true)}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>

//           {/* Image Upload Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "70px",
//               cursor: "pointer",
//             }}
//             onClick={() => fileInputRefs.current[index].click()}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image Icon"
//             />
//             <input
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[index] = el)}
//               style={{ display: "none" }}
//               onChange={(e) => handleFileSelect(e, id)}
//             />
//           </div>

//           {/* Recording Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "30px",
//               cursor: "pointer",
//             }}
//             onClick={() => toggleSpeechToText(id)}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//                 animation: isRecording ? "blink 1s infinite" : "none",
//               }}
//               src={isRecording ? RecordingActive : RecordingStatic}
//               alt="Recording Icon"
//             />
//           </div>
//         </>
//       )
//     );
//   };
//   // const renderOptions = () => {
//   //   switch (questionType) {
//   //     case "single-select":
//   //       return options.map((option, index) => (
//   //         <div
//   //           key={option.id}
//   //           style={{
//   //             display: "flex",
//   //             alignItems: "center",
//   //             marginBottom: "10px",
//   //             position: "relative",
//   //           }}
//   //           onFocus={() => setFocusedOption(option.id)}
//   //           onBlur={() => setFocusedOption(null)}
//   //           tabIndex={0}
//   //         >
//   //           <input
//   //             type="radio"
//   //             name="single-select"
//   //             checked={checkedOptions[index]} // Use checkedOptions to manage state
//   //             onChange={() => {
//   //               // Set all options to false and the selected option to true
//   //               setCheckedOptions((prev) => prev.map((_, i) => i === index));
//   //             }}
//   //             style={{ marginRight: "10px" }}
//   //           />
//   //           <div
//   //             contentEditable
//   //             ref={refs.current[index]}
//   //             suppressContentEditableWarning
//   //             onInput={() => handleInput(option.id)}
//   //             onPaste={(e) => handlePaste(e, option.id)}
//   //             style={{
//   //               border: "1px solid #ccc",
//   //               width: "100%",
//   //               backgroundColor: "white",
//   //               paddingTop: "22px",
//   //               paddingBottom: "10px",
//   //               paddingLeft: "10px",
//   //             }}
//   //           ></div>
//   //           {renderActionButtons(index, option.id)}
//   //         </div>
//   //       ));
//   //     case "multi-select":
//   //       return options.map((option, index) => (
//   //         <div
//   //           key={option.id}
//   //           style={{
//   //             display: "flex",
//   //             alignItems: "center",
//   //             marginBottom: "10px",
//   //             position: "relative",
//   //           }}
//   //           onFocus={() => setFocusedOption(option.id)}
//   //           onBlur={() => setFocusedOption(null)}
//   //           tabIndex={0}
//   //         >
//   //           <input
//   //             type="checkbox"
//   //             style={{ marginRight: "10px" }}
//   //             checked={checkedOptions[index]} // Use checkedOptions to manage state
//   //             onChange={() => {
//   //               // Toggle the checked state of the current option
//   //               setCheckedOptions((prev) =>
//   //                 prev.map((checked, i) => (i === index ? !checked : checked))
//   //               );
//   //             }}
//   //           />
//   //           <input
//   //             type="number"
//   //             placeholder="Weight"
//   //             style={{
//   //               marginRight: "10px",
//   //               width: "60px",
//   //               border: "1px solid #ccc",
//   //               padding: "5px",
//   //             }}
//   //           />
//   //           <div
//   //             contentEditable
//   //             ref={refs.current[index]}
//   //             suppressContentEditableWarning
//   //             onInput={() => handleInput(option.id)}
//   //             onPaste={(e) => handlePaste(e, option.id)}
//   //             style={{
//   //               border: "1px solid #ccc",
//   //               width: "100%",
//   //               backgroundColor: "white",
//   //               paddingTop: "22px",
//   //               paddingBottom: "10px",
//   //               paddingLeft: "10px",
//   //             }}
//   //           ></div>
//   //           {renderActionButtons(index, option.id)}
//   //         </div>
//   //       ));
//   //     case "fill-in-blanks":
//   //       return (
//   //         <div
//   //           style={{ position: "relative" }}
//   //           onFocus={() => setFocusedOption("fill-in-blank")}
//   //           onBlur={() => setFocusedOption(null)}
//   //           tabIndex={0}
//   //         >
//   //           <div
//   //             contentEditable
//   //             ref={refs.current[0]}
//   //             suppressContentEditableWarning
//   //             onFocus={() => setFocusedOption(1)}
//   //             onBlur={() => setFocusedOption(null)}
//   //             onInput={() => handleInput(1)}
//   //             onPaste={(e) => handlePaste(e, 1)}
//   //             style={{
//   //               border: "1px solid #ccc",
//   //               minHeight: "50px",
//   //               backgroundColor: "white",
//   //               paddingTop: "22px",
//   //               paddingBottom: "10px",
//   //               paddingLeft: "10px",
//   //             }}
//   //           ></div>
//   //           {renderActionButtons(0, "fill-in-blank")}
//   //         </div>
//   //       );
//   //     case "boolean":
//   //       return (
//   //         <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//   //           <label style={{ display: "flex", justifyContent: "center" }}>
//   //             <input type="radio" name="boolean" value="true" />
//   //             <p style={{ marginLeft: "10px", marginTop: "2px" }}>True </p>
//   //           </label>
//   //           <label style={{ display: "flex", justifyContent: "center" }}>
//   //             <input type="radio" name="boolean" value="false" />
//   //             <p style={{ marginLeft: "10px", marginTop: "2px" }}>False </p>
//   //           </label>
//   //         </div>
//   //       );
//   //     default:
//   //       return null;
//   //   }
//   // };

//   const renderOptions = () => {
//     switch (questionType) {
//       case "single-select":
//       // return option.map((opt, index) => (
//       //   <div
//       //     key={opt.option_no}
//       //     style={{
//       //       display: "flex",
//       //       alignItems: "center",
//       //       marginBottom: "10px",
//       //       position: "relative",
//       //     }}
//       //   >
//       //     <input
//       //       type="radio"
//       //       name="single-select"
//       //       checked={checkedOptions[index]}
//       //       onChange={() => {
//       //         setCheckedOptions((prev) => prev.map((_, i) => i === index));
//       //       }}
//       //       style={{ marginRight: "10px" }}
//       //     />
//       //     <div
//       //       dangerouslySetInnerHTML={{
//       //         __html: renderLatexToHTML(opt.option_text),
//       //       }}
//       //       style={{
//       //         border: "1px solid #ccc",
//       //         padding: "10px",
//       //         backgroundColor: "white",
//       //         width: "100%",
//       //       }}
//       //     ></div>
//       //   </div>
//       // ));
//       case "multi-select":
//         return option.map((opt, index) => (
//           <div
//             key={opt.option_no}
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginBottom: "10px",
//               position: "relative",
//             }}
//           >
//             <input
//               type="checkbox"
//               checked={checkedOptions[index]}
//               onChange={() => handleCheckboxChange(index)}
//               style={{ marginRight: "10px" }}
//             />
//             <input
//               type="number"
//               placeholder="Weight"
//               style={{
//                 marginRight: "10px",
//                 width: "60px",
//                 border: "1px solid #ccc",
//                 padding: "5px",
//               }}
//             />
//             <div
//               dangerouslySetInnerHTML={{
//                 __html: renderLatexToHTML(opt.option_text),
//               }}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: "10px",
//                 backgroundColor: "white",
//                 width: "100%",
//               }}
//             ></div>
//           </div>
//         ));
//       case "fill-in-blanks":
//         return (
//           <div>
//             <p>Fill in the blanks question. Please provide the answer.</p>
//             <input
//               type="text"
//               placeholder="Your Answer"
//               style={{
//                 width: "100%",
//                 padding: "10px",
//                 border: "1px solid #ccc",
//               }}
//             />
//           </div>
//         );
//       case "boolean":
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="true" />
//               <span style={{ marginLeft: "10px" }}>True</span>
//             </label>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="false" />
//               <span style={{ marginLeft: "10px" }}>False</span>
//             </label>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   const [checkedOptions, setCheckedOptions] = useState(
//     new Array(options.length).fill(false)
//   );

//   // Handle checkbox change
//   const handleCheckboxChange = (index) => {
//     setCheckedOptions((prevChecked) =>
//       prevChecked.map((checked, i) => (i === index ? !checked : checked))
//     );
//   };

//   useEffect(() => {
//     // Map question type to numeric value
//     const typeMapping = {
//       "single-select": 1,
//       "multi-select": 2,
//       "fill-in-blanks": 3,
//       boolean: 4,
//     };
//     setQuestionTypeValue(typeMapping[questionType]);
//   }, [questionType]);

//   const handleSubmit = async () => {
//     // Prepare options for the API payload
//     const optionsPayload = options.map((option, index) => ({
//       parse_ques_set_option_id: null,
//       parse_ques_set_id: null,
//       parse_ques_set_question_id: null,
//       parse_ques_option_no: index + 1,
//       parse_ques_option_bool_type: 1, // Example: Update based on actual use case
//       parse_ques_option_text: option.content,
//       parse_ques_option_correct_flag: checkedOptions[index] ? 1 : 0, // Set flag based on checkbox
//       parse_ques_option_weightage: 0,
//     }));

//     const questionText = mainEditableRef.current?.textContent?.trim() || "";

//     // Prepare the API payload
//     const payload = {
//       parse_ques_set_options_list: optionsPayload,
//       parse_ques_tagging_list: [
//         {
//           parse_ques_set_id: null,
//           parse_ques_set_question_id: null,
//           parse_ques_tag_id: 2,
//           parse_ques_tag_value_id: 1,
//         },
//       ],
//     };

//     try {
//       const response = await fetch(
//         `https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/post-parse-question-manual?parse_ques_set_name=viraj%20set%201%20New&client_id=1&client_branch_id=1&username=viraj&parse_ques_set_ques_no=${questionCounter}&parse_ques_set_ques_type=${questionTypeValue}&question_text=${questionText}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             accept: "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       if (response.ok) {
//         const result = await response.json();
//         console.log("API response:", result);
//         alert("Question submitted successfully!");
//       } else {
//         console.error("Failed to submit question", response.statusText);
//         alert("Failed to submit question.");
//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//       alert("An error occurred while submitting the question.");
//     }
//   };

//   useEffect(() => {
//     if (hasCounterChanged) {
//       handleSubmit(); // Trigger API call only if the counter changes due to user action
//     } else {
//       setHasCounterChanged(true); // Mark the initial render
//     }
//   }, [questionCounter]);

//   useEffect(() => {
//     if (questionText !== content) {
//       setContent(questionText);
//     }
//   }, [questionText]);

//   const processText = (text) => {
//     // Replace imgsrc with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     // Render LaTeX expressions
//     const latexRegex = /\\\((.*?)\\\)/g;
//     text = text.replace(latexRegex, (match, p1) => {
//       return katex.renderToString(p1, { throwOnError: false });
//     });

//     return text;
//   };
//   return (
//     <div style={{ position: "relative", width, height }}>
//       <div style={{ display: "flex", width: "100%", gap: "20px" }}>
//         {/* Left Section */}
//         <div style={{ width: "50%" }}>
//           {/* Main editable div */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginTop: "15px",
//               color: "#2F2E40",
//               marginBottom: "20px",
//             }}
//           >
//             <label>Type:</label>
//             {/* <input
//               type="radio"
//               value="single-select"
//               checked={questionType === "single-select"}
//               onChange={() => setQuestionType("single-select")}
//               style={{ marginLeft: "10px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Single Select</label> */}
//             <input
//               type="radio"
//               value="multi-select"
//               checked={questionType === "multi-select"}
//               onChange={() => setQuestionType("multi-select")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Multi Select</label>
//             <input
//               type="radio"
//               value="fill-in-blanks"
//               checked={questionType === "fill-in-blanks"}
//               onChange={() => setQuestionType("fill-in-blanks")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Fill-In Blanks</label>
//             <input
//               type="radio"
//               value="boolean"
//               checked={questionType === "boolean"}
//               onChange={() => setQuestionType("boolean")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Boolean</label>
//           </div>

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text <span style={{ color: "red" }}>*</span>
//           </p>
//           <div style={{ position: "relative" }}>
//             {/* Main ContentEditable Div */}
//             <div
//               contentEditable
//               ref={mainEditableRef}
//               onFocus={() => setFocusedOption("main")}
//               onBlur={() => setFocusedOption(null)}
//               onInput={() => handleInput("main")}
//               onPaste={(e) => handlePaste(e, "main")}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: "10px",
//                 marginBottom: "20px",
//                 minHeight: "100px",
//                 backgroundColor: "white",
//                 paddingTop: "22px",
//                 paddingLeft: "10px",
//                 paddingBottom: "10px",
//               }}
//               dangerouslySetInnerHTML={{ __html: processText(content) }}
//             ></div>

//             {/* Formula Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "110px",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowModal(true)}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt="Formula"
//               />
//             </div>

//             {/* Image Upload Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "70px",
//                 cursor: "pointer",
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt="Image Icon"
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileSelect(e, "main")}
//               />
//             </div>

//             {/* Recording Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "30px",
//                 cursor: "pointer",
//               }}
//               onClick={() => toggleSpeechToText("main")}
//             >
//               <img
//                 style={{
//                   height: "18px",
//                   width: "17px",
//                   animation: isRecording ? "blink 1s infinite" : "none",
//                 }}
//                 src={isRecording ? RecordingActive : RecordingStatic}
//                 alt="Recording Icon"
//               />
//             </div>
//           </div>

//           {/* Additional buttons */}
//           {renderOptions()}
//         </div>

//         {/* Right Section */}
//         <div
//           style={{
//             width: "50%",
//             border: "1px solid #ccc",
//             padding: "10px",
//             backgroundColor: "white",
//             minHeight: "100px",
//             whiteSpace: "pre-wrap",
//             marginTop: "81px",
//           }}
//         >
//           <div>
//             <strong style={{ paddingBottom: "15px", paddingTop: "8px" }}>
//               Question:
//             </strong>
//             <div
//               style={{ paddingBottom: "8px" }}
//               dangerouslySetInnerHTML={{
//                 // __html: renderLatexToHTML(content),
//                 __html: processText(content),

//               }}
//             ></div>
//           </div>
//           {options.map((option, index) => (
//             <div key={option.id}>
//               <strong style={{ paddingBottom: "8px" }}>
//                 Option {index + 1}:
//               </strong>
//               <div
//                 style={{ paddingBottom: "8px" }}
//                 dangerouslySetInnerHTML={{
//                   // __html: renderLatexToHTML(option.content),
//                   __html: processText(option.content),

//                 }}
//               ></div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <Modal show={showModal} onClose={() => setShowModal(false)}>
//         <h2>MathLive Input</h2>
//         <MathLive onLatexChange={handleLatexChange} />
//         <button
//           onClick={sendToTextBox}
//           style={{ marginTop: "10px", cursor: "pointer" }}
//         >
//           Send to Text Box
//         </button>
//       </Modal>
//     </div>
//   );
// };

// export default TextboxWithImageSecond;

/////////was working last properly without image converter
// import React, { useState, useRef, useEffect } from "react";
// import Modal from "../../POP/Modal"; // Import the modal component
// import MathLive from "../../POP/FileComp7"; // Import MathLive component
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
// import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
// const TextboxWithImageSecond = ({
//   width = "100%",
//   height = "auto",
//   htmlContent,
//   questionCounter,
//   currentQuestion,
//   questionText,
//   optionFromAnotherPage,
//   quesType,
// }) => {
//   // console.log("option", optionFromAnotherPage);
//   // console.log("questionText", questionText);
//   // console.log("current question type ", quesType);
//   const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
//   const recognitionRef = useRef(null); // Ref for the speech recognition object
//   const contentEditableRef = useRef(null);
//   const [images, setImages] = useState([]); // Stores actual image files
//   const [showModal, setShowModal] = useState(false); // Modal state
//   const [latex, setLatex] = useState(""); // MathLive LaTeX content state
//   // const [content, setContent] = useState(htmlContent || "");
//   const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
//   const [isClicked, setIsClicked] = useState(false);
//   const fileInputRef = useRef(null); // Ref for the hidden file input
//   const [questionType, setQuestionType] = useState("multi-select"); // Tracks question type0
//   const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
//   const [hasCounterChanged, setHasCounterChanged] = useState(false);

//   const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)
//   const [initialOptions, setInitialOptions] = useState([]); // Store the initial options
//   const [content, setContent] = useState(htmlContent || "");

//   // const [options, setOptions] = useState([
//   //   { id: 1, content: "" },
//   //   { id: 2, content: "" },
//   //   { id: 3, content: "" },
//   //   { id: 4, content: "" },
//   // ]); // Editable options
//   const [editableOptions, setEditableOptions] = useState([
//     { id: 1, content: "" },
//     { id: 2, content: "" },
//     { id: 3, content: "" },
//     { id: 4, content: "" },
//   ]);

//   const mainEditableRef = useRef(null);
//   const refs = useRef([]); // Refs for all editable options
//   // const [content, setContent] = useState(questionText || "");
//   // const [editableOptions, setEditableOptions] = useState(
//   //   options.map((option, index) => ({
//   //     id: index + 1,
//   //     content: option.option_text,
//   //   }))
//   // );
//   useEffect(() => {
//     if (optionFromAnotherPage && optionFromAnotherPage.length > 0) {
//       // Save initial options
//       setInitialOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           ...opt,
//           id: opt.id || index + 1,
//         }))
//       );

//       // Create editable options
//       setEditableOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           id: opt.id || index + 1,
//           content: opt.option_text || "",
//         }))
//       );
//     }
//   }, [optionFromAnotherPage]);

//   // Populate refs dynamically for all options
//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   useEffect(() => {
//     if (htmlContent !== content) {
//       setContent(htmlContent);
//     }
//   }, [htmlContent]);
//   const renderLatexToHTML = (text) => {
//     try {
//       let html = text;

//       // Replace LaTeX
//       html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//           displayMode: true,
//         })
//       );

//       html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//         })
//       );

//       // Replace image placeholders with actual images
//       images.forEach((image) => {
//         const placeholder = `[${image.id}_${image.alt}]`;
//         const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
//         html = html.replace(placeholder, imgTag);
//       });

//       return html;
//     } catch (error) {
//       console.error("Error rendering HTML:", error);
//       return text;
//     }
//   };

//   const handleInput = (id = "main") => {
//     const ref =
//       id === "main"
//         ? mainEditableRef.current
//         : refs.current.find((r, i) => i + 1 === id)?.current;

//     if (!ref) {
//       console.warn(`No ref found for id: ${id}`);
//       return;
//     }

//     // Save current selection (cursor position)
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Update content state
//     const contentHTML = ref.innerHTML.trim();
//     if (id === "main") {
//       console.log("questionEditing");
//       setContent(contentHTML);
//     } else {
//       console.log("optEditing", id);
//       setEditableOptions((prevOptions) =>
//         prevOptions.map((option) =>
//           option.id === id ? { ...option, content: contentHTML } : option
//         )
//       );
//     }

//     // Restore cursor position after the DOM updates
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function setCursor(node) {
//         if (node.nodeType === 3) {
//           // Text node
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (setCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }
//       setCursor(ref);
//     }, 0);
//   };

//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   // const handleInput = (id = "main") => {
//   //   const ref =
//   //     id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;

//   //   if (!ref) return;

//   //   // Save current selection (cursor position)
//   //   const selection = window.getSelection();
//   //   const range = selection.getRangeAt(0);
//   //   const preCaretRange = range.cloneRange();
//   //   preCaretRange.selectNodeContents(ref);
//   //   preCaretRange.setEnd(range.endContainer, range.endOffset);
//   //   const cursorPosition = preCaretRange.toString().length;

//   //   // Update content state
//   //   const contentHTML = ref.innerHTML;
//   //   if (id === "main") {
//   //     console.log("questionEditing");
//   //     setContent(contentHTML.trim());
//   //   } else {
//   //     console.log("optEditing");
//   //     setEditableOptions((prevOptions) =>
//   //       prevOptions.map((option) =>
//   //         option.id === id ? { ...option, content: contentHTML.trim() } : option
//   //       )
//   //     );
//   //   }

//   //   // Restore cursor position after the DOM updates
//   //   setTimeout(() => {
//   //     const newRange = document.createRange();
//   //     const newSelection = window.getSelection();
//   //     let charCount = 0;

//   //     function setCursor(node) {
//   //       if (node.nodeType === 3) {
//   //         // Text node
//   //         const nextCharCount = charCount + node.length;
//   //         if (cursorPosition <= nextCharCount) {
//   //           newRange.setStart(node, cursorPosition - charCount);
//   //           newRange.collapse(true);
//   //           newSelection.removeAllRanges();
//   //           newSelection.addRange(newRange);
//   //           return true;
//   //         }
//   //         charCount = nextCharCount;
//   //       } else {
//   //         for (let i = 0; i < node.childNodes.length; i++) {
//   //           if (setCursor(node.childNodes[i])) return true;
//   //         }
//   //       }
//   //       return false;
//   //     }
//   //     setCursor(ref);
//   //   }, 0);
//   // };

//   const startSpeechToText = () => {
//     if (
//       !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
//     ) {
//       alert("Speech-to-text is not supported in this browser.");
//       return;
//     }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!recognitionRef.current) {
//       const recognition = new SpeechRecognition();
//       recognition.lang = "en-US";
//       recognition.interimResults = true;
//       recognition.continuous = true;

//       recognition.onstart = () => setIsRecording(true);

//       recognition.onresult = (event) => {
//         const mainDiv = mainEditableRef.current; // Main contentEditable div
//         const selection = window.getSelection();
//         const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

//         for (let i = event.resultIndex; i < event.results.length; i++) {
//           const transcript = event.results[i][0].transcript;

//           if (event.results[i].isFinal) {
//             const textNode = document.createTextNode(transcript + " ");
//             if (range) {
//               range.deleteContents();
//               range.insertNode(textNode);
//               range.setStartAfter(textNode);
//               range.setEndAfter(textNode);
//               selection.removeAllRanges();
//               selection.addRange(range);
//             } else {
//               mainDiv.appendChild(textNode);
//             }
//             handleInput("main"); // Update state after inserting speech text
//           }
//         }
//       };

//       recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error);
//         setIsRecording(false);
//       };

//       recognition.onend = () => setIsRecording(false);

//       recognitionRef.current = recognition;
//     }

//     recognitionRef.current.start();
//   };

//   const stopSpeechToText = () => {
//     if (recognitionRef.current) {
//       recognitionRef.current.stop();
//       setIsRecording(false);
//     }
//   };
//   const toggleSpeechToText = () => {
//     if (isRecording) {
//       stopSpeechToText();
//     } else {
//       startSpeechToText();
//     }
//   };
//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const img = document.createElement("img");
//         img.src = event.target.result;
//         img.alt = file.name || "selected-image";
//         img.classList.add("inserted-image"); // Add the CSS class

//         // Insert image at the current cursor position
//         const selection = window.getSelection();
//         const range = selection.getRangeAt(0);
//         range.deleteContents();
//         range.insertNode(img);

//         handleInput();
//       };
//       reader.readAsDataURL(file);
//     }
//   };
//   const handlePaste = (e, id = "main") => {
//     e.preventDefault();
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const items = e.clipboardData.items;

//     for (let item of items) {
//       if (item.type.startsWith("image/")) {
//         const blob = item.getAsFile();
//         const imageId = images.length + 1; // Assign serial number
//         const imageName = blob.name || `pasted-image-${imageId}`;

//         // Create a placeholder text for the image
//         const placeholderText = `[${imageId}_${imageName}]`;

//         // Insert placeholder text in the editable div
//         document.execCommand("insertText", false, placeholderText);

//         // Read and store the actual image for rendering
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImages((prevImages) => [
//             ...prevImages,
//             { id: imageId, src: event.target.result, alt: imageName },
//           ]);
//         };
//         reader.readAsDataURL(blob);

//         handleInput(id);
//       } else if (item.type === "text/plain") {
//         const text = e.clipboardData.getData("text/plain");
//         document.execCommand("insertText", false, text);
//         handleInput(id);
//       }
//     }
//   };

//   // useEffect(() => {
//   //   refs.current = options.map((_, i) => refs.current[i] || React.createRef());
//   //   fileInputRefs.current = options.map(
//   //     (_, i) => fileInputRefs.current[i] || React.createRef()
//   //   );
//   // }, [options]);
//   // const handleFocus = (id) => {
//   //   setFocusedOption(id);
//   //   const focusedContent =
//   //     id === "main"
//   //       ? content
//   //       : options.find((option) => option.id === id)?.content || "";
//   //   setRenderHtml(renderLatexToHTML(focusedContent));
//   // };

//   // const addNewOption = () => {
//   //   setOptions((prevOptions) => [
//   //     ...prevOptions,
//   //     { id: prevOptions.length + 1, content: "" },
//   //   ]);
//   // };

//   const handleLatexChange = (newLatex) => {
//     setLatex(newLatex);
//   };

//   const sendToTextBox = () => {
//     const mathLatex = `\\(${latex}\\)`;
//     const textNode = document.createTextNode(mathLatex);

//     contentEditableRef.current.appendChild(textNode);
//     setShowModal(false);
//     handleInput();
//   };
//   // useEffect(() => {
//   //   if (optionFromAnotherPage && optionFromAnotherPage.length > 0) {
//   //     setOptions(
//   //       optionFromAnotherPage.map((opt, index) => ({
//   //         id: opt.id || index + 1,
//   //         content: opt.option_text,
//   //       }))
//   //     );
//   //   }
//   // }, [optionFromAnotherPage]);

//   const fileInputRefs = useRef([]); // File input refs for each option
//   const renderActionButtons = (index, id) => {
//     return (
//       focusedOption === id && (
//         <>
//           {/* Formula Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "110px",
//               cursor: "pointer",
//             }}
//             onClick={() => setShowModal(true)}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>

//           {/* Image Upload Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "70px",
//               cursor: "pointer",
//             }}
//             onClick={() => fileInputRefs.current[index].click()}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image Icon"
//             />
//             <input
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[index] = el)}
//               style={{ display: "none" }}
//               onChange={(e) => handleFileSelect(e, id)}
//             />
//           </div>

//           {/* Recording Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "30px",
//               cursor: "pointer",
//             }}
//             onClick={() => toggleSpeechToText(id)}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//                 animation: isRecording ? "blink 1s infinite" : "none",
//               }}
//               src={isRecording ? RecordingActive : RecordingStatic}
//               alt="Recording Icon"
//             />
//           </div>
//         </>
//       )
//     );
//   };

//   // const handleOptionEdit = (index, newContent) => {
//   //   setEditableOptions((prevOptions) =>
//   //     prevOptions.map((option, i) =>
//   //       i === index ? { ...option, content: newContent } : option
//   //     )
//   //   );
//   // };

//   // const handleOptionInput = (index) => {
//   //   const ref = refs.current[index]?.current; // Get the current editable div reference
//   //   if (!ref) return;

//   //   // Save cursor position
//   //   const selection = window.getSelection();
//   //   const range = selection.getRangeAt(0);
//   //   const preCaretRange = range.cloneRange();
//   //   preCaretRange.selectNodeContents(ref);
//   //   preCaretRange.setEnd(range.endContainer, range.endOffset);
//   //   const cursorPosition = preCaretRange.toString().length;

//   //   // Get current content from the editable div
//   //   const contentHTML = ref.innerHTML.trim(); // Get the updated content

//   //   // Update editableOptions state dynamically
//   //   // setEditableOptions((prevOptions) => {
//   //   //   const updatedOptions = prevOptions.map((editableOption, i) =>
//   //   //     i === index
//   //   //       ? { ...editableOption, content: contentHTML.trim() }
//   //   //       : editableOption
//   //   //   );

//   //   //   // Avoid re-render if content didn't change
//   //   //   if (prevOptions[index].content === contentHTML.trim()) return prevOptions;
//   //   //   return updatedOptions;
//   //   // });

//   //   setEditableOptions((prevOptions) =>
//   //     prevOptions.map((opt, i) =>
//   //       i === index ? { ...opt, content: contentHTML } : opt
//   //     )
//   //   );

//   //   // Restore cursor position after DOM update
//   //   setTimeout(() => {
//   //     const newRange = document.createRange();
//   //     const newSelection = window.getSelection();
//   //     let charCount = 0;

//   //     function restoreCursor(node) {
//   //       if (node.nodeType === 3) {
//   //         const nextCharCount = charCount + node.length;
//   //         if (cursorPosition <= nextCharCount) {
//   //           newRange.setStart(node, cursorPosition - charCount);
//   //           newRange.collapse(true);
//   //           newSelection.removeAllRanges();
//   //           newSelection.addRange(newRange);
//   //           return true;
//   //         }
//   //         charCount = nextCharCount;
//   //       } else {
//   //         for (let i = 0; i < node.childNodes.length; i++) {
//   //           if (restoreCursor(node.childNodes[i])) return true;
//   //         }
//   //       }
//   //       return false;
//   //     }

//   //     restoreCursor(ref);
//   //   }, 0);
//   // };
//   //  console.log(`Assigning ref for option ${index}`);
//   const renderOptions = () => {
//     switch (questionType) {
//       case "multi-select":
//         return editableOptions.map((opt, index) => (
//           <div
//             key={opt.id || index}
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginBottom: "10px",
//               position: "relative",
//             }}
//           >
//             <input
//               type="checkbox"
//               // checked={checkedOptions[index] || false}
//               // onChange={() => handleCheckboxChange(index)}
//               style={{ marginRight: "10px" }}
//             />

//             <input
//               type="number"
//               placeholder="Weight"
//               value={opt.weight || ""}
//               onChange={(e) =>
//                 setEditableOptions((prevOptions) =>
//                   prevOptions.map((o, i) =>
//                     i === index ? { ...o, weight: e.target.value } : o
//                   )
//                 )
//               }
//               style={{
//                 marginRight: "10px",
//                 width: "60px",
//                 border: "1px solid #ccc",
//                 padding: "5px",
//                 borderRadius: "4px",
//               }}
//             />

//             <div
//               contentEditable
//               ref={(el) => (refs.current[index] = { current: el })}
//               onInput={() => handleOptionInput(index)}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: "10px",
//                 minHeight: "40px",
//                 width: "100%",
//                 backgroundColor: "#fff",
//                 borderRadius: "5px",
//               }}
//               dangerouslySetInnerHTML={{
//                 __html: opt.content || "",
//               }}
//             ></div>

//             {renderActionButtons(index, opt.id)}
//           </div>
//         ));
//       case "fill-in-blanks":
//         return (
//           <div>
//             <p>Fill in the blanks question. Please provide the answer.</p>
//             <input
//               type="text"
//               placeholder="Your Answer"
//               style={{
//                 width: "100%",
//                 padding: "10px",
//                 border: "1px solid #ccc",
//               }}
//             />
//           </div>
//         );
//       case "boolean":
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="true" />
//               <span style={{ marginLeft: "10px" }}>True</span>
//             </label>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="false" />
//               <span style={{ marginLeft: "10px" }}>False</span>
//             </label>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   // const [checkedOptions, setCheckedOptions] = useState(
//   //   new Array(options.length).fill(false)
//   // );

//   // Handle checkbox change
//   // const handleCheckboxChange = (index) => {
//   //   setCheckedOptions((prevChecked) =>
//   //     prevChecked.map((checked, i) => (i === index ? !checked : checked))
//   //   );
//   // };

//   useEffect(() => {
//     // Map question type to numeric value
//     const typeMapping = {
//       "single-select": 1,
//       "multi-select": 2,
//       "fill-in-blanks": 3,
//       boolean: 4,
//     };
//     setQuestionTypeValue(typeMapping[questionType]);
//   }, [questionType]);

//   // const handleSubmit = async () => {
//   //   // Prepare options for the API payload
//   //   const optionsPayload = options.map((option, index) => ({
//   //     parse_ques_set_option_id: null,
//   //     parse_ques_set_id: null,
//   //     parse_ques_set_question_id: null,
//   //     parse_ques_option_no: index + 1,
//   //     parse_ques_option_bool_type: 1, // Example: Update based on actual use case
//   //     parse_ques_option_text: option.content,
//   //     parse_ques_option_correct_flag: checkedOptions[index] ? 1 : 0, // Set flag based on checkbox
//   //     parse_ques_option_weightage: 0,
//   //   }));

//   //   const questionText = mainEditableRef.current?.textContent?.trim() || "";

//   //   // Prepare the API payload
//   //   const payload = {
//   //     parse_ques_set_options_list: optionsPayload,
//   //     parse_ques_tagging_list: [
//   //       {
//   //         parse_ques_set_id: null,
//   //         parse_ques_set_question_id: null,
//   //         parse_ques_tag_id: 2,
//   //         parse_ques_tag_value_id: 1,
//   //       },
//   //     ],
//   //   };

//   //   try {
//   //     const response = await fetch(
//   //       `https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/post-parse-question-manual?parse_ques_set_name=viraj%20set%201%20New&client_id=1&client_branch_id=1&username=viraj&parse_ques_set_ques_no=${questionCounter}&parse_ques_set_ques_type=${questionTypeValue}&question_text=${questionText}`,
//   //       {
//   //         method: "POST",
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //           accept: "application/json",
//   //         },
//   //         body: JSON.stringify(payload),
//   //       }
//   //     );

//   //     if (response.ok) {
//   //       const result = await response.json();
//   //       console.log("API response:", result);
//   //       alert("Question submitted successfully!");
//   //     } else {
//   //       console.error("Failed to submit question", response.statusText);
//   //       alert("Failed to submit question.");
//   //     }
//   //   } catch (error) {
//   //     console.error("Error during API call:", error);
//   //     alert("An error occurred while submitting the question.");
//   //   }
//   // };

//   useEffect(() => {
//     if (hasCounterChanged) {
//       // handleSubmit(); // Trigger API call only if the counter changes due to user action
//     } else {
//       setHasCounterChanged(true); // Mark the initial render
//     }
//   }, [questionCounter]);

//   useEffect(() => {
//     if (questionText !== content) {
//       setContent(questionText);
//     }
//   }, [questionText]);

//   const processText = (text) => {
//     // Replace imgsrc with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     // Render LaTeX expressions
//     const latexRegex = /\\\((.*?)\\\)/g;
//     text = text.replace(latexRegex, (match, p1) => {
//       return katex.renderToString(p1, { throwOnError: false });
//     });

//     return text;
//   };
//   const processTextSecond = (text) => {
//     // Replace imgsrc with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     return text;
//   };
//   // const handleOptionContentUpdate = (index, newContent) => {
//   //   setEditableOptions((prevOptions) =>
//   //     prevOptions.map((option, i) =>
//   //       i === index ? { ...option, content: newContent } : option
//   //     )
//   //   );
//   // };

//   const handleOptionInput = (index) => {
//     console.log("Handling input for option:", index);

//     // Ensure the ref exists for the current option
//     const ref = refs.current[index]?.current;
//     if (!ref) {
//       console.warn(`No ref found for option at index: ${index}`);
//       return;
//     }

//     // Get the current content of the editable div

//     // Update the state for the editable option
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: contentHTML } : option
//       )
//     );

//     // Save cursor position
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Get current content from the editable div
//     const contentHTML = ref.innerHTML.trim();
//     console.log(`Content for option ${index}:`, contentHTML);

//     // Use the dedicated function to update editableOptions
//     handleOptionContentUpdate(index, contentHTML);

//     // Restore cursor position after DOM update
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function restoreCursor(node) {
//         if (node.nodeType === 3) {
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (restoreCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }

//       restoreCursor(ref);
//     }, 0);
//   };

//   const renderRightOptions = () => {
//     return editableOptions.map((opt, index) => (
//       <div
//         key={opt.id}
//         style={{
//           marginBottom: "10px",
//           padding: "10px",
//           border: "1px solid #ddd",
//         }}
//       >
//         <strong>Option {index + 1}:</strong>
//         <div
//           dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
//         ></div>
//       </div>
//     ));
//   };
//   const handleOptionContentUpdate = (index, newContent) => {
//     console.log(`Updating content for option ${index}:`, newContent);
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: newContent } : option
//       )
//     );
//   };

//   console.log(content + "contetn");
//   console.log(htmlContent + "htmlContent");
//   console.log("Editable Options:", JSON.stringify(editableOptions, null, 2));
//   useEffect(() => {
//     console.log("htmlContent updated:", htmlContent);
//     console.log("Editable options updated:", editableOptions);
//   }, [htmlContent, editableOptions]);
//   console.log("Refs after rendering:", refs.current);
//   useEffect(() => {
//     console.log("Updated editableOptions:", editableOptions);
//   }, [editableOptions]);
//   useEffect(() => {
//     console.log("Refs after rendering:", refs.current);
//   }, [editableOptions]);

//   return (
//     <div style={{ position: "relative", width, height }}>
//       <div style={{ display: "flex", width: "100%", gap: "20px" }}>
//         {/* Left Section */}
//         <div style={{ width: "50%" }}>
//           {/* Main editable div */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginTop: "15px",
//               color: "#2F2E40",
//               marginBottom: "20px",
//             }}
//           >
//             <label>Type:</label>
//             <input
//               type="radio"
//               value="multi-select"
//               checked={questionType === "multi-select"}
//               onChange={() => setQuestionType("multi-select")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Multi Select</label>
//             <input
//               type="radio"
//               value="fill-in-blanks"
//               checked={questionType === "fill-in-blanks"}
//               onChange={() => setQuestionType("fill-in-blanks")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Fill-In Blanks</label>
//             <input
//               type="radio"
//               value="boolean"
//               checked={questionType === "boolean"}
//               onChange={() => setQuestionType("boolean")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Boolean</label>
//           </div>

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text <span style={{ color: "red" }}>*</span>
//           </p>
//           <div style={{ position: "relative" }}>
//             {/* Main ContentEditable Div */}

//             <div
//               contentEditable
//               ref={mainEditableRef}
//               onFocus={() => setFocusedOption("main")}
//               onInput={() => handleInput("main")}
//               onPaste={(e) => handlePaste(e, "main")}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: "10px",
//                 marginBottom: "20px",
//                 minHeight: "100px",
//                 backgroundColor: "white",
//                 paddingTop: "22px",
//                 paddingLeft: "10px",
//                 paddingBottom: "10px",
//               }}
//               dangerouslySetInnerHTML={{ __html: processTextSecond(content) }}
//             ></div>

//             {/* Formula Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "110px",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowModal(true)}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt="Formula"
//               />
//             </div>

//             {/* Image Upload Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "70px",
//                 cursor: "pointer",
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt="Image Icon"
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileSelect(e, "main")}
//               />
//             </div>

//             {/* Recording Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "30px",
//                 cursor: "pointer",
//               }}
//               onClick={() => toggleSpeechToText("main")}
//             >
//               <img
//                 style={{
//                   height: "18px",
//                   width: "17px",
//                   animation: isRecording ? "blink 1s infinite" : "none",
//                 }}
//                 src={isRecording ? RecordingActive : RecordingStatic}
//                 alt="Recording Icon"
//               />
//             </div>
//           </div>

//           {/* Additional buttons */}
//           {renderOptions()}
//         </div>

//         {/* Right Section */}
//         <div
//           style={{
//             width: "50%",
//             border: "1px solid #ccc",
//             padding: "10px",
//             backgroundColor: "white",
//             minHeight: "100px",
//             whiteSpace: "pre-wrap",
//             marginTop: "81px",
//           }}
//         >
//           <div>
//             <strong style={{ paddingBottom: "15px", paddingTop: "8px" }}>
//               Question:
//             </strong>
//             <div
//               style={{ paddingBottom: "8px" }}
//               dangerouslySetInnerHTML={{
//                 // __html: renderLatexToHTML(content),
//                 __html: processText(content),
//               }}
//             ></div>
//           </div>

//           {/* {options.map((option, index) => {
//             console.log("Option being rendered:", option); // Check what's being passed

//             return (
//               <div key={option.id || index} style={{ marginBottom: "10px" }}>
//                 <strong style={{ display: "block", marginBottom: "5px" }}>
//                   Option {index + 1}:
//                 </strong>
//                 <div
//                   style={{
//                     padding: "10px",
//                     border: "1px solid #ccc",
//                     backgroundColor: "#f9f9f9",
//                     borderRadius: "5px",
//                   }}
//                   dangerouslySetInnerHTML={{
//                     __html: processText(
//                       option.content || "No option text available"
//                     ),
//                   }}
//                 ></div>
//               </div>
//             );
//           })} */}
//           <div>{renderRightOptions()}</div>
//         </div>
//       </div>

//       <Modal show={showModal} onClose={() => setShowModal(false)}>
//         <h2>MathLive Input</h2>
//         <MathLive onLatexChange={handleLatexChange} />
//         <button
//           onClick={sendToTextBox}
//           style={{ marginTop: "10px", cursor: "pointer" }}
//         >
//           Send to Text Box
//         </button>
//       </Modal>
//     </div>
//   );
// };

// export default React.memo(TextboxWithImageSecond);
/////////was working last properly without image converter

// import React, { useState, useRef, useEffect } from "react";
// // import Modal from "./Modal"; // Import the modal component
// import Modal from "../../POP/Modal";
// import MathLive from "../../POP/FileComp7"; // Import MathLive component
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
// import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
// const TextboxWithImage = ({
//   width = "100%",
//   height = "auto",
//   htmlContent,
//   questionCounter,
//   questionText,
//   optionFromAnotherPage,
//   quesType,
// }) => {
//   const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
//   const recognitionRef = useRef(null); // Ref for the speech recognition object
//   const contentEditableRef = useRef(null);
//   const [images, setImages] = useState([]); // Stores actual image files
//   const [showModal, setShowModal] = useState(false); // Modal state
//   const [latex, setLatex] = useState(""); // MathLive LaTeX content state
//   const [content, setContent] = useState(htmlContent || "");
//   const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
//   const [isClicked, setIsClicked] = useState(false);
//   const fileInputRef = useRef(null); // Ref for the hidden file input
//   const [questionType, setQuestionType] = useState("multi-select"); // Tracks question type0
//   const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
//   const [hasCounterChanged, setHasCounterChanged] = useState(false);

//   const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)
//   const [options, setOptions] = useState([
//     { id: 1, content: "" },
//     { id: 2, content: "" },
//     { id: 3, content: "" },
//     { id: 4, content: "" },
//   ]); // Editable options
//   const mainEditableRef = useRef(null);
//   const refs = useRef([]); // Refs for all editable options

//   // Populate refs dynamically for all options
//   useEffect(() => {
//     refs.current = options.map((_, i) => refs.current[i] || React.createRef());
//   }, [options]);

//   useEffect(() => {
//     if (htmlContent !== content) {
//       setContent(htmlContent);
//     }
//   }, [htmlContent]);
//   const renderLatexToHTML = (text) => {
//     try {
//       let html = text;

//       // Replace LaTeX
//       html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//           displayMode: true,
//         })
//       );

//       html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//         })
//       );

//       // Replace image placeholders with actual images
//       images.forEach((image) => {
//         const placeholder = `[${image.id}_${image.alt}]`;
//         const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
//         html = html.replace(placeholder, imgTag);
//       });

//       return html;
//     } catch (error) {
//       console.error("Error rendering HTML:", error);
//       return text;
//     }
//   };

//   const handleInput = (id = "main") => {
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const contentText = ref.textContent; // Only plain text, including placeholders

//     if (id === "main") {
//       setContent(contentText.trim());
//     } else {
//       setOptions((prevOptions) =>
//         prevOptions.map((option) =>
//           option.id === id ? { ...option, content: contentText.trim() } : option
//         )
//       );
//     }

//     if (focusedOption === id) {
//       setRenderHtml(renderLatexToHTML(contentText.trim()));
//     }
//   };

//   const startSpeechToText = () => {
//     if (
//       !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
//     ) {
//       alert("Speech-to-text is not supported in this browser.");
//       return;
//     }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!recognitionRef.current) {
//       const recognition = new SpeechRecognition();
//       recognition.lang = "en-US";
//       recognition.interimResults = true;
//       recognition.continuous = true;

//       recognition.onstart = () => setIsRecording(true);

//       recognition.onresult = (event) => {
//         const mainDiv = mainEditableRef.current; // Main contentEditable div
//         const selection = window.getSelection();
//         const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

//         for (let i = event.resultIndex; i < event.results.length; i++) {
//           const transcript = event.results[i][0].transcript;

//           if (event.results[i].isFinal) {
//             const textNode = document.createTextNode(transcript + " ");
//             if (range) {
//               range.deleteContents();
//               range.insertNode(textNode);
//               range.setStartAfter(textNode);
//               range.setEndAfter(textNode);
//               selection.removeAllRanges();
//               selection.addRange(range);
//             } else {
//               mainDiv.appendChild(textNode);
//             }
//             handleInput("main"); // Update state after inserting speech text
//           }
//         }
//       };

//       recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error);
//         setIsRecording(false);
//       };

//       recognition.onend = () => setIsRecording(false);

//       recognitionRef.current = recognition;
//     }

//     recognitionRef.current.start();
//   };

//   const stopSpeechToText = () => {
//     if (recognitionRef.current) {
//       recognitionRef.current.stop();
//       setIsRecording(false);
//     }
//   };
//   const toggleSpeechToText = () => {
//     if (isRecording) {
//       stopSpeechToText();
//     } else {
//       startSpeechToText();
//     }
//   };
//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const img = document.createElement("img");
//         img.src = event.target.result;
//         img.alt = file.name || "selected-image";
//         img.classList.add("inserted-image"); // Add the CSS class

//         // Insert image at the current cursor position
//         const selection = window.getSelection();
//         const range = selection.getRangeAt(0);
//         range.deleteContents();
//         range.insertNode(img);

//         handleInput();
//       };
//       reader.readAsDataURL(file);
//     }
//   };
//   const handlePaste = (e, id = "main") => {
//     e.preventDefault();
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const items = e.clipboardData.items;

//     for (let item of items) {
//       if (item.type.startsWith("image/")) {
//         const blob = item.getAsFile();
//         const imageId = images.length + 1; // Assign serial number
//         const imageName = blob.name || `pasted-image-${imageId}`;

//         // Create a placeholder text for the image
//         const placeholderText = `[${imageId}_${imageName}]`;

//         // Insert placeholder text in the editable div
//         document.execCommand("insertText", false, placeholderText);

//         // Read and store the actual image for rendering
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImages((prevImages) => [
//             ...prevImages,
//             { id: imageId, src: event.target.result, alt: imageName },
//           ]);
//         };
//         reader.readAsDataURL(blob);

//         handleInput(id);
//       } else if (item.type === "text/plain") {
//         const text = e.clipboardData.getData("text/plain");
//         document.execCommand("insertText", false, text);
//         handleInput(id);
//       }
//     }
//   };
//   useEffect(() => {
//     refs.current = options.map((_, i) => refs.current[i] || React.createRef());
//     fileInputRefs.current = options.map(
//       (_, i) => fileInputRefs.current[i] || React.createRef()
//     );
//   }, [options]);
//   const handleFocus = (id) => {
//     setFocusedOption(id);
//     const focusedContent =
//       id === "main"
//         ? content
//         : options.find((option) => option.id === id)?.content || "";
//     setRenderHtml(renderLatexToHTML(focusedContent));
//   };

//   const addNewOption = () => {
//     setOptions((prevOptions) => [
//       ...prevOptions,
//       { id: prevOptions.length + 1, content: "" },
//     ]);
//   };

//   const handleLatexChange = (newLatex) => {
//     setLatex(newLatex);
//   };

//   const sendToTextBox = () => {
//     const mathLatex = `\\(${latex}\\)`;
//     const textNode = document.createTextNode(mathLatex);

//     contentEditableRef.current.appendChild(textNode);
//     setShowModal(false);
//     handleInput();
//   };
//   const fileInputRefs = useRef([]); // File input refs for each option
//   const renderActionButtons = (index, id) => {
//     return (
//       focusedOption === id && (
//         <>
//           {/* Formula Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "110px",
//               cursor: "pointer",
//             }}
//             onClick={() => setShowModal(true)}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>

//           {/* Image Upload Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "70px",
//               cursor: "pointer",
//             }}
//             onClick={() => fileInputRefs.current[index].click()}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image Icon"
//             />
//             <input
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[index] = el)}
//               style={{ display: "none" }}
//               onChange={(e) => handleFileSelect(e, id)}
//             />
//           </div>

//           {/* Recording Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "30px",
//               cursor: "pointer",
//             }}
//             onClick={() => toggleSpeechToText(id)}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//                 animation: isRecording ? "blink 1s infinite" : "none",
//               }}
//               src={isRecording ? RecordingActive : RecordingStatic}
//               alt="Recording Icon"
//             />
//           </div>
//         </>
//       )
//     );
//   };
//   const renderOptions = () => {
//     switch (questionType) {
//       case "multi-select":
//         return options.map((option, index) => (
//           <div
//             key={option.id}
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginBottom: "10px",
//               position: "relative",
//             }}
//             onFocus={() => setFocusedOption(option.id)}
//             onBlur={() => setFocusedOption(null)}
//             tabIndex={0}
//           >
//             <input
//               type="checkbox"
//               style={{ marginRight: "10px" }}
//               checked={checkedOptions[index]} // Use checkedOptions to manage state
//               onChange={() => {
//                 // Toggle the checked state of the current option
//                 setCheckedOptions((prev) =>
//                   prev.map((checked, i) => (i === index ? !checked : checked))
//                 );
//               }}
//             />
//             <input
//               type="number"
//               placeholder="Weight"
//               style={{
//                 marginRight: "10px",
//                 width: "60px",
//                 border: "1px solid #ccc",
//                 padding: "5px",
//               }}
//             />
//             <div
//               contentEditable
//               ref={refs.current[index]}
//               suppressContentEditableWarning
//               onInput={() => handleInput(option.id)}
//               onPaste={(e) => handlePaste(e, option.id)}
//               style={{
//                 border: "1px solid #ccc",
//                 width: "100%",
//                 backgroundColor: "white",
//                 paddingTop: "22px",
//                 paddingBottom: "10px",
//                 paddingLeft: "10px",
//               }}
//             ></div>
//             {renderActionButtons(index, option.id)}
//           </div>
//         ));
//       case "fill-in-blanks":
//         return (
//           <div
//             style={{ position: "relative" }}
//             onFocus={() => setFocusedOption("fill-in-blank")}
//             onBlur={() => setFocusedOption(null)}
//             tabIndex={0}
//           >
//             <div
//               contentEditable
//               ref={refs.current[0]}
//               suppressContentEditableWarning
//               onFocus={() => setFocusedOption(1)}
//               onBlur={() => setFocusedOption(null)}
//               onInput={() => handleInput(1)}
//               onPaste={(e) => handlePaste(e, 1)}
//               style={{
//                 border: "1px solid #ccc",
//                 minHeight: "50px",
//                 backgroundColor: "white",
//                 paddingTop: "22px",
//                 paddingBottom: "10px",
//                 paddingLeft: "10px",
//               }}
//             ></div>
//             {renderActionButtons(0, "fill-in-blank")}
//           </div>
//         );
//       case "boolean":
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//             <label style={{ display: "flex", justifyContent: "center" }}>
//               <input type="radio" name="boolean" value="true" />
//               <p style={{ marginLeft: "10px", marginTop: "2px" }}>True </p>
//             </label>
//             <label style={{ display: "flex", justifyContent: "center" }}>
//               <input type="radio" name="boolean" value="false" />
//               <p style={{ marginLeft: "10px", marginTop: "2px" }}>False </p>
//             </label>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   const [checkedOptions, setCheckedOptions] = useState(
//     new Array(options.length).fill(false)
//   );

//   // Handle checkbox change
//   const handleCheckboxChange = (index) => {
//     setCheckedOptions((prevChecked) =>
//       prevChecked.map((checked, i) => (i === index ? !checked : checked))
//     );
//   };

//   useEffect(() => {
//     // Map question type to numeric value
//     const typeMapping = {
//       "single-select": 1,
//       "multi-select": 2,
//       "fill-in-blanks": 3,
//       boolean: 4,
//     };
//     setQuestionTypeValue(typeMapping[questionType]);
//   }, [questionType]);

//   const handleSubmit = async () => {
//     // Prepare options for the API payload
//     const optionsPayload = options.map((option, index) => ({
//       parse_ques_set_option_id: null,
//       parse_ques_set_id: null,
//       parse_ques_set_question_id: null,
//       parse_ques_option_no: index + 1,
//       parse_ques_option_bool_type: 1, // Example: Update based on actual use case
//       parse_ques_option_text: option.content,
//       parse_ques_option_correct_flag: checkedOptions[index] ? 1 : 0, // Set flag based on checkbox
//       parse_ques_option_weightage: 0,
//     }));

//     const questionText = mainEditableRef.current?.textContent?.trim() || "";

//     // Prepare the API payload
//     const payload = {
//       parse_ques_set_options_list: optionsPayload,
//       parse_ques_tagging_list: [
//         {
//           parse_ques_set_id: null,
//           parse_ques_set_question_id: null,
//           parse_ques_tag_id: 2,
//           parse_ques_tag_value_id: 1,
//         },
//       ],
//     };

//     try {
//       const response = await fetch(
//         `https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/post-parse-question-manual?parse_ques_set_name=viraj%20set%201%20New&client_id=1&client_branch_id=1&username=viraj&parse_ques_set_ques_no=${questionCounter}&parse_ques_set_ques_type=${questionTypeValue}&question_text=${questionText}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             accept: "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       if (response.ok) {
//         const result = await response.json();
//         console.log("API response:", result);
//         alert("Question submitted successfully!");
//       } else {
//         console.error("Failed to submit question", response.statusText);
//         alert("Failed to submit question.");
//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//       alert("An error occurred while submitting the question.");
//     }
//   };

//   useEffect(() => {
//     if (hasCounterChanged) {
//       handleSubmit(); // Trigger API call only if the counter changes due to user action
//     } else {
//       setHasCounterChanged(true); // Mark the initial render
//     }
//   }, [questionCounter]);

//   useEffect(() => {
//     if (mainEditableRef.current && questionText) {
//       mainEditableRef.current.innerHTML = questionText;
//     }
//   }, [questionText]);

//   return (
//     <div style={{ position: "relative", width, height }}>
//       <div style={{ display: "flex", width: "100%", gap: "20px" }}>
//         {/* Left Section */}
//         <div style={{ width: "50%" }}>
//           {/* Main editable div */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginTop: "15px",
//               color: "#2F2E40",
//               marginBottom: "20px",
//             }}
//           >
//             <label>Type:</label>
//             <input
//               type="radio"
//               value="multi-select"
//               checked={questionType === "multi-select"}
//               onChange={() => setQuestionType("multi-select")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Multi Select</label>
//             <input
//               type="radio"
//               value="fill-in-blanks"
//               checked={questionType === "fill-in-blanks"}
//               onChange={() => setQuestionType("fill-in-blanks")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Fill-In Blanks</label>
//             <input
//               type="radio"
//               value="boolean"
//               checked={questionType === "boolean"}
//               onChange={() => setQuestionType("boolean")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Boolean</label>
//           </div>

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text <span style={{ color: "red" }}>*</span>
//           </p>
//           <div style={{ position: "relative" }}>
//             {/* Main ContentEditable Div */}
//             <div
//               contentEditable
//               ref={mainEditableRef}
//               onFocus={() => setFocusedOption("main")}
//               onBlur={() => setFocusedOption(null)}
//               onInput={() => handleInput("main")}
//               onPaste={(e) => handlePaste(e, "main")}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: "10px",
//                 marginBottom: "20px",
//                 minHeight: "100px",
//                 backgroundColor: "white",
//                 paddingTop: "22px",
//                 paddingLeft: "10px",
//                 paddingBottom: "10px",
//               }}
//             ></div>

//             {/* Formula Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "110px",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowModal(true)}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt="Formula"
//               />
//             </div>

//             {/* Image Upload Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "70px",
//                 cursor: "pointer",
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt="Image Icon"
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileSelect(e, "main")}
//               />
//             </div>

//             {/* Recording Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "30px",
//                 cursor: "pointer",
//               }}
//               onClick={() => toggleSpeechToText("main")}
//             >
//               <img
//                 style={{
//                   height: "18px",
//                   width: "17px",
//                   animation: isRecording ? "blink 1s infinite" : "none",
//                 }}
//                 src={isRecording ? RecordingActive : RecordingStatic}
//                 alt="Recording Icon"
//               />
//             </div>
//           </div>

//           {/* Additional buttons */}
//           {renderOptions()}
//         </div>

//         {/* Right Section */}
//         <div
//           style={{
//             width: "50%",
//             border: "1px solid #ccc",
//             padding: "10px",
//             backgroundColor: "white",
//             minHeight: "100px",
//             whiteSpace: "pre-wrap",
//             marginTop: "81px",
//           }}
//         >
//           <div>
//             <strong style={{ paddingBottom: "15px", paddingTop: "8px" }}>
//               Question:
//             </strong>
//             <div
//               style={{ paddingBottom: "8px" }}
//               dangerouslySetInnerHTML={{
//                 __html: renderLatexToHTML(content),
//               }}
//             ></div>
//           </div>
//           {options.map((option, index) => (
//             <div key={option.id}>
//               <strong style={{ paddingBottom: "8px" }}>
//                 Option {index + 1}:
//               </strong>
//               <div
//                 style={{ paddingBottom: "8px" }}
//                 dangerouslySetInnerHTML={{
//                   __html: renderLatexToHTML(option.content),
//                 }}
//               ></div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <Modal show={showModal} onClose={() => setShowModal(false)}>
//         <h2>MathLive Input</h2>
//         <MathLive onLatexChange={handleLatexChange} />
//         <button
//           onClick={sendToTextBox}
//           style={{ marginTop: "10px", cursor: "pointer" }}
//         >
//           Send to Text Box
//         </button>
//       </Modal>

//       <button onClick={handleSubmit}>Submit</button>
//     </div>
//   );
// };

// export default TextboxWithImage;

// import React, { useState, useRef, useEffect } from "react";
// import Modal from "../../POP/Modal"; // Import the modal component
// import MathLive from "../../POP/FileComp7"; // Import MathLive component
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
// import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
// const TextboxWithImageSecond = ({
//   width = "100%",
//   height = "auto",
//   htmlContent,
//   questionCounter,
//   currentQuestion,
//   questionText,
//   optionFromAnotherPage,
//   quesType,
//   quesNo,
// }) => {
//   const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
//   const recognitionRef = useRef(null); // Ref for the speech recognition object
//   const contentEditableRef = useRef(null);
//   const [images, setImages] = useState([]); // Stores actual image files
//   const [showModal, setShowModal] = useState(false); // Modal state
//   const [latex, setLatex] = useState(""); // MathLive LaTeX content state
//   const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
//   const [isClicked, setIsClicked] = useState(false);
//   const fileInputRef = useRef(null); // Ref for the hidden file input
//   const [questionType, setQuestionType] = useState("multi-select"); // Tracks question type0
//   const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
//   const [hasCounterChanged, setHasCounterChanged] = useState(false);

//   const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)
//   const [initialOptions, setInitialOptions] = useState([]); // Store the initial options
//   const [content, setContent] = useState(htmlContent || "");

//   const [editableOptions, setEditableOptions] = useState([
//     { id: 1, content: "" },
//     { id: 2, content: "" },
//     { id: 3, content: "" },
//     { id: 4, content: "" },
//   ]);
//   useEffect(() => {
//     const mapQuesTypeToQuestionType = {
//       1: "multi-select",
//       2: "multi-select",
//       3: "fill-in-blanks",
//       4: "boolean",
//     };
//     const initialQuestionType = mapQuesTypeToQuestionType[quesType] || "multi-select";
//     setQuestionType(initialQuestionType);
//   }, [quesType]);

//   const mainEditableRef = useRef(null);
//   const refs = useRef([]); // Refs for all editable options

//   useEffect(() => {
//     if (optionFromAnotherPage && optionFromAnotherPage.length > 0) {
//       // Save initial options
//       setInitialOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           ...opt,
//           id: opt.id || index + 1,
//         }))
//       );

//       // Create editable options
//       setEditableOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           id: opt.id || index + 1,
//           content: opt.option_text || "",
//         }))
//       );
//     }
//   }, [optionFromAnotherPage]);

//   // Populate refs dynamically for all options
//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   useEffect(() => {
//     if (htmlContent !== content) {
//       setContent(htmlContent);
//     }
//   }, [htmlContent]);
//   const renderLatexToHTML = (text) => {
//     try {
//       let html = text;

//       // Replace LaTeX
//       html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//           displayMode: true,
//         })
//       );

//       html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//         })
//       );

//       // Replace image placeholders with actual images
//       images.forEach((image) => {
//         const placeholder = `[${image.id}_${image.alt}]`;
//         const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
//         html = html.replace(placeholder, imgTag);
//       });

//       return html;
//     } catch (error) {
//       console.error("Error rendering HTML:", error);
//       return text;
//     }
//   };

//   const handleInput = (id = "main") => {
//     const ref =
//       id === "main"
//         ? mainEditableRef.current
//         : refs.current.find((r, i) => i + 1 === id)?.current;

//     if (!ref) {
//       console.warn(`No ref found for id: ${id}`);
//       return;
//     }

//     // Save current selection (cursor position)
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Update content state
//     const contentHTML = ref.innerHTML.trim();
//     if (id === "main") {
//       console.log("questionEditing");
//       setContent(contentHTML);
//     } else {
//       console.log("optEditing", id);
//       setEditableOptions((prevOptions) =>
//         prevOptions.map((option) =>
//           option.id === id ? { ...option, content: contentHTML } : option
//         )
//       );
//     }

//     // Restore cursor position after the DOM updates
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function setCursor(node) {
//         if (node.nodeType === 3) {
//           // Text node
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (setCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }
//       setCursor(ref);
//     }, 0);
//   };

//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   const startSpeechToText = () => {
//     if (
//       !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
//     ) {
//       alert("Speech-to-text is not supported in this browser.");
//       return;
//     }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!recognitionRef.current) {
//       const recognition = new SpeechRecognition();
//       recognition.lang = "en-US";
//       recognition.interimResults = true;
//       recognition.continuous = true;

//       recognition.onstart = () => setIsRecording(true);

//       recognition.onresult = (event) => {
//         const mainDiv = mainEditableRef.current; // Main contentEditable div
//         const selection = window.getSelection();
//         const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

//         for (let i = event.resultIndex; i < event.results.length; i++) {
//           const transcript = event.results[i][0].transcript;

//           if (event.results[i].isFinal) {
//             const textNode = document.createTextNode(transcript + " ");
//             if (range) {
//               range.deleteContents();
//               range.insertNode(textNode);
//               range.setStartAfter(textNode);
//               range.setEndAfter(textNode);
//               selection.removeAllRanges();
//               selection.addRange(range);
//             } else {
//               mainDiv.appendChild(textNode);
//             }
//             handleInput("main"); // Update state after inserting speech text
//           }
//         }
//       };

//       recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error);
//         setIsRecording(false);
//       };

//       recognition.onend = () => setIsRecording(false);

//       recognitionRef.current = recognition;
//     }

//     recognitionRef.current.start();
//   };

//   const stopSpeechToText = () => {
//     if (recognitionRef.current) {
//       recognitionRef.current.stop();
//       setIsRecording(false);
//     }
//   };
//   const toggleSpeechToText = () => {
//     if (isRecording) {
//       stopSpeechToText();
//     } else {
//       startSpeechToText();
//     }
//   };
//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const img = document.createElement("img");
//         img.src = event.target.result;
//         img.alt = file.name || "selected-image";
//         img.classList.add("inserted-image"); // Add the CSS class

//         // Insert image at the current cursor position
//         const selection = window.getSelection();
//         const range = selection.getRangeAt(0);
//         range.deleteContents();
//         range.insertNode(img);

//         handleInput();
//       };
//       reader.readAsDataURL(file);
//     }
//   };
//   const handlePaste = (e, id = "main") => {
//     e.preventDefault();
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const items = e.clipboardData.items;

//     for (let item of items) {
//       if (item.type.startsWith("image/")) {
//         const blob = item.getAsFile();
//         const imageId = images.length + 1; // Assign serial number
//         const imageName = blob.name || `pasted-image-${imageId}`;

//         // Create a placeholder text for the image
//         const placeholderText = `[${imageId}_${imageName}]`;

//         // Insert placeholder text in the editable div
//         document.execCommand("insertText", false, placeholderText);

//         // Read and store the actual image for rendering
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImages((prevImages) => [
//             ...prevImages,
//             { id: imageId, src: event.target.result, alt: imageName },
//           ]);
//         };
//         reader.readAsDataURL(blob);

//         handleInput(id);
//       } else if (item.type === "text/plain") {
//         const text = e.clipboardData.getData("text/plain");
//         document.execCommand("insertText", false, text);
//         handleInput(id);
//       }
//     }
//   };

//   const handleLatexChange = (newLatex) => {
//     setLatex(newLatex);
//   };

//   const sendToTextBox = () => {
//     const mathLatex = `\\(${latex}\\)`;

//     if (focusedOption === "main") {
//       // Append to main editable div
//       if (mainEditableRef.current) {
//         mainEditableRef.current.innerHTML += mathLatex;
//         handleInput("main"); // Update the state
//       }
//     } else {
//       // Append to specific option
//       const focusedRef = refs.current.find(
//         (ref, index) => ref.current && index + 1 === focusedOption
//       )?.current;
//       if (focusedRef) {
//         focusedRef.innerHTML += mathLatex;
//         handleInput(focusedOption); // Update the state for the specific option
//       }
//     }

//     setShowModal(false); // Close the modal
//   };

//   const fileInputRefs = useRef([]); // File input refs for each option
//   const renderActionButtons = (index, id) => {
//     return (
//       focusedOption === id && (
//         <>
//           {/* Formula Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "110px",
//               cursor: "pointer",
//             }}
//             onClick={() => setShowModal(true)}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>

//           {/* Image Upload Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "70px",
//               cursor: "pointer",
//             }}
//             onClick={() => fileInputRefs.current[index].click()}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image Icon"
//             />
//             <input
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[index] = el)}
//               style={{ display: "none" }}
//               onChange={(e) => handleFileSelect(e, id)}
//             />
//           </div>

//           {/* Recording Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "30px",
//               cursor: "pointer",
//             }}
//             onClick={() => toggleSpeechToText(id)}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//                 animation: isRecording ? "blink 1s infinite" : "none",
//               }}
//               src={isRecording ? RecordingActive : RecordingStatic}
//               alt="Recording Icon"
//             />
//           </div>
//         </>
//       )
//     );
//   };
//   const renderOptions = () => {
//     switch (questionType) {
//       case "multi-select":
//         return editableOptions.map((opt, index) => (
//           <div
//             key={opt.id || index}
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginBottom: "10px",
//               position: "relative",
//             }}
//           >

//             <input type="checkbox" style={{ marginRight: "10px" }} />

//             <input
//               type="number"
//               placeholder="Weight"
//               value={opt.weight || ""}
//               onChange={(e) =>
//                 setEditableOptions((prevOptions) =>
//                   prevOptions.map((o, i) =>
//                     i === index ? { ...o, weight: e.target.value } : o
//                   )
//                 )
//               }
//               style={{
//                 marginRight: "10px",
//                 width: "60px",
//                 border: "1px solid #ccc",
//                 padding: "5px",
//                 borderRadius: "4px",
//               }}
//             />
//             <div
//               contentEditable
//               ref={(el) => (refs.current[index] = { current: el })}
//               onFocus={() => setFocusedOption(opt.id)}
//               onInput={() => handleOptionInput(index)}
//               onPaste={(e) => handlePaste(e, opt.id)}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: "10px",
//                 minHeight: "40px",
//                 width: "100%",
//                 backgroundColor: "#fff",
//                 borderRadius: "5px",
//                 paddingTop: "25px",
//               }}
//               dangerouslySetInnerHTML={{
//                 __html: processTextSecond(opt.content || ""),
//               }}
//             ></div>

//             {renderActionButtons(index, opt.id)}
//           </div>
//         ));
//       case "fill-in-blanks":
//         return (
//           <div style={{ position: "relative" }}>

//             <div
//               contentEditable
//               ref={(el) => (refs.current[0] = { current: el })}
//               onFocus={() => setFocusedOption(editableOptions[0]?.id || 1)}
//               onInput={() => handleInput(editableOptions[0]?.id || 1)}
//               onPaste={(e) => handlePaste(e, editableOptions[0]?.id || 1)}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: "10px",
//                 minHeight: "40px",
//                 width: "100%",
//                 backgroundColor: "#fff",
//                 borderRadius: "5px",
//                 paddingTop: "25px",
//               }}
//               dangerouslySetInnerHTML={{
//                 __html: editableOptions[0]?.content,
//               }}
//             ></div>

//             {/* Action Buttons */}
//             {renderActionButtons(0, editableOptions[0]?.id || 1)}
//           </div>
//         );

//       case "boolean":
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="true" />
//               <span style={{ marginLeft: "10px" }}>True</span>
//             </label>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="false" />
//               <span style={{ marginLeft: "10px" }}>False</span>
//             </label>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   // useEffect(() => {
//   //   // Map question type to numeric value
//   //   const typeMapping = {
//   //     "single-select": 1,
//   //     "multi-select": 2,
//   //     "fill-in-blanks": 3,
//   //     "boolean": 4,
//   //   };
//   //   setQuestionTypeValue(typeMapping[questionType]);
//   // }, [questionType]);

//   useEffect(() => {
//     if (hasCounterChanged) {
//     } else {
//       setHasCounterChanged(true); // Mark the initial render
//     }
//   }, [questionCounter]);

//   useEffect(() => {
//     if (questionText !== content) {
//       setContent(questionText);
//     }
//   }, [questionText]);

//   const processTextSecond = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     return text;
//   };

//   const processText = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     // Render LaTeX expressions
//     const latexRegex = /\\\((.*?)\\\)/g;
//     text = text.replace(latexRegex, (match, p1) => {
//       return katex.renderToString(p1, { throwOnError: false });
//     });

//     return text;
//   };

//   const handleOptionInput = (index) => {
//     console.log("Handling input for option:", index);

//     // Ensure the ref exists for the current option
//     const ref = refs.current[index]?.current;
//     if (!ref) {
//       console.warn(`No ref found for option at index: ${index}`);
//       return;
//     }

//     // Get the current content of the editable div

//     // Update the state for the editable option
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: contentHTML } : option
//       )
//     );

//     // Save cursor position
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Get current content from the editable div
//     const contentHTML = ref.innerHTML.trim();
//     console.log(`Content for option ${index}:`, contentHTML);

//     // Use the dedicated function to update editableOptions
//     handleOptionContentUpdate(index, contentHTML);

//     // Restore cursor position after DOM update
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function restoreCursor(node) {
//         if (node.nodeType === 3) {
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (restoreCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }

//       restoreCursor(ref);
//     }, 0);
//   };

//   const renderRightOptions = () => {
//     return editableOptions.map((opt, index) => (
//       <div
//         key={opt.id}
//         style={{
//           marginBottom: "10px",
//           padding: "10px",
//           border: "1px solid #ddd",
//         }}
//       >
//         <strong>Option {index + 1}:</strong>
//         <div
//           dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
//         ></div>
//       </div>
//     ));
//   };

//   const handleOptionContentUpdate = (index, newContent) => {
//     console.log(`Updating content for option ${index}:`, newContent);
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: newContent } : option
//       )
//     );
//   };

//   console.log(content + "contetn");
//   console.log(htmlContent + "htmlContent");
//   console.log("Editable Options:", JSON.stringify(editableOptions, null, 2));
//   useEffect(() => {
//     console.log("htmlContent updated:", htmlContent);
//     console.log("Editable options updated:", editableOptions);
//   }, [htmlContent, editableOptions]);
//   console.log("Refs after rendering:", refs.current);
//   useEffect(() => {
//     console.log("Updated editableOptions:", editableOptions);
//   }, [editableOptions]);
//   useEffect(() => {
//     console.log("Refs after rendering:", refs.current);
//   }, [editableOptions]);

//   return (
//     <div style={{ position: "relative", width, height }}>
//       <div style={{ display: "flex", width: "100%", gap: "20px" }}>
//         {/* Left Section */}
//         <div style={{ width: "50%" }}>
//           {/* Main editable div */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginTop: "15px",
//               color: "#2F2E40",
//               marginBottom: "20px",
//             }}
//           >
//             <h3 className="Question-background-match">Question : {quesNo}</h3>

//             {/* <label>Type:</label>
//             <input
//               type="radio"
//               value="multi-select"
//               checked={questionType === "multi-select"}
//               onChange={() => setQuestionType("multi-select")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Multi Select</label>
//             <input
//               type="radio"
//               value="fill-in-blanks"
//               checked={questionType === "fill-in-blanks"}
//               onChange={() => setQuestionType("fill-in-blanks")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Fill-In Blanks</label>
//             <input
//               type="radio"
//               value="boolean"
//               checked={questionType === "boolean"}
//               onChange={() => setQuestionType("boolean")}
//               style={{ marginLeft: "20px" }}
//             />
//             <label style={{ marginLeft: "5px" }}>Boolean</label> */}
//           </div>

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text <span style={{ color: "red" }}>*</span>
//           </p>
//           <div style={{ position: "relative" }}>
//             {/* Main ContentEditable Div */}
//             <div
//               contentEditable
//               ref={mainEditableRef}
//               onFocus={() => setFocusedOption("main")}
//               onInput={() => handleInput("main")}
//               onPaste={(e) => handlePaste(e, "main")}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: "22px 10px 10px", // top, left/right, bottom
//                 marginBottom: "20px",
//                 minHeight: "100px",
//                 backgroundColor: "white",
//               }}
//               dangerouslySetInnerHTML={{ __html: processTextSecond(content) }}
//             ></div>

//             {/* Formula Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "110px",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowModal(true)}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt="Formula"
//               />
//             </div>

//             {/* Image Upload Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "70px",
//                 cursor: "pointer",
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt="Image Icon"
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileSelect(e, "main")}
//               />
//             </div>

//             {/* Recording Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "30px",
//                 cursor: "pointer",
//               }}
//               onClick={() => toggleSpeechToText("main")}
//             >
//               <img
//                 style={{
//                   height: "18px",
//                   width: "17px",
//                   animation: isRecording ? "blink 1s infinite" : "none",
//                 }}
//                 src={isRecording ? RecordingActive : RecordingStatic}
//                 alt="Recording Icon"
//               />
//             </div>
//           </div>

//           {/* Additional buttons */}
//           {renderOptions()}
//         </div>

//         {/* Right Section */}
//         <div
//           style={{
//             width: "50%",
//             border: "1px solid #ccc",
//             padding: "10px",
//             backgroundColor: "white",
//             minHeight: "100px",
//             whiteSpace: "pre-wrap",
//             marginTop: "81px",
//           }}
//         >
//           <div>
//             <strong style={{ paddingBottom: "15px", paddingTop: "8px" }}>
//               Question:
//             </strong>
//             <div
//               style={{ paddingBottom: "8px" }}
//               dangerouslySetInnerHTML={{
//                 __html: processText(content),
//               }}
//             ></div>
//           </div>
//           <div>{renderRightOptions()}</div>
//         </div>
//       </div>

//       <Modal show={showModal} onClose={() => setShowModal(false)}>
//         <h2 style={{ color: "white" }}>MathLive Input</h2>
//         <MathLive onLatexChange={handleLatexChange} />
//         <button
//           onClick={sendToTextBox}
//           style={{ marginTop: "10px", cursor: "pointer" }}
//         >
//           Send to Text Box
//         </button>
//       </Modal>
//     </div>
//   );
// };

// export default React.memo(TextboxWithImageSecond);

// import React, { useState, useRef, useEffect } from "react";
// import Modal from "../../POP/Modal"; // Import the modal component
// import MathLive from "../../POP/FileComp7"; // Import MathLive component
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
// import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";
// import DeleteBin from "../../../Assets/Images/CommanImages/Delete.png";
// const TextboxWithImageSecond = ({
//   width = "100%",
//   height = "auto",
//   htmlContent,
//   questionCounter,
//   currentQuestion,
//   questionText,
//   optionFromAnotherPage,
//   quesType,
//   quesNo,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) => {
//   const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
//   const recognitionRef = useRef(null); // Ref for the speech recognition object
//   const contentEditableRef = useRef(null);
//   const [images, setImages] = useState([]); // Stores actual image files
//   const [showModal, setShowModal] = useState(false); // Modal state
//   const [latex, setLatex] = useState(""); // MathLive LaTeX content state
//   const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
//   const [isClicked, setIsClicked] = useState(false);
//   const fileInputRef = useRef(null); // Ref for the hidden file input
//   const [questionType, setQuestionType] = useState("multi-select"); // Tracks question type0
//   const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
//   const [hasCounterChanged, setHasCounterChanged] = useState(false);
//   const [checkedOptions, setCheckedOptions] = useState({});
//   const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)
//   const [initialOptions, setInitialOptions] = useState([]); // Store the initial options
//   const [content, setContent] = useState(htmlContent || "");
//   const [isDragging, setIsDragging] = useState(false);
//   const [dividerPosition, setDividerPosition] = useState(50);
//   const containerRef = useRef(null);
//   const [editableOptions, setEditableOptions] = useState(
//     optionFromAnotherPage?.map(opt => ({
//       ...opt,
//       id: opt.option_no,
//       content: opt.option_text
//     })) || []
//   );

//   const handleCheckboxChange = (index) => {
//     setEditableOptions(prevOptions =>
//       prevOptions.map((opt, idx) =>
//         idx === index
//           ? { ...opt, option_correct_flag: opt.option_correct_flag === 1 ? 0 : 1 }
//           : opt
//       )
//     );
//   };

//   const handleMouseDown = () => {
//     setIsDragging(true);
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging && containerRef.current) {
//       const containerRect = containerRef.current.getBoundingClientRect();
//       const newPosition =
//         ((e.clientX - containerRect.left) / containerRect.width) * 100;
//       setDividerPosition(Math.min(Math.max(newPosition, 20), 80));
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   useEffect(() => {
//     if (isDragging) {
//       document.addEventListener("mousemove", handleMouseMove);
//       document.addEventListener("mouseup", handleMouseUp);
//     }
//     return () => {
//       document.removeEventListener("mousemove", handleMouseMove);
//       document.removeEventListener("mouseup", handleMouseUp);
//     };
//   }, [isDragging]);

//   // const [editableOptions, setEditableOptions] = useState([
//   //   { id: 1, content: "" },
//   //   { id: 2, content: "" },
//   //   { id: 3, content: "" },
//   //   { id: 4, content: "" },
//   // ]);
//   useEffect(() => {
//     const mapQuesTypeToQuestionType = {
//       1: "multi-select",
//       2: "multi-select",
//       3: "fill-in-blanks",
//       4: "boolean",
//     };
//     const initialQuestionType =
//       mapQuesTypeToQuestionType[quesType] || "multi-select";
//     setQuestionType(initialQuestionType);
//   }, [quesType]);

//   const mainEditableRef = useRef(null);
//   const refs = useRef([]); // Refs for all editable options

//   useEffect(() => {
//     if (optionFromAnotherPage && optionFromAnotherPage.length > 0) {
//       // Save initial options
//       setInitialOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           ...opt,
//           id: opt.id || index + 1,
//         }))
//       );

//       // Create editable options
//       setEditableOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           id: opt.id || index + 1,
//           content: opt.option_text || "",
//         }))
//       );
//     }
//   }, [optionFromAnotherPage]);

//   // Populate refs dynamically for all options
//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   useEffect(() => {
//     if (htmlContent !== content) {
//       setContent(htmlContent);
//     }
//   }, [htmlContent]);
//   const renderLatexToHTML = (text) => {
//     try {
//       let html = text;

//       // Replace LaTeX
//       html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//           displayMode: true,
//         })
//       );

//       html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//         })
//       );

//       // Replace image placeholders with actual images
//       images.forEach((image) => {
//         const placeholder = `[${image.id}_${image.alt}]`;
//         const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
//         html = html.replace(placeholder, imgTag);
//       });

//       return html;
//     } catch (error) {
//       console.error("Error rendering HTML:", error);
//       return text;
//     }
//   };
//   const handleDeleteOption = (id) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.filter((option) => option.id !== id)
//     );
//   };

//   const handleInput = (id = "main") => {
//     const ref =
//       id === "main"
//         ? mainEditableRef.current
//         : refs.current.find((r, i) => i + 1 === id)?.current;

//     if (!ref) {
//       console.warn(`No ref found for id: ${id}`);
//       return;
//     }

//     // Save current selection (cursor position)
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Update content state
//     const contentHTML = ref.innerHTML.trim();
//     if (id === "main") {
//       console.log("questionEditing");
//       setContent(contentHTML);
//     } else {
//       console.log("optEditing", id);
//       setEditableOptions((prevOptions) =>
//         prevOptions.map((option) =>
//           option.id === id ? { ...option, content: contentHTML } : option
//         )
//       );
//     }

//     // Restore cursor position after the DOM updates
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function setCursor(node) {
//         if (node.nodeType === 3) {
//           // Text node
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (setCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }
//       setCursor(ref);
//     }, 0);
//   };

//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   const startSpeechToText = () => {
//     if (
//       !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
//     ) {
//       alert("Speech-to-text is not supported in this browser.");
//       return;
//     }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!recognitionRef.current) {
//       const recognition = new SpeechRecognition();
//       recognition.lang = "en-US";
//       recognition.interimResults = true;
//       recognition.continuous = true;

//       recognition.onstart = () => setIsRecording(true);

//       recognition.onresult = (event) => {
//         const mainDiv = mainEditableRef.current; // Main contentEditable div
//         const selection = window.getSelection();
//         const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

//         for (let i = event.resultIndex; i < event.results.length; i++) {
//           const transcript = event.results[i][0].transcript;

//           if (event.results[i].isFinal) {
//             const textNode = document.createTextNode(transcript + " ");
//             if (range) {
//               range.deleteContents();
//               range.insertNode(textNode);
//               range.setStartAfter(textNode);
//               range.setEndAfter(textNode);
//               selection.removeAllRanges();
//               selection.addRange(range);
//             } else {
//               mainDiv.appendChild(textNode);
//             }
//             handleInput("main"); // Update state after inserting speech text
//           }
//         }
//       };

//       recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error);
//         setIsRecording(false);
//       };

//       recognition.onend = () => setIsRecording(false);

//       recognitionRef.current = recognition;
//     }

//     recognitionRef.current.start();
//   };

//   const stopSpeechToText = () => {
//     if (recognitionRef.current) {
//       recognitionRef.current.stop();
//       setIsRecording(false);
//     }
//   };
//   const toggleSpeechToText = () => {
//     if (isRecording) {
//       stopSpeechToText();
//     } else {
//       startSpeechToText();
//     }
//   };
//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const img = document.createElement("img");
//         img.src = event.target.result;
//         img.alt = file.name || "selected-image";
//         img.classList.add("inserted-image"); // Add the CSS class

//         // Insert image at the current cursor position
//         const selection = window.getSelection();
//         const range = selection.getRangeAt(0);
//         range.deleteContents();
//         range.insertNode(img);

//         handleInput();
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleAddOption = () => {
//     const newOption = {
//       id: editableOptions.length + 1,
//       content: "",
//       weight: "",
//     };
//     setEditableOptions([...editableOptions, newOption]);
//   };

//   const handlePaste = (e, id = "main") => {
//     e.preventDefault();
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const items = e.clipboardData.items;

//     for (let item of items) {
//       if (item.type.startsWith("image/")) {
//         const blob = item.getAsFile();
//         const imageId = images.length + 1; // Assign serial number
//         const imageName = blob.name || `pasted-image-${imageId}`;

//         // Create a placeholder text for the image
//         const placeholderText = `[${imageId}_${imageName}]`;

//         // Insert placeholder text in the editable div
//         document.execCommand("insertText", false, placeholderText);

//         // Read and store the actual image for rendering
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImages((prevImages) => [
//             ...prevImages,
//             { id: imageId, src: event.target.result, alt: imageName },
//           ]);
//         };
//         reader.readAsDataURL(blob);

//         handleInput(id);
//       } else if (item.type === "text/plain") {
//         const text = e.clipboardData.getData("text/plain");
//         document.execCommand("insertText", false, text);
//         handleInput(id);
//       }
//     }
//   };

//   const handleLatexChange = (newLatex) => {
//     setLatex(newLatex);
//   };

//   const sendToTextBox = () => {
//     const mathLatex = `\\(${latex}\\)`;

//     if (focusedOption === "main") {
//       // Append to main editable div
//       if (mainEditableRef.current) {
//         mainEditableRef.current.innerHTML += mathLatex;
//         handleInput("main"); // Update the state
//       }
//     } else {
//       // Append to specific option
//       const focusedRef = refs.current.find(
//         (ref, index) => ref.current && index + 1 === focusedOption
//       )?.current;
//       if (focusedRef) {
//         focusedRef.innerHTML += mathLatex;
//         handleInput(focusedOption); // Update the state for the specific option
//       }
//     }

//     setShowModal(false); // Close the modal
//   };

//   const fileInputRefs = useRef([]); // File input refs for each option
//   const renderActionButtons = (index, id) => {
//     return (
//       focusedOption === id && (
//         <>
//           {/* Formula Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "110px",
//               cursor: "pointer",
//             }}
//             onClick={() => setShowModal(true)}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>

//           {/* Image Upload Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "70px",
//               cursor: "pointer",
//             }}
//             onClick={() => fileInputRefs.current[index].click()}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image Icon"
//             />
//             <input
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[index] = el)}
//               style={{ display: "none" }}
//               onChange={(e) => handleFileSelect(e, id)}
//             />
//           </div>

//           {/* Recording Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "30px",
//               cursor: "pointer",
//             }}
//             onClick={() => toggleSpeechToText(id)}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//                 animation: isRecording ? "blink 1s infinite" : "none",
//               }}
//               src={isRecording ? RecordingActive : RecordingStatic}
//               alt="Recording Icon"
//             />
//           </div>

//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "150px",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//               }}
//               onClick={() => handleDeleteOption(id)} // Call delete handler
//               src={DeleteBin}
//               alt="DeleteBin"
//             />
//           </div>
//         </>
//       )
//     );
//   };
//   const renderOptions = () => {
//     switch (questionType) {
//       case "multi-select":
//         return editableOptions.map((opt, index) => (
//           <div
//             key={opt.id || index}
//             style={{
//               display: "flex",
//               flexDirection: "column", // Ensure elements are stacked vertically
//               marginBottom: "10px",
//               position: "relative",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <input
//                 type="checkbox"
//                 style={{ marginRight: "10px" }}
//                 checked={opt.option_correct_flag === 1}
//                 onChange={() => handleCheckboxChange(index)}
//               />
//               {/* <input
//                 type="checkbox"
//                 checked={checkedOptions[opt.option_no] || false}
//                 onChange={() => handleCheckboxChange(opt.option_no)}
//                 style={{
//                   marginRight: "10px",
//                   accentColor: checkedOptions[opt.option_no]
//                     ? "#4CAF50"
//                     : undefined,
//                 }}
//               /> */}
//               <input
//                 type="number"
//                 placeholder="Weight"
//                 value={opt.weight || ""}
//                 onChange={(e) =>
//                   setEditableOptions((prevOptions) =>
//                     prevOptions.map((o, i) =>
//                       i === index ? { ...o, weight: e.target.value } : o
//                     )
//                   )
//                 }
//                 style={{
//                   marginRight: "10px",
//                   width: "60px",
//                   border: "1px solid #6A6A6A",
//                   padding: "5px",
//                   // borderRadius: "4px",
//                 }}
//               />
//               <div
//                 contentEditable
//                 ref={(el) => (refs.current[index] = { current: el })}
//                 onFocus={() => setFocusedOption(opt.id)}
//                 onInput={() => handleOptionInput(index)}
//                 onPaste={(e) => handlePaste(e, opt.id)}
//                 style={{
//                   border: "1px solid #6A6A6A",
//                   padding: "10px",
//                   minHeight: "40px",
//                   width: "100%",
//                   backgroundColor: "#fff",
//                   // borderRadius: "5px",
//                   paddingTop: "25px",
//                 }}
//                 dangerouslySetInnerHTML={{
//                   __html: processTextSecond(opt.content || ""),
//                 }}
//               ></div>
//               {renderActionButtons(index, opt.id)}
//             </div>
//             <div style={{ textAlign: "right", marginTop: "10px" }}>
//               {index === editableOptions.length - 1 &&
//                 focusedOption === opt.id && (
//                   <img
//                     onClick={handleAddOption}
//                     src={YellowPlus}
//                     alt="Option_Add"
//                     className="YellowPlus-RC-Button"
//                   />
//                 )}
//             </div>
//           </div>
//         ));
//       case "fill-in-blanks":
//         return (
//           <div style={{ position: "relative" }}>
//             <div
//               contentEditable
//               ref={(el) => (refs.current[0] = { current: el })}
//               onFocus={() => setFocusedOption(editableOptions[0]?.id || 1)}
//               onInput={() => handleInput(editableOptions[0]?.id || 1)}
//               onPaste={(e) => handlePaste(e, editableOptions[0]?.id || 1)}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "10px",
//                 minHeight: "40px",
//                 width: "100%",
//                 backgroundColor: "#fff",
//                 // borderRadius: "5px",
//                 paddingTop: "25px",
//               }}
//               dangerouslySetInnerHTML={{
//                 __html: editableOptions[0]?.content,
//               }}
//             ></div>

//             {/* Action Buttons */}
//             {renderActionButtons(0, editableOptions[0]?.id || 1)}
//           </div>
//         );

//       case "boolean":
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="true" />
//               <span style={{ marginLeft: "10px" }}>True</span>
//             </label>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="false" />
//               <span style={{ marginLeft: "10px" }}>False</span>
//             </label>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   useEffect(() => {
//     if (hasCounterChanged) {
//     } else {
//       setHasCounterChanged(true); // Mark the initial render
//     }
//   }, [questionCounter]);

//   useEffect(() => {
//     if (questionText !== content) {
//       setContent(questionText);
//     }
//   }, [questionText]);

//   const processTextSecond = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     return text;
//   };

//   const processText = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     // Render LaTeX expressions
//     const latexRegex = /\\\((.*?)\\\)/g;
//     text = text.replace(latexRegex, (match, p1) => {
//       return katex.renderToString(p1, { throwOnError: false });
//     });

//     return text;
//   };

//   const handleOptionInput = (index) => {
//     console.log("Handling input for option:", index);

//     // Ensure the ref exists for the current option
//     const ref = refs.current[index]?.current;
//     if (!ref) {
//       console.warn(`No ref found for option at index: ${index}`);
//       return;
//     }

//     // Get the current content of the editable div

//     // Update the state for the editable option
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: contentHTML } : option
//       )
//     );

//     // Save cursor position
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Get current content from the editable div
//     const contentHTML = ref.innerHTML.trim();
//     console.log(`Content for option ${index}:`, contentHTML);

//     // Use the dedicated function to update editableOptions
//     handleOptionContentUpdate(index, contentHTML);

//     // Restore cursor position after DOM update
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function restoreCursor(node) {
//         if (node.nodeType === 3) {
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (restoreCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }

//       restoreCursor(ref);
//     }, 0);
//   };

//   // const renderRightOptions = () => {
//   //   return editableOptions.map((opt, index) => (
//   //     <div
//   //       key={opt.id}
//   //       style={{
//   //         marginBottom: "10px",
//   //         padding: "10px",
//   //         border: "1px solid #ddd",
//   //       }}
//   //     >
//   //    <strong>Option {index + 1}:</strong>
//   //       <span><input type="checkbox" /></span>
//   //       <div
//   //         style={{ padding: "5px" }}
//   //         dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
//   //       ></div>
//   //     </div>
//   //   ));
//   // };
//   const renderRightOptions = () => {
//     return editableOptions.map((opt, index) => (
//       <div
//         key={opt.id}
//         style={{
//           marginBottom: "10px",
//           padding: "10px",
//           display: "flex",
//           alignItems: "flex-start",
//           gap: "10px",
//         }}
//       >
//         <input
//           type="checkbox"
//           style={{
//             marginTop: "5px",
//             flexShrink: 0,
//           }}
//         />
//         <div
//           style={{
//             padding: "5px",
//             flex: 1,
//           }}
//           dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
//         />
//       </div>
//     ));
//   };

//   const handleOptionContentUpdate = (index, newContent) => {
//     console.log(`Updating content for option ${index}:`, newContent);
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: newContent } : option
//       )
//     );
//   };

//   console.log(content + "contetn");
//   console.log(htmlContent + "htmlContent");
//   console.log("Editable Options:", JSON.stringify(editableOptions, null, 2));
//   useEffect(() => {
//     console.log("htmlContent updated:", htmlContent);
//     console.log("Editable options updated:", editableOptions);
//   }, [htmlContent, editableOptions]);
//   console.log("Refs after rendering:", refs.current);
//   useEffect(() => {
//     console.log("Updated editableOptions:", editableOptions);
//   }, [editableOptions]);
//   useEffect(() => {
//     console.log("Refs after rendering:", refs.current);
//   }, [editableOptions]);

//   return (
//     <div
//       style={{
//         position: "relative",
//         width,
//         height,
//         backgroundColor: "#FBFBFB",
//         padding: "10px",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           width: "100%",
//           gap: "20px",
//           userSelect: isDragging ? "none" : "auto",
//         }}
//         ref={containerRef}
//       >
//         {/* Left Section */}
//         <div style={{ width: `${dividerPosition}%` }}>
//           {/* Main editable div */}
//           {/* <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginTop: "15px",
//               color: "#2F2E40",
//               marginBottom: "20px",
//             }}
//           > */}
//           {/* <h3 className="Question-background-match">Question : {quesNo}</h3> */}
//           {/* </div> */}

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text :
//           </p>
//           <div style={{ position: "relative" }}>
//             {/* Main ContentEditable Div */}
//             <div
//               contentEditable
//               ref={mainEditableRef}
//               onFocus={() => setFocusedOption("main")}
//               onInput={() => handleInput("main")}
//               onPaste={(e) => handlePaste(e, "main")}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "22px 10px 10px", // top, left/right, bottom
//                 marginBottom: "20px",
//                 minHeight: "100px",
//                 backgroundColor: "white",
//               }}
//               dangerouslySetInnerHTML={{ __html: processTextSecond(content) }}
//             ></div>

//             {/* Formula Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "110px",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowModal(true)}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt="Formula"
//               />
//             </div>

//             {/* Image Upload Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "70px",
//                 cursor: "pointer",
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt="Image Icon"
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileSelect(e, "main")}
//               />
//             </div>

//             {/* Recording Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "30px",
//                 cursor: "pointer",
//               }}
//               onClick={() => toggleSpeechToText("main")}
//             >
//               <img
//                 style={{
//                   height: "18px",
//                   width: "17px",
//                   animation: isRecording ? "blink 1s infinite" : "none",
//                 }}
//                 src={isRecording ? RecordingActive : RecordingStatic}
//                 alt="Recording Icon"
//               />
//             </div>
//           </div>

//           {/* Additional buttons */}
//           {renderOptions()}
//         </div>

//         {/* Draggable divider */}
//         <div
//           style={{
//             position: "relative",
//             cursor: "col-resize",
//             width: "10px",
//             margin: "0 -5px",
//             zIndex: 20,
//           }}
//           onMouseDown={handleMouseDown}
//         >
//           <div
//             style={{
//               marginTop: "5vh",
//               position: "absolute",
//               top: 0,
//               bottom: 0,
//               left: "50%",
//               borderLeft: "2px dotted #ccc",
//               height: "87%",
//             }}
//           >
//             {/* Triangle pointer */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 right: "-6px",
//                 width: 0,
//                 height: 0,
//                 borderTop: "6px solid transparent",
//                 borderBottom: "6px solid transparent",
//                 borderLeft: "6px solid #ccc",
//                 transform: "translateY(-50%)",
//               }}
//             />
//           </div>
//         </div>

//         {/* Right side with options */}

//         {/* Right Section */}

//         <div style={{ width: `${100 - dividerPosition}%` }}>
//           <p style={{ marginTop: "2.2vh" }}>Preview :</p>

//           <div
//             style={{
//               width: "100%",
//               border: "1px solid #ccc",
//               padding: "10px",
//               backgroundColor: "white",
//               minHeight: "100px",
//               whiteSpace: "pre-wrap",
//               marginTop: "1vh",
//             }}
//           >
//             <div>
//               <strong style={{ paddingBottom: "15px", paddingTop: "8px" }}>
//                 Question:
//               </strong>
//               <div
//                 style={{ padding: "8px" }}
//                 dangerouslySetInnerHTML={{
//                   __html: processText(content),
//                 }}
//               ></div>
//             </div>
//             <div>{renderRightOptions()}</div>
//           </div>
//         </div>
//       </div>

//       <Modal show={showModal} onClose={() => setShowModal(false)}>
//         <h2 style={{ color: "white" }}>MathLive Input</h2>
//         <MathLive onLatexChange={handleLatexChange} />
//         <button
//           onClick={sendToTextBox}
//           style={{ marginTop: "10px", cursor: "pointer" }}
//         >
//           Send to Text Box
//         </button>
//       </Modal>
//     </div>
//   );
// };

// export default React.memo(TextboxWithImageSecond);

// import React, { useState, useRef, useEffect } from "react";
// import Modal from "../../POP/Modal"; // Import the modal component
// import MathLive from "../../POP/FileComp7"; // Import MathLive component
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
// import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";
// import DeleteBin from "../../../Assets/Images/CommanImages/Delete.png";
// const TextboxWithImageSecond = ({
//   width = "100%",
//   height = "auto",
//   htmlContent,
//   questionCounter,
//   currentQuestion,
//   questionText,
//   optionFromAnotherPage,
//   quesType,
//   quesNo,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) => {
//   const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
//   const recognitionRef = useRef(null); // Ref for the speech recognition object
//   const contentEditableRef = useRef(null);
//   const [images, setImages] = useState([]); // Stores actual image files
//   const [showModal, setShowModal] = useState(false); // Modal state
//   const [latex, setLatex] = useState(""); // MathLive LaTeX content state
//   const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
//   const [isClicked, setIsClicked] = useState(false);
//   const fileInputRef = useRef(null); // Ref for the hidden file input
//   const [questionType, setQuestionType] = useState("multi-select"); // Tracks question type0
//   const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
//   const [hasCounterChanged, setHasCounterChanged] = useState(false);
//   const [checkedOptions, setCheckedOptions] = useState({});
//   const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)
//   const [initialOptions, setInitialOptions] = useState([]); // Store the initial options
//   const [content, setContent] = useState(htmlContent || "");
//   const [isDragging, setIsDragging] = useState(false);
//   const [dividerPosition, setDividerPosition] = useState(50);
//   const containerRef = useRef(null);
//   const [editableOptions, setEditableOptions] = useState(
//     optionFromAnotherPage?.map((opt) => ({
//       ...opt,
//       id: opt.option_no,
//       content: opt.option_text,
//       isChecked: opt.option_correct_flag === 1,
//     })) || []
//   );

//   const handleCheckboxChange = (index) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((opt, idx) => ({
//         ...opt,
//         isChecked: idx === index ? !opt.isChecked : opt.isChecked,
//         option_correct_flag:
//           idx === index ? (opt.isChecked ? 0 : 1) : opt.option_correct_flag,
//       }))
//     );
//   };
//   // const [editableOptions, setEditableOptions] = useState(
//   //   optionFromAnotherPage?.map(opt => ({
//   //     ...opt,
//   //     id: opt.option_no,
//   //     content: opt.option_text
//   //   })) || []
//   // );

//   // const handleCheckboxChange = (index) => {
//   //   setEditableOptions(prevOptions =>
//   //     prevOptions.map((opt, idx) =>
//   //       idx === index
//   //         ? { ...opt, option_correct_flag: opt.option_correct_flag === 1 ? 0 : 1 }
//   //         : opt
//   //     )
//   //   );
//   // };

//   const handleMouseDown = () => {
//     setIsDragging(true);
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging && containerRef.current) {
//       const containerRect = containerRef.current.getBoundingClientRect();
//       const newPosition =
//         ((e.clientX - containerRect.left) / containerRect.width) * 100;
//       setDividerPosition(Math.min(Math.max(newPosition, 20), 80));
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   useEffect(() => {
//     if (isDragging) {
//       document.addEventListener("mousemove", handleMouseMove);
//       document.addEventListener("mouseup", handleMouseUp);
//     }
//     return () => {
//       document.removeEventListener("mousemove", handleMouseMove);
//       document.removeEventListener("mouseup", handleMouseUp);
//     };
//   }, [isDragging]);

//   // const [editableOptions, setEditableOptions] = useState([
//   //   { id: 1, content: "" },
//   //   { id: 2, content: "" },
//   //   { id: 3, content: "" },
//   //   { id: 4, content: "" },
//   // ]);
//   useEffect(() => {
//     const mapQuesTypeToQuestionType = {
//       1: "multi-select",
//       2: "multi-select",
//       3: "fill-in-blanks",
//       4: "boolean",
//     };
//     const initialQuestionType =
//       mapQuesTypeToQuestionType[quesType] || "multi-select";
//     setQuestionType(initialQuestionType);
//   }, [quesType]);

//   const mainEditableRef = useRef(null);
//   const refs = useRef([]); // Refs for all editable options

//   useEffect(() => {
//     if (optionFromAnotherPage && optionFromAnotherPage.length > 0) {
//       // Save initial options
//       setInitialOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           ...opt,
//           id: opt.id || index + 1,
//         }))
//       );

//       // Create editable options
//       setEditableOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           id: opt.id || index + 1,
//           content: opt.option_text || "",
//         }))
//       );
//     }
//   }, [optionFromAnotherPage]);

//   // Populate refs dynamically for all options
//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   useEffect(() => {
//     if (htmlContent !== content) {
//       setContent(htmlContent);
//     }
//   }, [htmlContent]);
//   const renderLatexToHTML = (text) => {
//     try {
//       let html = text;

//       // Replace LaTeX
//       html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//           displayMode: true,
//         })
//       );

//       html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//         })
//       );

//       // Replace image placeholders with actual images
//       images.forEach((image) => {
//         const placeholder = `[${image.id}_${image.alt}]`;
//         const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
//         html = html.replace(placeholder, imgTag);
//       });

//       return html;
//     } catch (error) {
//       console.error("Error rendering HTML:", error);
//       return text;
//     }
//   };
//   const handleDeleteOption = (id) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.filter((option) => option.id !== id)
//     );
//   };

//   const handleInput = (id = "main") => {
//     const ref =
//       id === "main"
//         ? mainEditableRef.current
//         : refs.current.find((r, i) => i + 1 === id)?.current;

//     if (!ref) {
//       console.warn(`No ref found for id: ${id}`);
//       return;
//     }

//     // Save current selection (cursor position)
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Update content state
//     const contentHTML = ref.innerHTML.trim();
//     if (id === "main") {
//       console.log("questionEditing");
//       setContent(contentHTML);
//     } else {
//       console.log("optEditing", id);
//       setEditableOptions((prevOptions) =>
//         prevOptions.map((option) =>
//           option.id === id ? { ...option, content: contentHTML } : option
//         )
//       );
//     }

//     // Restore cursor position after the DOM updates
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function setCursor(node) {
//         if (node.nodeType === 3) {
//           // Text node
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (setCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }
//       setCursor(ref);
//     }, 0);
//   };

//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   const startSpeechToText = () => {
//     if (
//       !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
//     ) {
//       alert("Speech-to-text is not supported in this browser.");
//       return;
//     }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!recognitionRef.current) {
//       const recognition = new SpeechRecognition();
//       recognition.lang = "en-US";
//       recognition.interimResults = true;
//       recognition.continuous = true;

//       recognition.onstart = () => setIsRecording(true);

//       recognition.onresult = (event) => {
//         const mainDiv = mainEditableRef.current; // Main contentEditable div
//         const selection = window.getSelection();
//         const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

//         for (let i = event.resultIndex; i < event.results.length; i++) {
//           const transcript = event.results[i][0].transcript;

//           if (event.results[i].isFinal) {
//             const textNode = document.createTextNode(transcript + " ");
//             if (range) {
//               range.deleteContents();
//               range.insertNode(textNode);
//               range.setStartAfter(textNode);
//               range.setEndAfter(textNode);
//               selection.removeAllRanges();
//               selection.addRange(range);
//             } else {
//               mainDiv.appendChild(textNode);
//             }
//             handleInput("main"); // Update state after inserting speech text
//           }
//         }
//       };

//       recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error);
//         setIsRecording(false);
//       };

//       recognition.onend = () => setIsRecording(false);

//       recognitionRef.current = recognition;
//     }

//     recognitionRef.current.start();
//   };

//   const stopSpeechToText = () => {
//     if (recognitionRef.current) {
//       recognitionRef.current.stop();
//       setIsRecording(false);
//     }
//   };
//   const toggleSpeechToText = () => {
//     if (isRecording) {
//       stopSpeechToText();
//     } else {
//       startSpeechToText();
//     }
//   };
//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const img = document.createElement("img");
//         img.src = event.target.result;
//         img.alt = file.name || "selected-image";
//         img.classList.add("inserted-image"); // Add the CSS class

//         // Insert image at the current cursor position
//         const selection = window.getSelection();
//         const range = selection.getRangeAt(0);
//         range.deleteContents();
//         range.insertNode(img);

//         handleInput();
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleAddOption = () => {
//     const newOption = {
//       id: editableOptions.length + 1,
//       content: "",
//       weight: "",
//     };
//     setEditableOptions([...editableOptions, newOption]);
//   };

//   const handlePaste = (e, id = "main") => {
//     e.preventDefault();
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const items = e.clipboardData.items;

//     for (let item of items) {
//       if (item.type.startsWith("image/")) {
//         const blob = item.getAsFile();
//         const imageId = images.length + 1; // Assign serial number
//         const imageName = blob.name || `pasted-image-${imageId}`;

//         // Create a placeholder text for the image
//         const placeholderText = `[${imageId}_${imageName}]`;

//         // Insert placeholder text in the editable div
//         document.execCommand("insertText", false, placeholderText);

//         // Read and store the actual image for rendering
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImages((prevImages) => [
//             ...prevImages,
//             { id: imageId, src: event.target.result, alt: imageName },
//           ]);
//         };
//         reader.readAsDataURL(blob);

//         handleInput(id);
//       } else if (item.type === "text/plain") {
//         const text = e.clipboardData.getData("text/plain");
//         document.execCommand("insertText", false, text);
//         handleInput(id);
//       }
//     }
//   };

//   const handleLatexChange = (newLatex) => {
//     setLatex(newLatex);
//   };

//   const sendToTextBox = () => {
//     const mathLatex = `\\(${latex}\\)`;

//     if (focusedOption === "main") {
//       // Append to main editable div
//       if (mainEditableRef.current) {
//         mainEditableRef.current.innerHTML += mathLatex;
//         handleInput("main"); // Update the state
//       }
//     } else {
//       // Append to specific option
//       const focusedRef = refs.current.find(
//         (ref, index) => ref.current && index + 1 === focusedOption
//       )?.current;
//       if (focusedRef) {
//         focusedRef.innerHTML += mathLatex;
//         handleInput(focusedOption); // Update the state for the specific option
//       }
//     }

//     setShowModal(false); // Close the modal
//   };

//   const fileInputRefs = useRef([]); // File input refs for each option
//   const renderActionButtons = (index, id) => {
//     return (
//       focusedOption === id && (
//         <>
//           {/* Formula Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "110px",
//               cursor: "pointer",
//             }}
//             onClick={() => setShowModal(true)}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>

//           {/* Image Upload Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "70px",
//               cursor: "pointer",
//             }}
//             onClick={() => fileInputRefs.current[index].click()}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image Icon"
//             />
//             <input
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[index] = el)}
//               style={{ display: "none" }}
//               onChange={(e) => handleFileSelect(e, id)}
//             />
//           </div>

//           {/* Recording Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "30px",
//               cursor: "pointer",
//             }}
//             onClick={() => toggleSpeechToText(id)}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//                 animation: isRecording ? "blink 1s infinite" : "none",
//               }}
//               src={isRecording ? RecordingActive : RecordingStatic}
//               alt="Recording Icon"
//             />
//           </div>

//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "150px",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//               }}
//               onClick={() => handleDeleteOption(id)} // Call delete handler
//               src={DeleteBin}
//               alt="DeleteBin"
//             />
//           </div>
//         </>
//       )
//     );
//   };
//   const renderOptions = () => {
//     switch (questionType) {
//       case "multi-select":
//         return editableOptions.map((opt, index) => (
//           <div
//             key={opt.id || index}
//             style={{
//               display: "flex",
//               flexDirection: "column", // Ensure elements are stacked vertically
//               marginBottom: "10px",
//               position: "relative",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center" }}>
//               {/* <input
//                 type="checkbox"
//                 style={{ marginRight: "10px" }}
//                 checked={opt.option_correct_flag === 1}
//                 onChange={() => handleCheckboxChange(index)}
//               /> */}
//               <input
//                 type="checkbox"
//                 checked={opt.isChecked}
//                 onChange={() => handleCheckboxChange(index)}
//                 style={{
//                   marginRight: "10px",
//                   cursor: "pointer",
//                   accentColor: "##D6D6D6",
//                 }}
//               />
//               {/* <input
//                 type="checkbox"
//                 checked={checkedOptions[opt.option_no] || false}
//                 onChange={() => handleCheckboxChange(opt.option_no)}
//                 style={{
//                   marginRight: "10px",
//                   accentColor: checkedOptions[opt.option_no]
//                     ? "#4CAF50"
//                     : undefined,
//                 }}
//               /> */}
//               <input
//                 type="number"
//                 placeholder="Weight"
//                 value={opt.weight || ""}
//                 onChange={(e) =>
//                   setEditableOptions((prevOptions) =>
//                     prevOptions.map((o, i) =>
//                       i === index ? { ...o, weight: e.target.value } : o
//                     )
//                   )
//                 }
//                 style={{
//                   marginRight: "10px",
//                   width: "60px",
//                   border: "1px solid #6A6A6A",
//                   padding: "5px",
//                   // borderRadius: "4px",
//                 }}
//               />
//               <div
//                 contentEditable
//                 ref={(el) => (refs.current[index] = { current: el })}
//                 onFocus={() => setFocusedOption(opt.id)}
//                 onInput={() => handleOptionInput(index)}
//                 onPaste={(e) => handlePaste(e, opt.id)}
//                 style={{
//                   border: "1px solid #6A6A6A",
//                   padding: "10px",
//                   minHeight: "40px",
//                   width: "100%",
//                   backgroundColor: "#fff",
//                   // borderRadius: "5px",
//                   paddingTop: "25px",
//                 }}
//                 dangerouslySetInnerHTML={{
//                   __html: processTextSecond(opt.content || ""),
//                 }}
//               ></div>
//               {renderActionButtons(index, opt.id)}
//             </div>
//             <div style={{ textAlign: "right", marginTop: "10px" }}>
//               {index === editableOptions.length - 1 &&
//                 focusedOption === opt.id && (
//                   <img
//                     onClick={handleAddOption}
//                     src={YellowPlus}
//                     alt="Option_Add"
//                     className="YellowPlus-RC-Button"
//                   />
//                 )}
//             </div>
//           </div>
//         ));
//       case "fill-in-blanks":
//         return (
//           <div style={{ position: "relative" }}>
//             <div
//               contentEditable
//               ref={(el) => (refs.current[0] = { current: el })}
//               onFocus={() => setFocusedOption(editableOptions[0]?.id || 1)}
//               onInput={() => handleInput(editableOptions[0]?.id || 1)}
//               onPaste={(e) => handlePaste(e, editableOptions[0]?.id || 1)}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "10px",
//                 minHeight: "40px",
//                 width: "100%",
//                 backgroundColor: "#fff",
//                 // borderRadius: "5px",
//                 paddingTop: "25px",
//               }}
//               dangerouslySetInnerHTML={{
//                 __html: editableOptions[0]?.content,
//               }}
//             ></div>

//             {/* Action Buttons */}
//             {renderActionButtons(0, editableOptions[0]?.id || 1)}
//           </div>
//         );

//       case "boolean":
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="true" />
//               <span style={{ marginLeft: "10px" }}>True</span>
//             </label>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="false" />
//               <span style={{ marginLeft: "10px" }}>False</span>
//             </label>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   useEffect(() => {
//     if (hasCounterChanged) {
//     } else {
//       setHasCounterChanged(true); // Mark the initial render
//     }
//   }, [questionCounter]);

//   useEffect(() => {
//     if (questionText !== content) {
//       setContent(questionText);
//     }
//   }, [questionText]);

//   const processTextSecond = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     return text;
//   };

//   const processText = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     // Render LaTeX expressions
//     const latexRegex = /\\\((.*?)\\\)/g;
//     text = text.replace(latexRegex, (match, p1) => {
//       return katex.renderToString(p1, { throwOnError: false });
//     });

//     return text;
//   };

//   const handleOptionInput = (index) => {
//     console.log("Handling input for option:", index);

//     // Ensure the ref exists for the current option
//     const ref = refs.current[index]?.current;
//     if (!ref) {
//       console.warn(`No ref found for option at index: ${index}`);
//       return;
//     }

//     // Get the current content of the editable div

//     // Update the state for the editable option
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: contentHTML } : option
//       )
//     );

//     // Save cursor position
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Get current content from the editable div
//     const contentHTML = ref.innerHTML.trim();
//     console.log(`Content for option ${index}:`, contentHTML);

//     // Use the dedicated function to update editableOptions
//     handleOptionContentUpdate(index, contentHTML);

//     // Restore cursor position after DOM update
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function restoreCursor(node) {
//         if (node.nodeType === 3) {
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (restoreCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }

//       restoreCursor(ref);
//     }, 0);
//   };

//   // const renderRightOptions = () => {
//   //   return editableOptions.map((opt, index) => (
//   //     <div
//   //       key={opt.id}
//   //       style={{
//   //         marginBottom: "10px",
//   //         padding: "10px",
//   //         border: "1px solid #ddd",
//   //       }}
//   //     >
//   //    <strong>Option {index + 1}:</strong>
//   //       <span><input type="checkbox" /></span>
//   //       <div
//   //         style={{ padding: "5px" }}
//   //         dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
//   //       ></div>
//   //     </div>
//   //   ));
//   // };
//   const renderRightOptions = () => {
//     return editableOptions.map((opt, index) => (
//       <div
//         key={opt.id}
//         style={{
//           marginBottom: "10px",
//           padding: "10px",
//           display: "flex",
//           alignItems: "flex-start",
//           gap: "10px",
//         }}
//       >
//         <input
//           type="checkbox"
//           style={{
//             marginTop: "5px",
//             flexShrink: 0,
//           }}
//         />
//         <div
//           style={{
//             padding: "5px",
//             flex: 1,
//           }}
//           dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
//         />
//       </div>
//     ));
//   };

//   const handleOptionContentUpdate = (index, newContent) => {
//     console.log(`Updating content for option ${index}:`, newContent);
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: newContent } : option
//       )
//     );
//   };

//   console.log(content + "contetn");
//   console.log(htmlContent + "htmlContent");
//   console.log("Editable Options:", JSON.stringify(editableOptions, null, 2));
//   useEffect(() => {
//     console.log("htmlContent updated:", htmlContent);
//     console.log("Editable options updated:", editableOptions);
//   }, [htmlContent, editableOptions]);
//   console.log("Refs after rendering:", refs.current);
//   useEffect(() => {
//     console.log("Updated editableOptions:", editableOptions);
//   }, [editableOptions]);
//   useEffect(() => {
//     console.log("Refs after rendering:", refs.current);
//   }, [editableOptions]);

//   return (
//     <div
//       style={{
//         position: "relative",
//         width,
//         height,
//         backgroundColor: "#FBFBFB",
//         padding: "10px",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           width: "100%",
//           gap: "20px",
//           userSelect: isDragging ? "none" : "auto",
//         }}
//         ref={containerRef}
//       >
//         {/* Left Section */}
//         <div style={{ width: `${dividerPosition}%` }}>
//           {/* Main editable div */}
//           {/* <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginTop: "15px",
//               color: "#2F2E40",
//               marginBottom: "20px",
//             }}
//           > */}
//           {/* <h3 className="Question-background-match">Question : {quesNo}</h3> */}
//           {/* </div> */}

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text :
//           </p>
//           <div style={{ position: "relative" }}>
//             {/* Main ContentEditable Div */}
//             <div
//               contentEditable
//               ref={mainEditableRef}
//               onFocus={() => setFocusedOption("main")}
//               onInput={() => handleInput("main")}
//               onPaste={(e) => handlePaste(e, "main")}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "22px 10px 10px", // top, left/right, bottom
//                 marginBottom: "20px",
//                 minHeight: "100px",
//                 backgroundColor: "white",
//               }}
//               dangerouslySetInnerHTML={{ __html: processTextSecond(content) }}
//             ></div>

//             {/* Formula Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "110px",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowModal(true)}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt="Formula"
//               />
//             </div>

//             {/* Image Upload Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "70px",
//                 cursor: "pointer",
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt="Image Icon"
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileSelect(e, "main")}
//               />
//             </div>

//             {/* Recording Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "30px",
//                 cursor: "pointer",
//               }}
//               onClick={() => toggleSpeechToText("main")}
//             >
//               <img
//                 style={{
//                   height: "18px",
//                   width: "17px",
//                   animation: isRecording ? "blink 1s infinite" : "none",
//                 }}
//                 src={isRecording ? RecordingActive : RecordingStatic}
//                 alt="Recording Icon"
//               />
//             </div>
//           </div>

//           {/* Additional buttons */}
//           {renderOptions()}
//         </div>

//         {/* Draggable divider */}
//         <div
//           style={{
//             position: "relative",
//             cursor: "col-resize",
//             width: "10px",
//             margin: "0 -5px",
//             zIndex: 20,
//           }}
//           onMouseDown={handleMouseDown}
//         >
//           <div
//             style={{
//               marginTop: "5vh",
//               position: "absolute",
//               top: 0,
//               bottom: 0,
//               left: "50%",
//               borderLeft: "2px dotted #ccc",
//               height: "87%",
//             }}
//           >
//             {/* Triangle pointer */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 right: "-6px",
//                 width: 0,
//                 height: 0,
//                 borderTop: "6px solid transparent",
//                 borderBottom: "6px solid transparent",
//                 borderLeft: "6px solid #ccc",
//                 transform: "translateY(-50%)",
//               }}
//             />
//           </div>
//         </div>

//         {/* Right side with options */}

//         {/* Right Section */}

//         <div style={{ width: `${100 - dividerPosition}%` }}>
//           <p style={{ marginTop: "2.2vh" }}>Preview :</p>

//           <div
//             style={{
//               width: "100%",
//               border: "1px solid #ccc",
//               padding: "10px",
//               backgroundColor: "white",
//               minHeight: "100px",
//               whiteSpace: "pre-wrap",
//               marginTop: "1vh",
//             }}
//           >
//             <div>
//               <strong style={{ paddingBottom: "15px", paddingTop: "8px" }}>
//                 Question:
//               </strong>
//               <div
//                 style={{ padding: "8px" }}
//                 dangerouslySetInnerHTML={{
//                   __html: processText(content),
//                 }}
//               ></div>
//             </div>
//             <div>{renderRightOptions()}</div>
//           </div>
//         </div>
//       </div>

//       <Modal show={showModal} onClose={() => setShowModal(false)}>
//         <h2 style={{ color: "white" }}>MathLive Input</h2>
//         <MathLive onLatexChange={handleLatexChange} />
//         <button
//           onClick={sendToTextBox}
//           style={{ marginTop: "10px", cursor: "pointer" }}
//         >
//           Send to Text Box
//         </button>
//       </Modal>
//     </div>
//   );
// };

// export default React.memo(TextboxWithImageSecond);

// import React, { useState, useRef, useEffect } from "react";
// import Modal from "../../POP/Modal"; // Import the modal component
// import MathLive from "../../POP/FileComp7"; // Import MathLive component
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
// import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";
// import DeleteBin from "../../../Assets/Images/CommanImages/Delete.png";
// const TextboxWithImageSecond = ({
//   width = "100%",
//   height = "auto",
//   htmlContent,
//   questionCounter,
//   currentQuestion,
//   questionText,
//   optionFromAnotherPage,
//   quesType,
//   quesNo,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) => {
//   const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
//   const recognitionRef = useRef(null); // Ref for the speech recognition object
//   const contentEditableRef = useRef(null);
//   const [images, setImages] = useState([]); // Stores actual image files
//   const [showModal, setShowModal] = useState(false); // Modal state
//   const [latex, setLatex] = useState(""); // MathLive LaTeX content state
//   const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
//   const [isClicked, setIsClicked] = useState(false);
//   const fileInputRef = useRef(null); // Ref for the hidden file input
//   const [questionType, setQuestionType] = useState("multi-select"); // Tracks question type0
//   const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
//   const [hasCounterChanged, setHasCounterChanged] = useState(false);
//   const [checkedOptions, setCheckedOptions] = useState({});
//   const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)
//   const [initialOptions, setInitialOptions] = useState([]); // Store the initial options
//   const [content, setContent] = useState(htmlContent || "");
//   const [isDragging, setIsDragging] = useState(false);
//   const [dividerPosition, setDividerPosition] = useState(50);
//   const containerRef = useRef(null);
//   const [editableOptions, setEditableOptions] = useState(
//     optionFromAnotherPage?.map((opt) => ({
//       ...opt,
//       id: opt.option_no,
//       content: opt.option_text,
//       isChecked: opt.option_correct_flag === 1,
//     })) || []
//   );

//   const handleCheckboxChange = (index) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((opt, idx) => ({
//         ...opt,
//         isChecked: idx === index ? !opt.isChecked : opt.isChecked,
//         option_correct_flag:
//           idx === index ? (opt.isChecked ? 0 : 1) : opt.option_correct_flag,
//       }))
//     );
//   };

//   const handleMouseDown = () => {
//     setIsDragging(true);
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging && containerRef.current) {
//       const containerRect = containerRef.current.getBoundingClientRect();
//       const newPosition =
//         ((e.clientX - containerRect.left) / containerRect.width) * 100;
//       setDividerPosition(Math.min(Math.max(newPosition, 20), 80));
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   useEffect(() => {
//     if (isDragging) {
//       document.addEventListener("mousemove", handleMouseMove);
//       document.addEventListener("mouseup", handleMouseUp);
//     }
//     return () => {
//       document.removeEventListener("mousemove", handleMouseMove);
//       document.removeEventListener("mouseup", handleMouseUp);
//     };
//   }, [isDragging]);

//   useEffect(() => {
//     const mapQuesTypeToQuestionType = {
//       1: "multi-select",
//       2: "multi-select",
//       3: "fill-in-blanks",
//       4: "boolean",
//     };
//     const initialQuestionType =
//       mapQuesTypeToQuestionType[quesType] || "multi-select";
//     setQuestionType(initialQuestionType);
//   }, [quesType]);

//   const mainEditableRef = useRef(null);
//   const refs = useRef([]); // Refs for all editable options

//   useEffect(() => {
//     if (optionFromAnotherPage && optionFromAnotherPage.length > 0) {
//       // Save initial options
//       setInitialOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           ...opt,
//           id: opt.id || index + 1,
//         }))
//       );

//       // Create editable options
//       setEditableOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           id: opt.id || index + 1,
//           content: opt.option_text || "",
//         }))
//       );
//     }
//   }, [optionFromAnotherPage]);

//   // Populate refs dynamically for all options
//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   useEffect(() => {
//     if (htmlContent !== content) {
//       setContent(htmlContent);
//     }
//   }, [htmlContent]);
//   const renderLatexToHTML = (text) => {
//     try {
//       let html = text;

//       // Replace LaTeX
//       html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//           displayMode: true,
//         })
//       );

//       html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//         })
//       );

//       // Replace image placeholders with actual images
//       images.forEach((image) => {
//         const placeholder = `[${image.id}_${image.alt}]`;
//         const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
//         html = html.replace(placeholder, imgTag);
//       });

//       return html;
//     } catch (error) {
//       console.error("Error rendering HTML:", error);
//       return text;
//     }
//   };
//   const handleDeleteOption = (id) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.filter((option) => option.id !== id)
//     );
//   };

//   const handleInput = (id = "main") => {
//     const ref =
//       id === "main"
//         ? mainEditableRef.current
//         : refs.current.find((r, i) => i + 1 === id)?.current;

//     if (!ref) {
//       console.warn(`No ref found for id: ${id}`);
//       return;
//     }

//     // Save current selection (cursor position)
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Update content state
//     const contentHTML = ref.innerHTML.trim();
//     if (id === "main") {
//       console.log("questionEditing");
//       setContent(contentHTML);
//     } else {
//       console.log("optEditing", id);
//       setEditableOptions((prevOptions) =>
//         prevOptions.map((option) =>
//           option.id === id ? { ...option, content: contentHTML } : option
//         )
//       );
//     }

//     // Restore cursor position after the DOM updates
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function setCursor(node) {
//         if (node.nodeType === 3) {
//           // Text node
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (setCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }
//       setCursor(ref);
//     }, 0);
//   };

//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   const startSpeechToText = () => {
//     if (
//       !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
//     ) {
//       alert("Speech-to-text is not supported in this browser.");
//       return;
//     }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!recognitionRef.current) {
//       const recognition = new SpeechRecognition();
//       recognition.lang = "en-US";
//       recognition.interimResults = true;
//       recognition.continuous = true;

//       recognition.onstart = () => setIsRecording(true);

//       recognition.onresult = (event) => {
//         const mainDiv = mainEditableRef.current; // Main contentEditable div
//         const selection = window.getSelection();
//         const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

//         for (let i = event.resultIndex; i < event.results.length; i++) {
//           const transcript = event.results[i][0].transcript;

//           if (event.results[i].isFinal) {
//             const textNode = document.createTextNode(transcript + " ");
//             if (range) {
//               range.deleteContents();
//               range.insertNode(textNode);
//               range.setStartAfter(textNode);
//               range.setEndAfter(textNode);
//               selection.removeAllRanges();
//               selection.addRange(range);
//             } else {
//               mainDiv.appendChild(textNode);
//             }
//             handleInput("main"); // Update state after inserting speech text
//           }
//         }
//       };

//       recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error);
//         setIsRecording(false);
//       };

//       recognition.onend = () => setIsRecording(false);

//       recognitionRef.current = recognition;
//     }

//     recognitionRef.current.start();
//   };

//   const stopSpeechToText = () => {
//     if (recognitionRef.current) {
//       recognitionRef.current.stop();
//       setIsRecording(false);
//     }
//   };
//   const toggleSpeechToText = () => {
//     if (isRecording) {
//       stopSpeechToText();
//     } else {
//       startSpeechToText();
//     }
//   };
//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const img = document.createElement("img");
//         img.src = event.target.result;
//         img.alt = file.name || "selected-image";
//         img.classList.add("inserted-image"); // Add the CSS class

//         // Insert image at the current cursor position
//         const selection = window.getSelection();
//         const range = selection.getRangeAt(0);
//         range.deleteContents();
//         range.insertNode(img);

//         handleInput();
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleAddOption = () => {
//     const newOption = {
//       id: editableOptions.length + 1,
//       content: "",
//       weight: "",
//     };
//     setEditableOptions([...editableOptions, newOption]);
//   };

//   const handlePaste = (e, id = "main") => {
//     e.preventDefault();
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const items = e.clipboardData.items;

//     for (let item of items) {
//       if (item.type.startsWith("image/")) {
//         const blob = item.getAsFile();
//         const imageId = images.length + 1; // Assign serial number
//         const imageName = blob.name || `pasted-image-${imageId}`;

//         // Create a placeholder text for the image
//         const placeholderText = `[${imageId}_${imageName}]`;

//         // Insert placeholder text in the editable div
//         document.execCommand("insertText", false, placeholderText);

//         // Read and store the actual image for rendering
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImages((prevImages) => [
//             ...prevImages,
//             { id: imageId, src: event.target.result, alt: imageName },
//           ]);
//         };
//         reader.readAsDataURL(blob);

//         handleInput(id);
//       } else if (item.type === "text/plain") {
//         const text = e.clipboardData.getData("text/plain");
//         document.execCommand("insertText", false, text);
//         handleInput(id);
//       }
//     }
//   };

//   const handleLatexChange = (newLatex) => {
//     setLatex(newLatex);
//   };

//   const sendToTextBox = () => {
//     const mathLatex = `\\(${latex}\\)`;

//     if (focusedOption === "main") {
//       // Append to main editable div
//       if (mainEditableRef.current) {
//         mainEditableRef.current.innerHTML += mathLatex;
//         handleInput("main"); // Update the state
//       }
//     } else {
//       // Append to specific option
//       const focusedRef = refs.current.find(
//         (ref, index) => ref.current && index + 1 === focusedOption
//       )?.current;
//       if (focusedRef) {
//         focusedRef.innerHTML += mathLatex;
//         handleInput(focusedOption); // Update the state for the specific option
//       }
//     }

//     setShowModal(false); // Close the modal
//   };

//   const fileInputRefs = useRef([]); // File input refs for each option
//   const renderActionButtons = (index, id) => {
//     return (
//       focusedOption === id && (
//         <>
//           {/* Formula Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "110px",
//               cursor: "pointer",
//             }}
//             onClick={() => setShowModal(true)}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>

//           {/* Image Upload Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "70px",
//               cursor: "pointer",
//             }}
//             onClick={() => fileInputRefs.current[index].click()}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image Icon"
//             />
//             <input
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[index] = el)}
//               style={{ display: "none" }}
//               onChange={(e) => handleFileSelect(e, id)}
//             />
//           </div>

//           {/* Recording Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "30px",
//               cursor: "pointer",
//             }}
//             onClick={() => toggleSpeechToText(id)}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//                 animation: isRecording ? "blink 1s infinite" : "none",
//               }}
//               src={isRecording ? RecordingActive : RecordingStatic}
//               alt="Recording Icon"
//             />
//           </div>

//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "150px",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//               }}
//               onClick={() => handleDeleteOption(id)} // Call delete handler
//               src={DeleteBin}
//               alt="DeleteBin"
//             />
//           </div>
//         </>
//       )
//     );
//   };
//   const renderOptions = () => {
//     switch (questionType) {
//       case "multi-select":
//         return editableOptions.map((opt, index) => (
//           <div
//             key={opt.id || index}
//             style={{
//               display: "flex",
//               flexDirection: "column", // Ensure elements are stacked vertically
//               marginBottom: "10px",
//               position: "relative",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center" }}>

//               <input
//                 type="checkbox"
//                 checked={opt.isChecked}
//                 onChange={() => handleCheckboxChange(index)}
//                 style={{
//                   marginRight: "10px",
//                   cursor: "pointer",
//                   accentColor: "##D6D6D6",
//                 }}
//               />

//               <input
//                 type="number"
//                 placeholder="Weight"
//                 value={opt.weight || ""}
//                 onChange={(e) =>
//                   setEditableOptions((prevOptions) =>
//                     prevOptions.map((o, i) =>
//                       i === index ? { ...o, weight: e.target.value } : o
//                     )
//                   )
//                 }
//                 style={{
//                   marginRight: "10px",
//                   width: "60px",
//                   border: "1px solid #6A6A6A",
//                   padding: "5px",
//                 }}
//               />
//               <div
//                 contentEditable
//                 ref={(el) => (refs.current[index] = { current: el })}
//                 onFocus={() => setFocusedOption(opt.id)}
//                 onInput={() => handleOptionInput(index)}
//                 onPaste={(e) => handlePaste(e, opt.id)}
//                 style={{
//                   border: "1px solid #6A6A6A",
//                   padding: "10px",
//                   minHeight: "40px",
//                   width: "100%",
//                   backgroundColor: "#fff",
//                   paddingTop: "25px",
//                 }}
//                 dangerouslySetInnerHTML={{
//                   __html: processTextSecond(opt.content || ""),
//                 }}
//               ></div>
//               {renderActionButtons(index, opt.id)}
//             </div>
//             <div style={{ textAlign: "right", marginTop: "10px" }}>
//               {index === editableOptions.length - 1 &&
//                 focusedOption === opt.id && (
//                   <img
//                     onClick={handleAddOption}
//                     src={YellowPlus}
//                     alt="Option_Add"
//                     className="YellowPlus-RC-Button"
//                   />
//                 )}
//             </div>
//           </div>
//         ));
//       case "fill-in-blanks":
//         return (
//           <div style={{ position: "relative" }}>
//             <div
//               contentEditable
//               ref={(el) => (refs.current[0] = { current: el })}
//               onFocus={() => setFocusedOption(editableOptions[0]?.id || 1)}
//               onInput={() => handleInput(editableOptions[0]?.id || 1)}
//               onPaste={(e) => handlePaste(e, editableOptions[0]?.id || 1)}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "10px",
//                 minHeight: "40px",
//                 width: "100%",
//                 backgroundColor: "#fff",
//                 paddingTop: "25px",
//               }}
//               dangerouslySetInnerHTML={{
//                 __html: editableOptions[0]?.content,
//               }}
//             ></div>

//             {/* Action Buttons */}
//             {renderActionButtons(0, editableOptions[0]?.id || 1)}
//           </div>
//         );

//       case "boolean":
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="true" />
//               <span style={{ marginLeft: "10px" }}>True</span>
//             </label>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="false" />
//               <span style={{ marginLeft: "10px" }}>False</span>
//             </label>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   useEffect(() => {
//     if (hasCounterChanged) {
//     } else {
//       setHasCounterChanged(true); // Mark the initial render
//     }
//   }, [questionCounter]);

//   useEffect(() => {
//     if (questionText !== content) {
//       setContent(questionText);
//     }
//   }, [questionText]);

//   const processTextSecond = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     return text;
//   };

//   const processText = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     // Render LaTeX expressions
//     const latexRegex = /\\\((.*?)\\\)/g;
//     text = text.replace(latexRegex, (match, p1) => {
//       return katex.renderToString(p1, { throwOnError: false });
//     });

//     return text;
//   };

//   const handleOptionInput = (index) => {
//     console.log("Handling input for option:", index);

//     // Ensure the ref exists for the current option
//     const ref = refs.current[index]?.current;
//     if (!ref) {
//       console.warn(`No ref found for option at index: ${index}`);
//       return;
//     }

//     // Get the current content of the editable div

//     // Update the state for the editable option
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: contentHTML } : option
//       )
//     );

//     // Save cursor position
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Get current content from the editable div
//     const contentHTML = ref.innerHTML.trim();
//     console.log(`Content for option ${index}:`, contentHTML);

//     // Use the dedicated function to update editableOptions
//     handleOptionContentUpdate(index, contentHTML);

//     // Restore cursor position after DOM update
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function restoreCursor(node) {
//         if (node.nodeType === 3) {
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (restoreCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }

//       restoreCursor(ref);
//     }, 0);
//   };

//   const renderRightOptions = () => {
//     return editableOptions.map((opt, index) => (
//       <div
//         key={opt.id}
//         style={{
//           marginBottom: "10px",
//           padding: "10px",
//           display: "flex",
//           alignItems: "flex-start",
//           gap: "10px",
//         }}
//       >
//         <input
//           type="checkbox"
//           style={{
//             marginTop: "5px",
//             flexShrink: 0,
//           }}
//         />
//         <div
//           style={{
//             padding: "5px",
//             flex: 1,
//           }}
//           dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
//         />
//       </div>
//     ));
//   };

//   const handleOptionContentUpdate = (index, newContent) => {
//     console.log(`Updating content for option ${index}:`, newContent);
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: newContent } : option
//       )
//     );
//   };

//   console.log(content + "contetn");
//   console.log(htmlContent + "htmlContent");
//   console.log("Editable Options:", JSON.stringify(editableOptions, null, 2));
//   useEffect(() => {
//     console.log("htmlContent updated:", htmlContent);
//     console.log("Editable options updated:", editableOptions);
//   }, [htmlContent, editableOptions]);
//   console.log("Refs after rendering:", refs.current);
//   useEffect(() => {
//     console.log("Updated editableOptions:", editableOptions);
//   }, [editableOptions]);
//   useEffect(() => {
//     console.log("Refs after rendering:", refs.current);
//   }, [editableOptions]);

//   return (
//     <div
//       style={{
//         position: "relative",
//         width,
//         height,
//         backgroundColor: "#FBFBFB",
//         padding: "10px",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           width: "100%",
//           gap: "20px",
//           userSelect: isDragging ? "none" : "auto",
//         }}
//         ref={containerRef}
//       >
//         {/* Left Section */}
//         <div style={{ width: `${dividerPosition}%` }}>
//           {/* Main editable div */}

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text :
//           </p>
//           <div style={{ position: "relative" }}>
//             {/* Main ContentEditable Div */}
//             <div
//               contentEditable
//               ref={mainEditableRef}
//               onFocus={() => setFocusedOption("main")}
//               onInput={() => handleInput("main")}
//               onPaste={(e) => handlePaste(e, "main")}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "22px 10px 10px", // top, left/right, bottom
//                 marginBottom: "20px",
//                 minHeight: "100px",
//                 backgroundColor: "white",
//               }}
//               dangerouslySetInnerHTML={{ __html: processTextSecond(content) }}
//             ></div>

//             {/* Formula Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "110px",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowModal(true)}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt="Formula"
//               />
//             </div>

//             {/* Image Upload Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "70px",
//                 cursor: "pointer",
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt="Image Icon"
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileSelect(e, "main")}
//               />
//             </div>

//             {/* Recording Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "30px",
//                 cursor: "pointer",
//               }}
//               onClick={() => toggleSpeechToText("main")}
//             >
//               <img
//                 style={{
//                   height: "18px",
//                   width: "17px",
//                   animation: isRecording ? "blink 1s infinite" : "none",
//                 }}
//                 src={isRecording ? RecordingActive : RecordingStatic}
//                 alt="Recording Icon"
//               />
//             </div>
//           </div>

//           {/* Additional buttons */}
//           {renderOptions()}
//         </div>

//         {/* Draggable divider */}
//         <div
//           style={{
//             position: "relative",
//             cursor: "col-resize",
//             width: "10px",
//             margin: "0 -5px",
//             zIndex: 20,
//           }}
//           onMouseDown={handleMouseDown}
//         >
//           <div
//             style={{
//               marginTop: "5vh",
//               position: "absolute",
//               top: 0,
//               bottom: 0,
//               left: "50%",
//               borderLeft: "2px dotted #ccc",
//               height: "87%",
//             }}
//           >
//             {/* Triangle pointer */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 right: "-6px",
//                 width: 0,
//                 height: 0,
//                 borderTop: "6px solid transparent",
//                 borderBottom: "6px solid transparent",
//                 borderLeft: "6px solid #ccc",
//                 transform: "translateY(-50%)",
//               }}
//             />
//           </div>
//         </div>

//         {/* Right side with options */}

//         {/* Right Section */}

//         <div style={{ width: `${100 - dividerPosition}%` }}>
//           <p style={{ marginTop: "2.2vh" }}>Preview :</p>

//           <div
//             style={{
//               width: "100%",
//               border: "1px solid #ccc",
//               padding: "10px",
//               backgroundColor: "white",
//               minHeight: "100px",
//               whiteSpace: "pre-wrap",
//               marginTop: "1vh",
//             }}
//           >
//             <div>
//               <strong style={{ paddingBottom: "15px", paddingTop: "8px" }}>
//                 Question:
//               </strong>
//               <div
//                 style={{ padding: "8px" }}
//                 dangerouslySetInnerHTML={{
//                   __html: processText(content),
//                 }}
//               ></div>
//             </div>
//             <div>{renderRightOptions()}</div>
//           </div>
//         </div>
//       </div>

//       <Modal show={showModal} onClose={() => setShowModal(false)}>
//         <h2 style={{ color: "white" }}>MathLive Input</h2>
//         <MathLive onLatexChange={handleLatexChange} />
//         <button
//           onClick={sendToTextBox}
//           style={{ marginTop: "10px", cursor: "pointer" }}
//         >
//           Send to Text Box
//         </button>
//       </Modal>
//     </div>
//   );
// };

// export default React.memo(TextboxWithImageSecond);

// import React, { useState, useRef, useEffect } from "react";
// import Modal from "../../POP/Modal"; // Import the modal component
// import MathLive from "../../POP/FileComp7"; // Import MathLive component
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
// import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";
// import DeleteBin from "../../../Assets/Images/CommanImages/Delete.png";
// const ReviewComponent = ({
//   width = "100%",
//   height = "auto",
//   htmlContent,
//   questionCounter,
//   currentQuestion,
//   questionText,
//   optionFromAnotherPage,
//   quesType,
//   quesNo,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   onQuestionUpdate,
//   setCurrentQuestion,
//   fetchNewUpdatedDataValues
// }) => {
//   const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
//   const recognitionRef = useRef(null); // Ref for the speech recognition object
//   const contentEditableRef = useRef(null);
//   const [images, setImages] = useState([]); // Stores actual image files
//   const [showModal, setShowModal] = useState(false); // Modal state
//   const [latex, setLatex] = useState(""); // MathLive LaTeX content state
//   const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
//   const [isClicked, setIsClicked] = useState(false);
//   const fileInputRef = useRef(null); // Ref for the hidden file input
//   const [questionType, setQuestionType] = useState("multi-select"); // Tracks question type0
//   const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
//   const [hasCounterChanged, setHasCounterChanged] = useState(false);
//   const [checkedOptions, setCheckedOptions] = useState({});
//   const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)
//   const [initialOptions, setInitialOptions] = useState([]); // Store the initial options
//   const [content, setContent] = useState(htmlContent || "");
//   const [isDragging, setIsDragging] = useState(false);
//   const [dividerPosition, setDividerPosition] = useState(50);
//   const containerRef = useRef(null);
//   const [editableOptions, setEditableOptions] = useState(
//     optionFromAnotherPage?.map((opt) => ({
//       ...opt,
//       id: opt.option_no,
//       content: opt.option_text,
//       isChecked: opt.option_correct_flag === 1,
//     })) || []
//   );

//   const handleCheckboxChange = (index) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((opt, idx) => ({
//         ...opt,
//         isChecked: idx === index ? !opt.isChecked : opt.isChecked,
//         option_correct_flag:
//           idx === index ? (opt.isChecked ? 0 : 1) : opt.option_correct_flag,
//       }))
//     );
//   };

//   const handleMouseDown = () => {
//     setIsDragging(true);
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging && containerRef.current) {
//       const containerRect = containerRef.current.getBoundingClientRect();
//       const newPosition =
//         ((e.clientX - containerRect.left) / containerRect.width) * 100;
//       setDividerPosition(Math.min(Math.max(newPosition, 20), 80));
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   useEffect(() => {
//     if (isDragging) {
//       document.addEventListener("mousemove", handleMouseMove);
//       document.addEventListener("mouseup", handleMouseUp);
//     }
//     return () => {
//       document.removeEventListener("mousemove", handleMouseMove);
//       document.removeEventListener("mouseup", handleMouseUp);
//     };
//   }, [isDragging]);

//   useEffect(() => {
//     const mapQuesTypeToQuestionType = {
//       1: "multi-select",
//       2: "multi-select",
//       3: "fill-in-blanks",
//       4: "boolean",
//     };
//     const initialQuestionType =
//       mapQuesTypeToQuestionType[quesType] || "multi-select";
//     setQuestionType(initialQuestionType);
//   }, [quesType]);

//   const mainEditableRef = useRef(null);
//   const refs = useRef([]); // Refs for all editable options

//   useEffect(() => {
//     if (optionFromAnotherPage && optionFromAnotherPage.length > 0) {
//       // Save initial options
//       setInitialOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           ...opt,
//           id: opt.id || index + 1,
//         }))
//       );

//       // Create editable options
//       setEditableOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           id: opt.id || index + 1,
//           content: opt.option_text || "",
//         }))
//       );
//     }
//   }, [optionFromAnotherPage]);

//   // Populate refs dynamically for all options
//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   useEffect(() => {
//     if (htmlContent !== content) {
//       setContent(htmlContent);
//     }
//   }, [htmlContent]);
//   const renderLatexToHTML = (text) => {
//     try {
//       let html = text;

//       // Replace LaTeX
//       html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//           displayMode: true,
//         })
//       );

//       html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//         })
//       );

//       // Replace image placeholders with actual images
//       images.forEach((image) => {
//         const placeholder = `[${image.id}_${image.alt}]`;
//         const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
//         html = html.replace(placeholder, imgTag);
//       });

//       return html;
//     } catch (error) {
//       console.error("Error rendering HTML:", error);
//       return text;
//     }
//   };
//   const handleDeleteOption = (id) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.filter((option) => option.id !== id)
//     );
//   };

//   const handleInput = (id = "main") => {
//     const ref =
//       id === "main"
//         ? mainEditableRef.current
//         : refs.current.find((r, i) => i + 1 === id)?.current;

//     if (!ref) {
//       console.warn(`No ref found for id: ${id}`);
//       return;
//     }

//     // Save current selection (cursor position)
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Update content state
//     const contentHTML = ref.innerHTML.trim();
//     if (id === "main") {
//       console.log("questionEditing");
//       setContent(contentHTML);
//     } else {
//       console.log("optEditing", id);
//       setEditableOptions((prevOptions) =>
//         prevOptions.map((option) =>
//           option.id === id ? { ...option, content: contentHTML } : option
//         )
//       );
//     }

//     // Restore cursor position after the DOM updates
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function setCursor(node) {
//         if (node.nodeType === 3) {
//           // Text node
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (setCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }
//       setCursor(ref);
//     }, 0);
//   };

//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   const startSpeechToText = () => {
//     if (
//       !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
//     ) {
//       alert("Speech-to-text is not supported in this browser.");
//       return;
//     }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!recognitionRef.current) {
//       const recognition = new SpeechRecognition();
//       recognition.lang = "en-US";
//       recognition.interimResults = true;
//       recognition.continuous = true;

//       recognition.onstart = () => setIsRecording(true);

//       recognition.onresult = (event) => {
//         const mainDiv = mainEditableRef.current; // Main contentEditable div
//         const selection = window.getSelection();
//         const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

//         for (let i = event.resultIndex; i < event.results.length; i++) {
//           const transcript = event.results[i][0].transcript;

//           if (event.results[i].isFinal) {
//             const textNode = document.createTextNode(transcript + " ");
//             if (range) {
//               range.deleteContents();
//               range.insertNode(textNode);
//               range.setStartAfter(textNode);
//               range.setEndAfter(textNode);
//               selection.removeAllRanges();
//               selection.addRange(range);
//             } else {
//               mainDiv.appendChild(textNode);
//             }
//             handleInput("main"); // Update state after inserting speech text
//           }
//         }
//       };

//       recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error);
//         setIsRecording(false);
//       };

//       recognition.onend = () => setIsRecording(false);

//       recognitionRef.current = recognition;
//     }

//     recognitionRef.current.start();
//   };

//   const stopSpeechToText = () => {
//     if (recognitionRef.current) {
//       recognitionRef.current.stop();
//       setIsRecording(false);
//     }
//   };
//   const toggleSpeechToText = () => {
//     if (isRecording) {
//       stopSpeechToText();
//     } else {
//       startSpeechToText();
//     }
//   };
//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const img = document.createElement("img");
//         img.src = event.target.result;
//         img.alt = file.name || "selected-image";
//         img.classList.add("inserted-image"); // Add the CSS class

//         // Insert image at the current cursor position
//         const selection = window.getSelection();
//         const range = selection.getRangeAt(0);
//         range.deleteContents();
//         range.insertNode(img);

//         handleInput();
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleAddOption = () => {
//     const newOption = {
//       id: editableOptions.length + 1,
//       content: "",
//       weight: "",
//     };
//     setEditableOptions([...editableOptions, newOption]);
//   };

//   const handlePaste = (e, id = "main") => {
//     e.preventDefault();
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const items = e.clipboardData.items;

//     for (let item of items) {
//       if (item.type.startsWith("image/")) {
//         const blob = item.getAsFile();
//         const imageId = images.length + 1; // Assign serial number
//         const imageName = blob.name || `pasted-image-${imageId}`;

//         // Create a placeholder text for the image
//         const placeholderText = `[${imageId}_${imageName}]`;

//         // Insert placeholder text in the editable div
//         document.execCommand("insertText", false, placeholderText);

//         // Read and store the actual image for rendering
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImages((prevImages) => [
//             ...prevImages,
//             { id: imageId, src: event.target.result, alt: imageName },
//           ]);
//         };
//         reader.readAsDataURL(blob);

//         handleInput(id);
//       } else if (item.type === "text/plain") {
//         const text = e.clipboardData.getData("text/plain");
//         document.execCommand("insertText", false, text);
//         handleInput(id);
//       }
//     }
//   };

//   const handleLatexChange = (newLatex) => {
//     setLatex(newLatex);
//   };

//   const sendToTextBox = () => {
//     const mathLatex = `\\(${latex}\\)`;

//     if (focusedOption === "main") {
//       // Append to main editable div
//       if (mainEditableRef.current) {
//         mainEditableRef.current.innerHTML += mathLatex;
//         handleInput("main"); // Update the state
//       }
//     } else {
//       // Append to specific option
//       const focusedRef = refs.current.find(
//         (ref, index) => ref.current && index + 1 === focusedOption
//       )?.current;
//       if (focusedRef) {
//         focusedRef.innerHTML += mathLatex;
//         handleInput(focusedOption); // Update the state for the specific option
//       }
//     }

//     setShowModal(false); // Close the modal
//   };

//   const fileInputRefs = useRef([]); // File input refs for each option
//   const renderActionButtons = (index, id) => {
//     return (
//       focusedOption === id && (
//         <>
//           {/* Formula Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "110px",
//               cursor: "pointer",
//             }}
//             onClick={() => setShowModal(true)}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>

//           {/* Image Upload Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "70px",
//               cursor: "pointer",
//             }}
//             onClick={() => fileInputRefs.current[index].click()}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image Icon"
//             />
//             <input
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[index] = el)}
//               style={{ display: "none" }}
//               onChange={(e) => handleFileSelect(e, id)}
//             />
//           </div>

//           {/* Recording Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "30px",
//               cursor: "pointer",
//             }}
//             onClick={() => toggleSpeechToText(id)}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//                 animation: isRecording ? "blink 1s infinite" : "none",
//               }}
//               src={isRecording ? RecordingActive : RecordingStatic}
//               alt="Recording Icon"
//             />
//           </div>

//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "150px",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//               }}
//               onClick={() => handleDeleteOption(id)} // Call delete handler
//               src={DeleteBin}
//               alt="DeleteBin"
//             />
//           </div>
//         </>
//       )
//     );
//   };
//   const renderOptions = () => {
//     switch (questionType) {
//       case "multi-select":
//         return editableOptions.map((opt, index) => (
//           <div
//             key={opt.id || index}
//             style={{
//               display: "flex",
//               flexDirection: "column", // Ensure elements are stacked vertically
//               marginBottom: "10px",
//               position: "relative",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <input
//                 type="checkbox"
//                 checked={opt.isChecked}
//                 onChange={() => handleCheckboxChange(index)}
//                 style={{
//                   marginRight: "10px",
//                   cursor: "pointer",
//                   accentColor: "##D6D6D6",
//                 }}
//               />

//               <input
//                 type="number"
//                 placeholder="Weight"
//                 value={opt.weight || ""}
//                 onChange={(e) =>
//                   setEditableOptions((prevOptions) =>
//                     prevOptions.map((o, i) =>
//                       i === index ? { ...o, weight: e.target.value } : o
//                     )
//                   )
//                 }
//                 style={{
//                   marginRight: "10px",
//                   width: "60px",
//                   border: "1px solid #6A6A6A",
//                   padding: "5px",
//                 }}
//               />
//               <div
//                 contentEditable
//                 ref={(el) => (refs.current[index] = { current: el })}
//                 onFocus={() => setFocusedOption(opt.id)}
//                 onInput={() => handleOptionInput(index)}
//                 onPaste={(e) => handlePaste(e, opt.id)}
//                 style={{
//                   border: "1px solid #6A6A6A",
//                   padding: "10px",
//                   minHeight: "40px",
//                   width: "100%",
//                   backgroundColor: "#fff",
//                   paddingTop: "25px",
//                 }}
//                 dangerouslySetInnerHTML={{
//                   __html: processTextSecond(opt.content || ""),
//                 }}
//               ></div>
//               {renderActionButtons(index, opt.id)}
//             </div>
//             <div style={{ textAlign: "right", marginTop: "10px" }}>
//               {index === editableOptions.length - 1 &&
//                 focusedOption === opt.id && (
//                   <img
//                     onClick={handleAddOption}
//                     src={YellowPlus}
//                     alt="Option_Add"
//                     className="YellowPlus-RC-Button"
//                   />
//                 )}
//             </div>
//           </div>
//         ));
//       case "fill-in-blanks":
//         return (
//           <div style={{ position: "relative" }}>
//             <div
//               contentEditable
//               ref={(el) => (refs.current[0] = { current: el })}
//               onFocus={() => setFocusedOption(editableOptions[0]?.id || 1)}
//               onInput={() => handleInput(editableOptions[0]?.id || 1)}
//               onPaste={(e) => handlePaste(e, editableOptions[0]?.id || 1)}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "10px",
//                 minHeight: "40px",
//                 width: "100%",
//                 backgroundColor: "#fff",
//                 paddingTop: "25px",
//               }}
//               dangerouslySetInnerHTML={{
//                 __html: editableOptions[0]?.content,
//               }}
//             ></div>

//             {/* Action Buttons */}
//             {renderActionButtons(0, editableOptions[0]?.id || 1)}
//           </div>
//         );

//       case "boolean":
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="true" />
//               <span style={{ marginLeft: "10px" }}>True</span>
//             </label>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="false" />
//               <span style={{ marginLeft: "10px" }}>False</span>
//             </label>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   useEffect(() => {
//     if (hasCounterChanged) {
//     } else {
//       setHasCounterChanged(true); // Mark the initial render
//     }
//   }, [questionCounter]);

//   useEffect(() => {
//     if (questionText !== content) {
//       setContent(questionText);
//     }
//   }, [questionText]);

//   const processTextSecond = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     return text;
//   };

//   const processText = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     // Render LaTeX expressions
//     const latexRegex = /\\\((.*?)\\\)/g;
//     text = text.replace(latexRegex, (match, p1) => {
//       return katex.renderToString(p1, { throwOnError: false });
//     });

//     return text;
//   };

//   const handleOptionInput = (index) => {
//     console.log("Handling input for option:", index);

//     // Ensure the ref exists for the current option
//     const ref = refs.current[index]?.current;
//     if (!ref) {
//       console.warn(`No ref found for option at index: ${index}`);
//       return;
//     }

//     // Get the current content of the editable div

//     // Update the state for the editable option
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: contentHTML } : option
//       )
//     );

//     // Save cursor position
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Get current content from the editable div
//     const contentHTML = ref.innerHTML.trim();
//     console.log(`Content for option ${index}:`, contentHTML);

//     // Use the dedicated function to update editableOptions
//     handleOptionContentUpdate(index, contentHTML);

//     // Restore cursor position after DOM update
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function restoreCursor(node) {
//         if (node.nodeType === 3) {
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (restoreCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }

//       restoreCursor(ref);
//     }, 0);
//   };

//   const renderRightOptions = () => {
//     return editableOptions.map((opt, index) => (
//       <div
//         key={opt.id}
//         style={{
//           marginBottom: "10px",
//           padding: "10px",
//           display: "flex",
//           alignItems: "flex-start",
//           gap: "10px",
//         }}
//       >
//         <input
//           type="checkbox"
//           style={{
//             marginTop: "5px",
//             flexShrink: 0,
//           }}
//         />
//         <div
//           style={{
//             padding: "5px",
//             flex: 1,
//           }}
//           dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
//         />
//       </div>
//     ));
//   };

//   const handleOptionContentUpdate = (index, newContent) => {
//     console.log(`Updating content for option ${index}:`, newContent);
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: newContent } : option
//       )
//     );
//   };

//   // useEffect(() => {
//   //   if (onQuestionUpdate) {
//   //     onQuestionUpdate({
//   //       question_text: content, // Pass updated question text
//   //       options: editableOptions.map((opt) => ({
//   //         option_no: opt.id,
//   //         option_text: opt.content, // Pass updated option text
//   //         option_correct_flag: opt.isChecked ? 1 : 0,
//   //       })),
//   //     });
//   //   }
//   // }, [content, editableOptions, onQuestionUpdate]);

//   useEffect(() => {
//     if (onQuestionUpdate) {
//       onQuestionUpdate({
//         question_text: questionText, // Updated question text
//         options: optionFromAnotherPage, // Updated options
//       });
//     }
//   }, [questionText, optionFromAnotherPage, onQuestionUpdate]);

//   // const handleQuestionEdit = (updatedData) => {
//   //   setCurrentQuestion((prevQuestion) => ({
//   //     ...prevQuestion,
//   //     question_text: updatedData.question_text,
//   //     options: updatedData.options,
//   //   }));
//   // };

//   // const handleFetchDataClick = () => {
//   //   const updatedData = fetchNewUpdatedDataValues();
//   //   console.log("Updated Data:", updatedData);
//   // };
//   const handleFetchAndUpdate = () => {
//     const updatedData = {
//       question_text: content,
//       options: editableOptions.map((opt) => ({
//         option_no: opt.id,
//         option_text: opt.content,
//         option_correct_flag: opt.isChecked ? 1 : 0,
//       })),
//     };
//     console.log("Updated Data:", updatedData);

//     if (fetchNewUpdatedDataValues) {
//       fetchNewUpdatedDataValues(updatedData); // Send updated data to parent

//     }

//   };

//   // Trigger handleFetchAndUpdate when content or options change
//   useEffect(() => {
//     handleFetchAndUpdate();
//   }, [content, editableOptions]);

//   // console.log(content + "contetn");
//   // console.log(htmlContent + "htmlContent");
//   // console.log("Editable Options:", JSON.stringify(editableOptions, null, 2));
//   // useEffect(() => {
//   //   console.log("htmlContent updated:", htmlContent);
//   //   console.log("Editable options updated:", editableOptions);
//   // }, [htmlContent, editableOptions]);
//   // console.log("Refs after rendering:", refs.current);
//   // useEffect(() => {
//   //   console.log("Updated editableOptions:", editableOptions);
//   // }, [editableOptions]);
//   // useEffect(() => {
//   //   console.log("Refs after rendering:", refs.current);
//   // }, [editableOptions]);

//   return (
//     <div
//       style={{
//         position: "relative",
//         width,
//         height,
//         backgroundColor: "#FBFBFB",
//         padding: "10px",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           width: "100%",
//           gap: "20px",
//           userSelect: isDragging ? "none" : "auto",
//         }}
//         ref={containerRef}
//       >
//         {/* Left Section */}
//         <div style={{ width: `${dividerPosition}%` }}>
//           {/* Main editable div */}

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text :
//           </p>
//           <div style={{ position: "relative" }}>
//             {/* Main ContentEditable Div */}
//             <div
//               contentEditable
//               ref={mainEditableRef}
//               onFocus={() => setFocusedOption("main")}
//               onInput={() => handleInput("main")}
//               onPaste={(e) => handlePaste(e, "main")}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "22px 10px 10px", // top, left/right, bottom
//                 marginBottom: "20px",
//                 minHeight: "100px",
//                 backgroundColor: "white",
//               }}
//               dangerouslySetInnerHTML={{ __html: processTextSecond(content) }}
//             ></div>

//             {/* Formula Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "110px",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowModal(true)}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt="Formula"
//               />
//             </div>

//             {/* Image Upload Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "70px",
//                 cursor: "pointer",
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt="Image Icon"
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileSelect(e, "main")}
//               />
//             </div>

//             {/* Recording Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "30px",
//                 cursor: "pointer",
//               }}
//               onClick={() => toggleSpeechToText("main")}
//             >
//               <img
//                 style={{
//                   height: "18px",
//                   width: "17px",
//                   animation: isRecording ? "blink 1s infinite" : "none",
//                 }}
//                 src={isRecording ? RecordingActive : RecordingStatic}
//                 alt="Recording Icon"
//               />
//             </div>
//           </div>

//           {/* Additional buttons */}
//           {renderOptions()}
//         </div>

//         {/* Draggable divider */}
//         <div
//           style={{
//             position: "relative",
//             cursor: "col-resize",
//             width: "10px",
//             margin: "0 -5px",
//             zIndex: 20,
//           }}
//           onMouseDown={handleMouseDown}
//         >
//           <div
//             style={{
//               marginTop: "5vh",
//               position: "absolute",
//               top: 0,
//               bottom: 0,
//               left: "50%",
//               borderLeft: "2px dotted #ccc",
//               height: "87%",
//             }}
//           >
//             {/* Triangle pointer */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 right: "-6px",
//                 width: 0,
//                 height: 0,
//                 borderTop: "6px solid transparent",
//                 borderBottom: "6px solid transparent",
//                 borderLeft: "6px solid #ccc",
//                 transform: "translateY(-50%)",
//               }}
//             />
//           </div>
//         </div>

//         {/* Right side with options */}

//         {/* Right Section */}

//         <div style={{ width: `${100 - dividerPosition}%` }}>
//           <p style={{ marginTop: "2.2vh" }}>Preview :</p>

//           <div
//             style={{
//               width: "100%",
//               border: "1px solid #ccc",
//               padding: "10px",
//               backgroundColor: "white",
//               minHeight: "100px",
//               whiteSpace: "pre-wrap",
//               marginTop: "1vh",
//             }}
//           >
//             <div>
//               <strong style={{ paddingBottom: "15px", paddingTop: "8px" }}>
//                 Question:
//               </strong>
//               <div
//                 style={{ padding: "8px" }}
//                 dangerouslySetInnerHTML={{
//                   __html: processText(content),
//                 }}
//               ></div>
//             </div>
//             <div>{renderRightOptions()}</div>
//           </div>
//         </div>
//       </div>

//       <Modal show={showModal} onClose={() => setShowModal(false)}>
//         <h2 style={{ color: "white" }}>MathLive Input</h2>
//         <MathLive onLatexChange={handleLatexChange} />
//         <button
//           onClick={sendToTextBox}
//           style={{ marginTop: "10px", cursor: "pointer" }}
//         >
//           Send to Text Box
//         </button>
//       </Modal>
//     </div>
//   );
// };

// export default React.memo(ReviewComponent);

// import React, { useState, useRef, useEffect } from "react";
// import Modal from "../../POP/Modal"; // Import the modal component
// import MathLive from "../../POP/FileComp7"; // Import MathLive component
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
// import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";
// import DeleteBin from "../../../Assets/Images/CommanImages/Delete.png";
// const ReviewComponent = ({
//   width = "100%",
//   height = "auto",
//   htmlContent,
//   questionCounter,
//   currentQuestion,
//   questionText,
//   optionFromAnotherPage,
//   quesType,
//   quesNo,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   onQuestionUpdate,
//   setCurrentQuestion,
//   fetchNewUpdatedDataValues,
// }) => {
//   const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
//   const recognitionRef = useRef(null); // Ref for the speech recognition object
//   const contentEditableRef = useRef(null);
//   const [images, setImages] = useState([]); // Stores actual image files
//   const [showModal, setShowModal] = useState(false); // Modal state
//   const [latex, setLatex] = useState(""); // MathLive LaTeX content state
//   const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
//   const [isClicked, setIsClicked] = useState(false);
//   const fileInputRef = useRef(null); // Ref for the hidden file input
//   const [questionType, setQuestionType] = useState("multi-select"); // Tracks question type0
//   const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
//   const [hasCounterChanged, setHasCounterChanged] = useState(false);
//   const [checkedOptions, setCheckedOptions] = useState({});
//   const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)
//   const [initialOptions, setInitialOptions] = useState([]); // Store the initial options
//   const [content, setContent] = useState(htmlContent || "");
//   const [isDragging, setIsDragging] = useState(false);
//   const [dividerPosition, setDividerPosition] = useState(50);
//   const containerRef = useRef(null);
//   const [editableOptions, setEditableOptions] = useState([]);

//   // const [editableOptions, setEditableOptions] = useState(
//   //   optionFromAnotherPage?.map((opt) => ({
//   //     ...opt,
//   //     id: opt.option_no,
//   //     content: opt.option_text,
//   //     isChecked: opt.option_correct_flag === 1,
//   //   })) || []
//   // );
//   useEffect(() => {
//     if (optionFromAnotherPage) {
//       const timer = setTimeout(() => {
//         setEditableOptions(
//           optionFromAnotherPage.map((opt) => ({
//             ...opt,
//             id: opt.option_no,
//             content: opt.option_text,
//             isChecked: opt.option_correct_flag === 1, // Delayed setting of isChecked
//           }))
//         );
//       }, 1500); // 2-second delay

//       // Clear timer if component unmounts or optionFromAnotherPage changes
//       return () => clearTimeout(timer);
//     }
//   }, [optionFromAnotherPage]);

//   const handleCheckboxChange = (index) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((opt, idx) => ({
//         ...opt,
//         isChecked: idx === index ? !opt.isChecked : opt.isChecked,
//         option_correct_flag:
//           idx === index ? (opt.isChecked ? 0 : 1) : opt.option_correct_flag,
//       }))
//     );
//   };

//   const handleMouseDown = () => {
//     setIsDragging(true);
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging && containerRef.current) {
//       const containerRect = containerRef.current.getBoundingClientRect();
//       const newPosition =
//         ((e.clientX - containerRect.left) / containerRect.width) * 100;
//       setDividerPosition(Math.min(Math.max(newPosition, 20), 80));
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   useEffect(() => {
//     if (isDragging) {
//       document.addEventListener("mousemove", handleMouseMove);
//       document.addEventListener("mouseup", handleMouseUp);
//     }
//     return () => {
//       document.removeEventListener("mousemove", handleMouseMove);
//       document.removeEventListener("mouseup", handleMouseUp);
//     };
//   }, [isDragging]);

//   useEffect(() => {
//     const mapQuesTypeToQuestionType = {
//       1: "multi-select",
//       2: "multi-select",
//       3: "fill-in-blanks",
//       4: "boolean",
//     };
//     const initialQuestionType =
//       mapQuesTypeToQuestionType[quesType] || "multi-select";
//     setQuestionType(initialQuestionType);
//   }, [quesType]);

//   const mainEditableRef = useRef(null);
//   const refs = useRef([]); // Refs for all editable options

//   useEffect(() => {
//     if (optionFromAnotherPage && optionFromAnotherPage.length > 0) {
//       // Save initial options
//       setInitialOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           ...opt,
//           id: opt.id || index + 1,
//         }))
//       );

//       // Create editable options
//       setEditableOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           id: opt.id || index + 1,
//           content: opt.option_text || "",
//         }))
//       );
//     }
//   }, [optionFromAnotherPage]);

//   // Populate refs dynamically for all options
//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   useEffect(() => {
//     if (htmlContent !== content) {
//       setContent(htmlContent);
//     }
//   }, [htmlContent]);
//   const renderLatexToHTML = (text) => {
//     try {
//       let html = text;

//       // Replace LaTeX
//       html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//           displayMode: true,
//         })
//       );

//       html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//         })
//       );

//       // Replace image placeholders with actual images
//       images.forEach((image) => {
//         const placeholder = `[${image.id}_${image.alt}]`;
//         const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
//         html = html.replace(placeholder, imgTag);
//       });

//       return html;
//     } catch (error) {
//       console.error("Error rendering HTML:", error);
//       return text;
//     }
//   };
//   const handleDeleteOption = (id) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.filter((option) => option.id !== id)
//     );
//   };

//   const handleInput = (id = "main") => {
//     const ref =
//       id === "main"
//         ? mainEditableRef.current
//         : refs.current.find((r, i) => i + 1 === id)?.current;

//     if (!ref) {
//       console.warn(`No ref found for id: ${id}`);
//       return;
//     }

//     // Save current selection (cursor position)
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Update content state
//     const contentHTML = ref.innerHTML.trim();
//     if (id === "main") {
//       console.log("questionEditing");
//       setContent(contentHTML);
//     } else {
//       console.log("optEditing", id);
//       setEditableOptions((prevOptions) =>
//         prevOptions.map((option) =>
//           option.id === id ? { ...option, content: contentHTML } : option
//         )
//       );
//     }

//     // Restore cursor position after the DOM updates
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function setCursor(node) {
//         if (node.nodeType === 3) {
//           // Text node
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (setCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }
//       setCursor(ref);
//     }, 0);
//   };

//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   const startSpeechToText = () => {
//     if (
//       !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
//     ) {
//       alert("Speech-to-text is not supported in this browser.");
//       return;
//     }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!recognitionRef.current) {
//       const recognition = new SpeechRecognition();
//       recognition.lang = "en-US";
//       recognition.interimResults = true;
//       recognition.continuous = true;

//       recognition.onstart = () => setIsRecording(true);

//       recognition.onresult = (event) => {
//         const mainDiv = mainEditableRef.current; // Main contentEditable div
//         const selection = window.getSelection();
//         const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

//         for (let i = event.resultIndex; i < event.results.length; i++) {
//           const transcript = event.results[i][0].transcript;

//           if (event.results[i].isFinal) {
//             const textNode = document.createTextNode(transcript + " ");
//             if (range) {
//               range.deleteContents();
//               range.insertNode(textNode);
//               range.setStartAfter(textNode);
//               range.setEndAfter(textNode);
//               selection.removeAllRanges();
//               selection.addRange(range);
//             } else {
//               mainDiv.appendChild(textNode);
//             }
//             handleInput("main"); // Update state after inserting speech text
//           }
//         }
//       };

//       recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error);
//         setIsRecording(false);
//       };

//       recognition.onend = () => setIsRecording(false);

//       recognitionRef.current = recognition;
//     }

//     recognitionRef.current.start();
//   };

//   const stopSpeechToText = () => {
//     if (recognitionRef.current) {
//       recognitionRef.current.stop();
//       setIsRecording(false);
//     }
//   };
//   const toggleSpeechToText = () => {
//     if (isRecording) {
//       stopSpeechToText();
//     } else {
//       startSpeechToText();
//     }
//   };

//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const img = document.createElement("img");
//         img.src = event.target.result;
//         img.alt = file.name || "selected-image";
//         img.classList.add("inserted-image"); // Add the CSS class

//         // Insert image at the current cursor position
//         const selection = window.getSelection();
//         const range = selection.getRangeAt(0);
//         range.deleteContents();
//         range.insertNode(img);

//         handleInput();
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // const handleFileSelect = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     const reader = new FileReader();
//   //     reader.onload = (event) => {
//   //       const imageName = `image${images.length + 1}.png`;
//   //       const imageTag = `#<${imageName}>#`;

//   //       // Insert the image tag at the current cursor position
//   //       const selection = window.getSelection();
//   //       const range = selection.getRangeAt(0);
//   //       range.deleteContents();
//   //       const textNode = document.createTextNode(imageTag);
//   //       range.insertNode(textNode);

//   //       // Add the image to the images list
//   //       setImages((prevImages) => [
//   //         ...prevImages,
//   //         { name: imageName, src: event.target.result },
//   //       ]);

//   //       handleInput();
//   //     };
//   //     reader.readAsDataURL(file);
//   //   }
//   // };

//   const handleAddOption = () => {
//     const newOption = {
//       id: editableOptions.length + 1,
//       content: "",
//       weight: "",
//     };
//     setEditableOptions([...editableOptions, newOption]);
//   };

//   const handlePaste = (e, id = "main") => {
//     e.preventDefault();
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const items = e.clipboardData.items;

//     for (let item of items) {
//       if (item.type.startsWith("image/")) {
//         const blob = item.getAsFile();
//         const imageId = images.length + 1; // Assign serial number
//         const imageName = blob.name || `pasted-image-${imageId}`;

//         // Create a placeholder text for the image
//         const placeholderText = `[${imageId}_${imageName}]`;

//         // Insert placeholder text in the editable div
//         document.execCommand("insertText", false, placeholderText);

//         // Read and store the actual image for rendering
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImages((prevImages) => [
//             ...prevImages,
//             { id: imageId, src: event.target.result, alt: imageName },
//           ]);
//         };
//         reader.readAsDataURL(blob);

//         handleInput(id);
//       } else if (item.type === "text/plain") {
//         const text = e.clipboardData.getData("text/plain");
//         document.execCommand("insertText", false, text);
//         handleInput(id);
//       }
//     }
//   };

//   const handleLatexChange = (newLatex) => {
//     setLatex(newLatex);
//   };

//   const sendToTextBox = () => {
//     const mathLatex = `\\(${latex}\\)`;

//     if (focusedOption === "main") {
//       // Append to main editable div
//       if (mainEditableRef.current) {
//         mainEditableRef.current.innerHTML += mathLatex;
//         handleInput("main"); // Update the state
//       }
//     } else {
//       // Append to specific option
//       const focusedRef = refs.current.find(
//         (ref, index) => ref.current && index + 1 === focusedOption
//       )?.current;
//       if (focusedRef) {
//         focusedRef.innerHTML += mathLatex;
//         handleInput(focusedOption); // Update the state for the specific option
//       }
//     }

//     setShowModal(false); // Close the modal
//   };

//   const fileInputRefs = useRef([]); // File input refs for each option
//   const renderActionButtons = (index, id) => {
//     return (
//       focusedOption === id && (
//         <>
//           {/* Formula Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "110px",
//               cursor: "pointer",
//             }}
//             onClick={() => setShowModal(true)}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>

//           {/* Image Upload Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "70px",
//               cursor: "pointer",
//             }}
//             onClick={() => fileInputRefs.current[index].click()}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image Icon"
//             />
//             <input
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[index] = el)}
//               style={{ display: "none" }}
//               onChange={(e) => handleFileSelect(e, id)}
//             />
//           </div>

//           {/* Recording Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "30px",
//               cursor: "pointer",
//             }}
//             onClick={() => toggleSpeechToText(id)}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//                 animation: isRecording ? "blink 1s infinite" : "none",
//               }}
//               src={isRecording ? RecordingActive : RecordingStatic}
//               alt="Recording Icon"
//             />
//           </div>

//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "150px",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//               }}
//               onClick={() => handleDeleteOption(id)} // Call delete handler
//               src={DeleteBin}
//               alt="DeleteBin"
//             />
//           </div>
//         </>
//       )
//     );
//   };
//   const renderOptions = () => {
//     switch (questionType) {
//       case "multi-select":
//         return editableOptions.map((opt, index) => (
//           <div
//             key={opt.id || index}
//             style={{
//               display: "flex",
//               flexDirection: "column", // Ensure elements are stacked vertically
//               marginBottom: "10px",
//               position: "relative",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <input
//                 type="checkbox"
//                 checked={opt.isChecked}
//                 onChange={() => handleCheckboxChange(index)}
//                 style={{
//                   marginRight: "10px",
//                   cursor: "pointer",
//                   accentColor: "##D6D6D6",
//                 }}
//               />

//               <input
//                 type="number"
//                 placeholder="Weight"
//                 value={opt.weight || ""}
//                 onChange={(e) =>
//                   setEditableOptions((prevOptions) =>
//                     prevOptions.map((o, i) =>
//                       i === index ? { ...o, weight: e.target.value } : o
//                     )
//                   )
//                 }
//                 style={{
//                   marginRight: "10px",
//                   width: "60px",
//                   border: "1px solid #6A6A6A",
//                   padding: "5px",
//                 }}
//               />
//               <div
//                 contentEditable
//                 ref={(el) => (refs.current[index] = { current: el })}
//                 onFocus={() => setFocusedOption(opt.id)}
//                 onInput={() => handleOptionInput(index)}
//                 onPaste={(e) => handlePaste(e, opt.id)}
//                 style={{
//                   border: "1px solid #6A6A6A",
//                   padding: "10px",
//                   minHeight: "40px",
//                   width: "100%",
//                   backgroundColor: "#fff",
//                   paddingTop: "25px",
//                 }}
//                 dangerouslySetInnerHTML={{
//                   __html: processTextSecond(opt.content || ""),
//                 }}
//               ></div>
//               {renderActionButtons(index, opt.id)}
//             </div>
//             <div style={{ textAlign: "right", marginTop: "10px" }}>
//               {index === editableOptions.length - 1 &&
//                 focusedOption === opt.id && (
//                   <img
//                     onClick={handleAddOption}
//                     src={YellowPlus}
//                     alt="Option_Add"
//                     className="YellowPlus-RC-Button"
//                   />
//                 )}
//             </div>
//           </div>
//         ));
//       case "fill-in-blanks":
//         return (
//           <div style={{ position: "relative" }}>
//             <div
//               contentEditable
//               ref={(el) => (refs.current[0] = { current: el })}
//               onFocus={() => setFocusedOption(editableOptions[0]?.id || 1)}
//               onInput={() => handleInput(editableOptions[0]?.id || 1)}
//               onPaste={(e) => handlePaste(e, editableOptions[0]?.id || 1)}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "10px",
//                 minHeight: "40px",
//                 width: "100%",
//                 backgroundColor: "#fff",
//                 paddingTop: "25px",
//               }}
//               dangerouslySetInnerHTML={{
//                 __html: editableOptions[0]?.content,
//               }}
//             ></div>

//             {/* Action Buttons */}
//             {renderActionButtons(0, editableOptions[0]?.id || 1)}
//           </div>
//         );

//       case "boolean":
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="true" />
//               <span style={{ marginLeft: "10px" }}>True</span>
//             </label>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="false" />
//               <span style={{ marginLeft: "10px" }}>False</span>
//             </label>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   useEffect(() => {
//     if (hasCounterChanged) {
//     } else {
//       setHasCounterChanged(true); // Mark the initial render
//     }
//   }, [questionCounter]);

//   useEffect(() => {
//     if (questionText !== content) {
//       setContent(questionText);
//     }
//   }, [questionText]);

//   const processTextSecond = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     return text;
//   };

//   const processText = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     // Render LaTeX expressions
//     const latexRegex = /\\\((.*?)\\\)/g;
//     text = text.replace(latexRegex, (match, p1) => {
//       return katex.renderToString(p1, { throwOnError: false });
//     });

//     return text;
//   };

//   const handleOptionInput = (index) => {
//     console.log("Handling input for option:", index);

//     // Ensure the ref exists for the current option
//     const ref = refs.current[index]?.current;
//     if (!ref) {
//       console.warn(`No ref found for option at index: ${index}`);
//       return;
//     }

//     // Get the current content of the editable div

//     // Update the state for the editable option
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: contentHTML } : option
//       )
//     );

//     // Save cursor position
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Get current content from the editable div
//     const contentHTML = ref.innerHTML.trim();
//     console.log(`Content for option ${index}:`, contentHTML);

//     // Use the dedicated function to update editableOptions
//     handleOptionContentUpdate(index, contentHTML);

//     // Restore cursor position after DOM update
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function restoreCursor(node) {
//         if (node.nodeType === 3) {
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (restoreCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }

//       restoreCursor(ref);
//     }, 0);
//   };

//   const renderRightOptions = () => {
//     return editableOptions.map((opt, index) => (
//       <div
//         key={opt.id}
//         style={{
//           marginBottom: "10px",
//           padding: "10px",
//           display: "flex",
//           alignItems: "flex-start",
//           gap: "10px",
//         }}
//       >
//         {/* <input
//           type="checkbox"
//           style={{
//             marginTop: "5px",
//             flexShrink: 0,
//           }}
//         /> */}
//         <strong   style={{
//             marginTop: "5px",
//             flexShrink: 0,
//           }}>Option {index + 1}:</strong>
//         <div
//           style={{
//             padding: "5px",
//             flex: 1,
//           }}
//           dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
//         />
//       </div>
//     ));
//   };

//   const handleOptionContentUpdate = (index, newContent) => {
//     console.log(`Updating content for option ${index}:`, newContent);
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: newContent } : option
//       )
//     );
//   };

//   // useEffect(() => {
//   //   if (onQuestionUpdate) {
//   //     onQuestionUpdate({
//   //       question_text: content, // Pass updated question text
//   //       options: editableOptions.map((opt) => ({
//   //         option_no: opt.id,
//   //         option_text: opt.content, // Pass updated option text
//   //         option_correct_flag: opt.isChecked ? 1 : 0,
//   //       })),
//   //     });
//   //   }
//   // }, [content, editableOptions, onQuestionUpdate]);

//   useEffect(() => {
//     if (onQuestionUpdate) {
//       onQuestionUpdate({
//         question_text: questionText, // Updated question text
//         options: optionFromAnotherPage, // Updated options
//       });
//     }
//   }, [questionText, optionFromAnotherPage, onQuestionUpdate]);

//   // const handleQuestionEdit = (updatedData) => {
//   //   setCurrentQuestion((prevQuestion) => ({
//   //     ...prevQuestion,
//   //     question_text: updatedData.question_text,
//   //     options: updatedData.options,
//   //   }));
//   // };

//   // const handleFetchDataClick = () => {
//   //   const updatedData = fetchNewUpdatedDataValues();
//   //   console.log("Updated Data:", updatedData);
//   // };
//   const handleFetchAndUpdate = () => {
//     const updatedData = {
//       question_text: content,
//       options: editableOptions.map((opt) => ({
//         option_no: opt.id,
//         option_text: opt.content,
//         option_correct_flag: opt.isChecked ? 1 : 0,
//       })),
//       images, // Include the images list
//     };
//     console.log("Updated Data:", updatedData);

//     if (fetchNewUpdatedDataValues) {
//       fetchNewUpdatedDataValues(updatedData); // Send updated data to parent
//     }
//   };

//   // Example: Sending the images list to the parent component
//   // useEffect(() => {
//   //   if (fetchNewUpdatedDataValues) {
//   //     fetchNewUpdatedDataValues({ images });
//   //   }
//   // }, [images, fetchNewUpdatedDataValues]);

//   // Trigger handleFetchAndUpdate when content or options change
//   // useEffect(() => {
//   //   handleFetchAndUpdate();
//   // }, [content, editableOptions]);
//   // Trigger handleFetchAndUpdate when content, options, or images change
//   useEffect(() => {
//     handleFetchAndUpdate();
//   }, [content, editableOptions, images]);

//   // console.log(content + "contetn");
//   // console.log(htmlContent + "htmlContent");
//   // console.log("Editable Options:", JSON.stringify(editableOptions, null, 2));
//   // useEffect(() => {
//   //   console.log("htmlContent updated:", htmlContent);
//   //   console.log("Editable options updated:", editableOptions);
//   // }, [htmlContent, editableOptions]);
//   // console.log("Refs after rendering:", refs.current);
//   // useEffect(() => {
//   //   console.log("Updated editableOptions:", editableOptions);
//   // }, [editableOptions]);
//   // useEffect(() => {
//   //   console.log("Refs after rendering:", refs.current);
//   // }, [editableOptions]);

//   return (
//     <div
//       style={{
//         position: "relative",
//         width,
//         height,
//         backgroundColor: "#FBFBFB",
//         padding: "10px",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           width: "100%",
//           gap: "20px",
//           userSelect: isDragging ? "none" : "auto",
//         }}
//         ref={containerRef}
//       >
//         {/* Left Section */}
//         <div style={{ width: `${dividerPosition}%` }}>
//           {/* Main editable div */}

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text :
//           </p>
//           <div style={{ position: "relative" }}>
//             {/* Main ContentEditable Div */}
//             <div
//               contentEditable
//               ref={mainEditableRef}
//               onFocus={() => setFocusedOption("main")}
//               onInput={() => handleInput("main")}
//               onPaste={(e) => handlePaste(e, "main")}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "22px 10px 10px", // top, left/right, bottom
//                 marginBottom: "20px",
//                 minHeight: "100px",
//                 backgroundColor: "white",
//               }}
//               dangerouslySetInnerHTML={{ __html: processTextSecond(content) }}
//             ></div>

//             {/* Formula Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "110px",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowModal(true)}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt="Formula"
//               />
//             </div>

//             {/* Image Upload Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "70px",
//                 cursor: "pointer",
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt="Image Icon"
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileSelect(e, "main")}
//               />
//             </div>

//             {/* Recording Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "30px",
//                 cursor: "pointer",
//               }}
//               onClick={() => toggleSpeechToText("main")}
//             >
//               <img
//                 style={{
//                   height: "18px",
//                   width: "17px",
//                   animation: isRecording ? "blink 1s infinite" : "none",
//                 }}
//                 src={isRecording ? RecordingActive : RecordingStatic}
//                 alt="Recording Icon"
//               />
//             </div>
//           </div>

//           {/* Additional buttons */}
//           {renderOptions()}
//         </div>

//         {/* Draggable divider */}
//         <div
//           style={{
//             position: "relative",
//             cursor: "col-resize",
//             width: "10px",
//             margin: "0 -5px",
//             zIndex: 20,
//           }}
//           onMouseDown={handleMouseDown}
//         >
//           <div
//             style={{
//               marginTop: "5vh",
//               position: "absolute",
//               top: 0,
//               bottom: 0,
//               left: "50%",
//               borderLeft: "2px dotted #ccc",
//               height: "87%",
//             }}
//           >
//             {/* Triangle pointer */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 right: "-6px",
//                 width: 0,
//                 height: 0,
//                 borderTop: "6px solid transparent",
//                 borderBottom: "6px solid transparent",
//                 borderLeft: "6px solid #ccc",
//                 transform: "translateY(-50%)",
//               }}
//             />
//           </div>
//         </div>

//         {/* Right side with options */}

//         {/* Right Section */}

//         <div style={{ width: `${100 - dividerPosition}%` }}>
//           <p style={{ marginTop: "2.2vh" }}>Preview :</p>

//           <div
//             style={{
//               width: "100%",
//               border: "1px solid #ccc",
//               padding: "10px",
//               backgroundColor: "white",
//               minHeight: "100px",
//               whiteSpace: "pre-wrap",
//               marginTop: "1vh",
//             }}
//           >
//             <div>
//               <strong style={{ paddingBottom: "15px", paddingTop: "8px" }}>
//                 Question:
//               </strong>
//               <div
//                 style={{ padding: "8px" }}
//                 dangerouslySetInnerHTML={{
//                   __html: processText(content),
//                 }}
//               ></div>
//             </div>
//             <div>{renderRightOptions()}</div>
//           </div>
//         </div>
//       </div>

//       <Modal show={showModal} onClose={() => setShowModal(false)}>
//         <h2 style={{ color: "white" }}>MathLive Input</h2>
//         <MathLive onLatexChange={handleLatexChange} />
//         <button
//           onClick={sendToTextBox}
//           style={{ marginTop: "10px", cursor: "pointer" }}
//         >
//           Send to Text Box
//         </button>
//       </Modal>
//     </div>
//   );
// };

// export default React.memo(ReviewComponent);

// import React, { useState, useRef, useEffect } from "react";
// import Modal from "../../POP/Modal"; // Import the modal component
// import MathLive from "../../POP/FileComp7"; // Import MathLive component
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
// import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";
// import DeleteBin from "../../../Assets/Images/CommanImages/Delete.png";
// const ReviewComponent = ({
//   width = "100%",
//   height = "auto",
//   htmlContent,
//   questionCounter,
//   currentQuestion,
//   questionText,
//   optionFromAnotherPage,
//   quesType,
//   quesNo,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   onQuestionUpdate,
//   setCurrentQuestion,
//   fetchNewUpdatedDataValues,
// }) => {
//   const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
//   const recognitionRef = useRef(null); // Ref for the speech recognition object
//   const contentEditableRef = useRef(null);
//   const [images, setImages] = useState([]); // Stores actual image files
//   const [showModal, setShowModal] = useState(false); // Modal state
//   const [latex, setLatex] = useState(""); // MathLive LaTeX content state
//   const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
//   const [isClicked, setIsClicked] = useState(false);
//   const fileInputRef = useRef(null); // Ref for the hidden file input
//   const [questionType, setQuestionType] = useState("multi-select"); // Tracks question type0
//   const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
//   const [hasCounterChanged, setHasCounterChanged] = useState(false);
//   const [checkedOptions, setCheckedOptions] = useState({});
//   const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)
//   const [initialOptions, setInitialOptions] = useState([]); // Store the initial options
//   const [content, setContent] = useState(htmlContent || "");
//   const [isDragging, setIsDragging] = useState(false);
//   const [dividerPosition, setDividerPosition] = useState(50);
//   const containerRef = useRef(null);
//   const [editableOptions, setEditableOptions] = useState([]);

//   // const [editableOptions, setEditableOptions] = useState(
//   //   optionFromAnotherPage?.map((opt) => ({
//   //     ...opt,
//   //     id: opt.option_no,
//   //     content: opt.option_text,
//   //     isChecked: opt.option_correct_flag === 1,
//   //   })) || []
//   // );
//   useEffect(() => {
//     if (optionFromAnotherPage) {
//       const timer = setTimeout(() => {
//         setEditableOptions(
//           optionFromAnotherPage.map((opt) => ({
//             ...opt,
//             id: opt.option_no,
//             content: opt.option_text,
//             isChecked: opt.option_correct_flag === 1, // Delayed setting of isChecked
//           }))
//         );
//       }, 1500); // 2-second delay

//       // Clear timer if component unmounts or optionFromAnotherPage changes
//       return () => clearTimeout(timer);
//     }
//   }, [optionFromAnotherPage]);

//   const handleCheckboxChange = (index) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((opt, idx) => ({
//         ...opt,
//         isChecked: idx === index ? !opt.isChecked : opt.isChecked,
//         option_correct_flag:
//           idx === index ? (opt.isChecked ? 0 : 1) : opt.option_correct_flag,
//       }))
//     );
//   };

//   const handleMouseDown = () => {
//     setIsDragging(true);
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging && containerRef.current) {
//       const containerRect = containerRef.current.getBoundingClientRect();
//       const newPosition =
//         ((e.clientX - containerRect.left) / containerRect.width) * 100;
//       setDividerPosition(Math.min(Math.max(newPosition, 20), 80));
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   useEffect(() => {
//     if (isDragging) {
//       document.addEventListener("mousemove", handleMouseMove);
//       document.addEventListener("mouseup", handleMouseUp);
//     }
//     return () => {
//       document.removeEventListener("mousemove", handleMouseMove);
//       document.removeEventListener("mouseup", handleMouseUp);
//     };
//   }, [isDragging]);

//   useEffect(() => {
//     const mapQuesTypeToQuestionType = {
//       1: "multi-select",
//       2: "multi-select",
//       3: "fill-in-blanks",
//       4: "boolean",
//     };
//     const initialQuestionType =
//       mapQuesTypeToQuestionType[quesType] || "multi-select";
//     setQuestionType(initialQuestionType);
//   }, [quesType]);

//   const mainEditableRef = useRef(null);
//   const refs = useRef([]); // Refs for all editable options

//   useEffect(() => {
//     if (optionFromAnotherPage && optionFromAnotherPage.length > 0) {
//       // Save initial options
//       setInitialOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           ...opt,
//           id: opt.id || index + 1,
//         }))
//       );

//       // Create editable options
//       setEditableOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           id: opt.id || index + 1,
//           content: opt.option_text || "",
//         }))
//       );
//     }
//   }, [optionFromAnotherPage]);

//   // Populate refs dynamically for all options
//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   useEffect(() => {
//     if (htmlContent !== content) {
//       setContent(htmlContent);
//     }
//   }, [htmlContent]);
//   const renderLatexToHTML = (text) => {
//     try {
//       let html = text;

//       // Replace LaTeX
//       html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//           displayMode: true,
//         })
//       );

//       html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//         })
//       );

//       // Replace image placeholders with actual images
//       images.forEach((image) => {
//         const placeholder = `[${image.id}_${image.alt}]`;
//         const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
//         html = html.replace(placeholder, imgTag);
//       });

//       return html;
//     } catch (error) {
//       console.error("Error rendering HTML:", error);
//       return text;
//     }
//   };
//   const handleDeleteOption = (id) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.filter((option) => option.id !== id)
//     );
//   };

//   const handleInput = (id = "main") => {
//     const ref =
//       id === "main"
//         ? mainEditableRef.current
//         : refs.current.find((r, i) => i + 1 === id)?.current;

//     if (!ref) {
//       console.warn(`No ref found for id: ${id}`);
//       return;
//     }

//     // Save current selection (cursor position)
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Update content state
//     const contentHTML = ref.innerHTML.trim();
//     if (id === "main") {
//       console.log("questionEditing");
//       setContent(contentHTML);
//     } else {
//       console.log("optEditing", id);
//       setEditableOptions((prevOptions) =>
//         prevOptions.map((option) =>
//           option.id === id ? { ...option, content: contentHTML } : option
//         )
//       );
//     }

//     // Restore cursor position after the DOM updates
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function setCursor(node) {
//         if (node.nodeType === 3) {
//           // Text node
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (setCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }
//       setCursor(ref);
//     }, 0);
//   };

//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   const startSpeechToText = () => {
//     if (
//       !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
//     ) {
//       alert("Speech-to-text is not supported in this browser.");
//       return;
//     }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!recognitionRef.current) {
//       const recognition = new SpeechRecognition();
//       recognition.lang = "en-US";
//       recognition.interimResults = true;
//       recognition.continuous = true;

//       recognition.onstart = () => setIsRecording(true);

//       recognition.onresult = (event) => {
//         const mainDiv = mainEditableRef.current; // Main contentEditable div
//         const selection = window.getSelection();
//         const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

//         for (let i = event.resultIndex; i < event.results.length; i++) {
//           const transcript = event.results[i][0].transcript;

//           if (event.results[i].isFinal) {
//             const textNode = document.createTextNode(transcript + " ");
//             if (range) {
//               range.deleteContents();
//               range.insertNode(textNode);
//               range.setStartAfter(textNode);
//               range.setEndAfter(textNode);
//               selection.removeAllRanges();
//               selection.addRange(range);
//             } else {
//               mainDiv.appendChild(textNode);
//             }
//             handleInput("main"); // Update state after inserting speech text
//           }
//         }
//       };

//       recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error);
//         setIsRecording(false);
//       };

//       recognition.onend = () => setIsRecording(false);

//       recognitionRef.current = recognition;
//     }

//     recognitionRef.current.start();
//   };

//   const stopSpeechToText = () => {
//     if (recognitionRef.current) {
//       recognitionRef.current.stop();
//       setIsRecording(false);
//     }
//   };
//   const toggleSpeechToText = () => {
//     if (isRecording) {
//       stopSpeechToText();
//     } else {
//       startSpeechToText();
//     }
//   };

//   // const handleFileSelect = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     const reader = new FileReader();
//   //     reader.onload = (event) => {
//   //       const img = document.createElement("img");
//   //       img.src = event.target.result;
//   //       img.alt = file.name || "selected-image";
//   //       img.classList.add("inserted-image"); // Add the CSS class

//   //       // Insert image at the current cursor position
//   //       const selection = window.getSelection();
//   //       const range = selection.getRangeAt(0);
//   //       range.deleteContents();
//   //       range.insertNode(img);

//   //       handleInput();
//   //     };
//   //     reader.readAsDataURL(file);
//   //   }
//   // };
//   const handleFileSelect = (e, id = "main") => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const imageIndex = images.length + 1;
//         const imageName = `image${imageIndex}.png`;
//         const placeholder = `#<${imageName}>#`;

//         // Insert image in the editor at the current cursor position
//         const img = document.createElement("img");
//         img.src = event.target.result;
//         img.classList.add("Img-RQ-QnsAns");
//         img.alt = imageName;

//         const selection = window.getSelection();
//         const range = selection.getRangeAt(0);
//         range.deleteContents();
//         range.insertNode(img);

//         // Store the image data
//         setImages((prevImages) => [
//           ...prevImages,
//           { name: imageName, src: event.target.result, placeholder },
//         ]);

//         // Trigger appropriate input handler to update content
//         if (id === "main") {
//           handleInput("main");
//         } else {
//           const index = editableOptions.findIndex((opt) => opt.id === id);
//           if (index !== -1) handleOptionInput(index);
//         }
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // const handleFileSelect = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     const reader = new FileReader();
//   //     reader.onload = (event) => {
//   //       const imageName = `image${images.length + 1}.png`;
//   //       const imageTag = `#<${imageName}>#`;

//   //       // Insert the image tag at the current cursor position
//   //       const selection = window.getSelection();
//   //       const range = selection.getRangeAt(0);
//   //       range.deleteContents();
//   //       const textNode = document.createTextNode(imageTag);
//   //       range.insertNode(textNode);

//   //       // Add the image to the images list
//   //       setImages((prevImages) => [
//   //         ...prevImages,
//   //         { name: imageName, src: event.target.result },
//   //       ]);

//   //       handleInput();
//   //     };
//   //     reader.readAsDataURL(file);
//   //   }
//   // };

//   const handleAddOption = () => {
//     const newOption = {
//       id: editableOptions.length + 1,
//       content: "",
//       weight: "",
//     };
//     setEditableOptions([...editableOptions, newOption]);
//   };

//   // const handlePaste = (e, id = "main") => {
//   //   e.preventDefault();
//   //   const ref =
//   //     id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//   //   const items = e.clipboardData.items;

//   //   for (let item of items) {
//   //     if (item.type.startsWith("image/")) {
//   //       const blob = item.getAsFile();
//   //       const imageId = images.length + 1; // Assign serial number
//   //       const imageName = blob.name || `pasted-image-${imageId}`;

//   //       // Create a placeholder text for the image
//   //       const placeholderText = `[${imageId}_${imageName}]`;

//   //       // Insert placeholder text in the editable div
//   //       document.execCommand("insertText", false, placeholderText);

//   //       // Read and store the actual image for rendering
//   //       const reader = new FileReader();
//   //       reader.onload = (event) => {
//   //         setImages((prevImages) => [
//   //           ...prevImages,
//   //           { id: imageId, src: event.target.result, alt: imageName },
//   //         ]);
//   //       };
//   //       reader.readAsDataURL(blob);

//   //       handleInput(id);
//   //     } else if (item.type === "text/plain") {
//   //       const text = e.clipboardData.getData("text/plain");
//   //       document.execCommand("insertText", false, text);
//   //       handleInput(id);
//   //     }
//   //   }
//   // };
//   const handlePaste = (e, id = "main") => {
//     e.preventDefault();
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const items = e.clipboardData.items;

//     for (let item of items) {
//       if (item.type.startsWith("image/")) {
//         const blob = item.getAsFile();
//         const imageId = images.length + 1;
//         const imageName = blob.name || `pasted-image-${imageId}`;
//         const placeholderText = `#<${imageName}>#`;

//         // Insert placeholder text in the editable div
//         document.execCommand("insertText", false, placeholderText);

//         // Read and store the actual image
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImages((prevImages) => [
//             ...prevImages,
//             { id: imageId, src: event.target.result, alt: imageName, placeholder: placeholderText },
//           ]);
//         };
//         reader.readAsDataURL(blob);

//         if (id === "main") {
//           handleInput("main");
//         } else {
//           const index = editableOptions.findIndex((opt) => opt.id === id);
//           if (index !== -1) handleOptionInput(index);
//         }
//       } else if (item.type === "text/plain") {
//         const text = e.clipboardData.getData("text/plain");
//         document.execCommand("insertText", false, text);
//         handleInput(id);
//       }
//     }
//   };

//   const handleLatexChange = (newLatex) => {
//     setLatex(newLatex);
//   };

//   const sendToTextBox = () => {
//     const mathLatex = `\\(${latex}\\)`;

//     if (focusedOption === "main") {
//       // Append to main editable div
//       if (mainEditableRef.current) {
//         mainEditableRef.current.innerHTML += mathLatex;
//         handleInput("main"); // Update the state
//       }
//     } else {
//       // Append to specific option
//       const focusedRef = refs.current.find(
//         (ref, index) => ref.current && index + 1 === focusedOption
//       )?.current;
//       if (focusedRef) {
//         focusedRef.innerHTML += mathLatex;
//         handleInput(focusedOption); // Update the state for the specific option
//       }
//     }

//     setShowModal(false); // Close the modal
//   };

//   const fileInputRefs = useRef([]); // File input refs for each option
//   const renderActionButtons = (index, id) => {
//     return (
//       focusedOption === id && (
//         <>
//           {/* Formula Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "110px",
//               cursor: "pointer",
//             }}
//             onClick={() => setShowModal(true)}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>

//           {/* Image Upload Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "70px",
//               cursor: "pointer",
//             }}
//             onClick={() => fileInputRefs.current[index].click()}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image Icon"
//             />
//             <input
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[index] = el)}
//               style={{ display: "none" }}
//               onChange={(e) => handleFileSelect(e, id)}
//             />
//           </div>

//           {/* Recording Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "30px",
//               cursor: "pointer",
//             }}
//             onClick={() => toggleSpeechToText(id)}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//                 animation: isRecording ? "blink 1s infinite" : "none",
//               }}
//               src={isRecording ? RecordingActive : RecordingStatic}
//               alt="Recording Icon"
//             />
//           </div>

//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "150px",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//               }}
//               onClick={() => handleDeleteOption(id)} // Call delete handler
//               src={DeleteBin}
//               alt="DeleteBin"
//             />
//           </div>
//         </>
//       )
//     );
//   };
//   const renderOptions = () => {
//     switch (questionType) {
//       case "multi-select":
//         return editableOptions.map((opt, index) => (
//           <div
//             key={opt.id || index}
//             style={{
//               display: "flex",
//               flexDirection: "column", // Ensure elements are stacked vertically
//               marginBottom: "10px",
//               position: "relative",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <input
//                 type="checkbox"
//                 checked={opt.isChecked}
//                 onChange={() => handleCheckboxChange(index)}
//                 style={{
//                   marginRight: "10px",
//                   cursor: "pointer",
//                   accentColor: "##D6D6D6",
//                 }}
//               />

//               <input
//                 type="number"
//                 placeholder="Weight"
//                 value={opt.weight || ""}
//                 onChange={(e) =>
//                   setEditableOptions((prevOptions) =>
//                     prevOptions.map((o, i) =>
//                       i === index ? { ...o, weight: e.target.value } : o
//                     )
//                   )
//                 }
//                 style={{
//                   marginRight: "10px",
//                   width: "60px",
//                   border: "1px solid #6A6A6A",
//                   padding: "5px",
//                 }}
//               />
//               <div
//                 contentEditable
//                 ref={(el) => (refs.current[index] = { current: el })}
//                 onFocus={() => setFocusedOption(opt.id)}
//                 onInput={() => handleOptionInput(index)}
//                 onPaste={(e) => handlePaste(e, opt.id)}
//                 style={{
//                   border: "1px solid #6A6A6A",
//                   padding: "10px",
//                   minHeight: "40px",
//                   width: "100%",
//                   backgroundColor: "#fff",
//                   paddingTop: "25px",
//                 }}
//                 dangerouslySetInnerHTML={{
//                   __html: processTextSecond(opt.content || ""),
//                 }}
//               ></div>
//               {renderActionButtons(index, opt.id)}
//             </div>
//             <div style={{ textAlign: "right", marginTop: "10px" }}>
//               {index === editableOptions.length - 1 &&
//                 focusedOption === opt.id && (
//                   <img
//                     onClick={handleAddOption}
//                     src={YellowPlus}
//                     alt="Option_Add"
//                     className="YellowPlus-RC-Button"
//                   />
//                 )}
//             </div>
//           </div>
//         ));
//       case "fill-in-blanks":
//         return (
//           <div style={{ position: "relative" }}>
//             <div
//               contentEditable
//               ref={(el) => (refs.current[0] = { current: el })}
//               onFocus={() => setFocusedOption(editableOptions[0]?.id || 1)}
//               onInput={() => handleInput(editableOptions[0]?.id || 1)}
//               onPaste={(e) => handlePaste(e, editableOptions[0]?.id || 1)}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "10px",
//                 minHeight: "40px",
//                 width: "100%",
//                 backgroundColor: "#fff",
//                 paddingTop: "25px",
//               }}
//               dangerouslySetInnerHTML={{
//                 __html: editableOptions[0]?.content,
//               }}
//             ></div>

//             {/* Action Buttons */}
//             {renderActionButtons(0, editableOptions[0]?.id || 1)}
//           </div>
//         );

//       case "boolean":
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="true" />
//               <span style={{ marginLeft: "10px" }}>True</span>
//             </label>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="false" />
//               <span style={{ marginLeft: "10px" }}>False</span>
//             </label>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   useEffect(() => {
//     if (hasCounterChanged) {
//     } else {
//       setHasCounterChanged(true); // Mark the initial render
//     }
//   }, [questionCounter]);

//   useEffect(() => {
//     if (questionText !== content) {
//       setContent(questionText);
//     }
//   }, [questionText]);

//   const processTextSecond = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     return text;
//   };

//   const processText = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     // Render LaTeX expressions
//     const latexRegex = /\\\((.*?)\\\)/g;
//     text = text.replace(latexRegex, (match, p1) => {
//       return katex.renderToString(p1, { throwOnError: false });
//     });

//     return text;
//   };

//   // const handleOptionInput = (index) => {
//   //   console.log("Handling input for option:", index);

//   //   // Ensure the ref exists for the current option
//   //   const ref = refs.current[index]?.current;
//   //   if (!ref) {
//   //     console.warn(`No ref found for option at index: ${index}`);
//   //     return;
//   //   }

//   //   // Get the current content of the editable div

//   //   // Update the state for the editable option
//   //   setEditableOptions((prevOptions) =>
//   //     prevOptions.map((option, i) =>
//   //       i === index ? { ...option, content: contentHTML } : option
//   //     )
//   //   );

//   //   // Save cursor position
//   //   const selection = window.getSelection();
//   //   const range = selection.getRangeAt(0);
//   //   const preCaretRange = range.cloneRange();
//   //   preCaretRange.selectNodeContents(ref);
//   //   preCaretRange.setEnd(range.endContainer, range.endOffset);
//   //   const cursorPosition = preCaretRange.toString().length;

//   //   // Get current content from the editable div
//   //   const contentHTML = ref.innerHTML.trim();
//   //   console.log(`Content for option ${index}:`, contentHTML);

//   //   // Use the dedicated function to update editableOptions
//   //   handleOptionContentUpdate(index, contentHTML);

//   //   // Restore cursor position after DOM update
//   //   setTimeout(() => {
//   //     const newRange = document.createRange();
//   //     const newSelection = window.getSelection();
//   //     let charCount = 0;

//   //     function restoreCursor(node) {
//   //       if (node.nodeType === 3) {
//   //         const nextCharCount = charCount + node.length;
//   //         if (cursorPosition <= nextCharCount) {
//   //           newRange.setStart(node, cursorPosition - charCount);
//   //           newRange.collapse(true);
//   //           newSelection.removeAllRanges();
//   //           newSelection.addRange(newRange);
//   //           return true;
//   //         }
//   //         charCount = nextCharCount;
//   //       } else {
//   //         for (let i = 0; i < node.childNodes.length; i++) {
//   //           if (restoreCursor(node.childNodes[i])) return true;
//   //         }
//   //       }
//   //       return false;
//   //     }

//   //     restoreCursor(ref);
//   //   }, 0);
//   // };
//   const handleOptionInput = (index) => {
//     console.log("Handling input for option:", index);

//     const ref = refs.current[index]?.current;
//     if (!ref) {
//       console.warn(`No ref found for option at index: ${index}`);
//       return;
//     }

//     // Save current selection (cursor position)
//     const selection = window.getSelection();
//     if (!selection || selection.rangeCount === 0) {
//       console.warn("No valid selection detected.");
//       return;
//     }
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Get the current content from the editable div
//     const contentHTML = ref.innerHTML.trim();
//     console.log(`Content for option ${index}:`, contentHTML);

//     // Update the state for the specific option
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: contentHTML } : option
//       )
//     );

//     // Restore cursor position after DOM update
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function restoreCursor(node) {
//         if (node.nodeType === 3) {
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (restoreCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }
//       restoreCursor(ref);
//     }, 0);
//   };

//   const renderRightOptions = () => {
//     return editableOptions.map((opt, index) => (
//       <div
//         key={opt.id}
//         style={{
//           marginBottom: "10px",
//           padding: "10px",
//           display: "flex",
//           alignItems: "flex-start",
//           gap: "10px",
//         }}
//       >
//         {/* <input
//           type="checkbox"
//           style={{
//             marginTop: "5px",
//             flexShrink: 0,
//           }}
//         /> */}
//         <strong   style={{
//             marginTop: "5px",
//             flexShrink: 0,
//           }}>Option {index + 1}:</strong>
//         <div
//           style={{
//             padding: "5px",
//             flex: 1,
//           }}
//           dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
//         />
//       </div>
//     ));
//   };

//   const handleOptionContentUpdate = (index, newContent) => {
//     console.log(`Updating content for option ${index}:`, newContent);
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: newContent } : option
//       )
//     );
//   };

//   // useEffect(() => {
//   //   if (onQuestionUpdate) {
//   //     onQuestionUpdate({
//   //       question_text: content, // Pass updated question text
//   //       options: editableOptions.map((opt) => ({
//   //         option_no: opt.id,
//   //         option_text: opt.content, // Pass updated option text
//   //         option_correct_flag: opt.isChecked ? 1 : 0,
//   //       })),
//   //     });
//   //   }
//   // }, [content, editableOptions, onQuestionUpdate]);

//   useEffect(() => {
//     if (onQuestionUpdate) {
//       onQuestionUpdate({
//         question_text: questionText, // Updated question text
//         options: optionFromAnotherPage, // Updated options
//       });
//     }
//   }, [questionText, optionFromAnotherPage, onQuestionUpdate]);

//   // const handleQuestionEdit = (updatedData) => {
//   //   setCurrentQuestion((prevQuestion) => ({
//   //     ...prevQuestion,
//   //     question_text: updatedData.question_text,
//   //     options: updatedData.options,
//   //   }));
//   // };

//   // const handleFetchDataClick = () => {
//   //   const updatedData = fetchNewUpdatedDataValues();
//   //   console.log("Updated Data:", updatedData);
//   // };
//   const handleFetchAndUpdate = () => {
//     const updatedData = {
//       question_text: content,
//       options: editableOptions.map((opt) => ({
//         option_no: opt.id,
//         option_text: opt.content,
//         option_correct_flag: opt.isChecked ? 1 : 0,
//       })),
//       images, // Include the images list
//     };
//     console.log("Updated Data:", updatedData);

//     if (fetchNewUpdatedDataValues) {
//       fetchNewUpdatedDataValues(updatedData); // Send updated data to parent
//     }
//   };

//   // Example: Sending the images list to the parent component
//   // useEffect(() => {
//   //   if (fetchNewUpdatedDataValues) {
//   //     fetchNewUpdatedDataValues({ images });
//   //   }
//   // }, [images, fetchNewUpdatedDataValues]);

//   // Trigger handleFetchAndUpdate when content or options change
//   // useEffect(() => {
//   //   handleFetchAndUpdate();
//   // }, [content, editableOptions]);
//   // Trigger handleFetchAndUpdate when content, options, or images change
//   useEffect(() => {
//     handleFetchAndUpdate();
//   }, [content, editableOptions, images]);

//   // console.log(content + "contetn");
//   // console.log(htmlContent + "htmlContent");
//   // console.log("Editable Options:", JSON.stringify(editableOptions, null, 2));
//   // useEffect(() => {
//   //   console.log("htmlContent updated:", htmlContent);
//   //   console.log("Editable options updated:", editableOptions);
//   // }, [htmlContent, editableOptions]);
//   // console.log("Refs after rendering:", refs.current);
//   // useEffect(() => {
//   //   console.log("Updated editableOptions:", editableOptions);
//   // }, [editableOptions]);
//   // useEffect(() => {
//   //   console.log("Refs after rendering:", refs.current);
//   // }, [editableOptions]);

//   return (
//     <div
//       style={{
//         position: "relative",
//         width,
//         height,
//         backgroundColor: "#FBFBFB",
//         padding: "10px",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           width: "100%",
//           gap: "20px",
//           userSelect: isDragging ? "none" : "auto",
//         }}
//         ref={containerRef}
//       >
//         {/* Left Section */}
//         <div style={{ width: `${dividerPosition}%` }}>
//           {/* Main editable div */}

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text :
//           </p>
//           <div style={{ position: "relative" }}>
//             {/* Main ContentEditable Div */}
//             <div
//               contentEditable
//               ref={mainEditableRef}
//               onFocus={() => setFocusedOption("main")}
//               onInput={() => handleInput("main")}
//               onPaste={(e) => handlePaste(e, "main")}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "22px 10px 10px", // top, left/right, bottom
//                 marginBottom: "20px",
//                 minHeight: "100px",
//                 backgroundColor: "white",
//               }}
//               dangerouslySetInnerHTML={{ __html: processTextSecond(content) }}
//             ></div>

//             {/* Formula Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "110px",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowModal(true)}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt="Formula"
//               />
//             </div>

//             {/* Image Upload Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "70px",
//                 cursor: "pointer",
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt="Image Icon"
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileSelect(e, "main")}
//               />
//             </div>

//             {/* Recording Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "30px",
//                 cursor: "pointer",
//               }}
//               onClick={() => toggleSpeechToText("main")}
//             >
//               <img
//                 style={{
//                   height: "18px",
//                   width: "17px",
//                   animation: isRecording ? "blink 1s infinite" : "none",
//                 }}
//                 src={isRecording ? RecordingActive : RecordingStatic}
//                 alt="Recording Icon"
//               />
//             </div>
//           </div>

//           {/* Additional buttons */}
//           {renderOptions()}
//         </div>

//         {/* Draggable divider */}
//         <div
//           style={{
//             position: "relative",
//             cursor: "col-resize",
//             width: "10px",
//             margin: "0 -5px",
//             zIndex: 20,
//           }}
//           onMouseDown={handleMouseDown}
//         >
//           <div
//             style={{
//               marginTop: "5vh",
//               position: "absolute",
//               top: 0,
//               bottom: 0,
//               left: "50%",
//               borderLeft: "2px dotted #ccc",
//               height: "87%",
//             }}
//           >
//             {/* Triangle pointer */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 right: "-6px",
//                 width: 0,
//                 height: 0,
//                 borderTop: "6px solid transparent",
//                 borderBottom: "6px solid transparent",
//                 borderLeft: "6px solid #ccc",
//                 transform: "translateY(-50%)",
//               }}
//             />
//           </div>
//         </div>

//         {/* Right side with options */}

//         {/* Right Section */}

//         <div style={{ width: `${100 - dividerPosition}%` }}>
//           <p style={{ marginTop: "2.2vh" }}>Preview :</p>

//           <div
//             style={{
//               width: "100%",
//               border: "1px solid #ccc",
//               padding: "10px",
//               backgroundColor: "white",
//               minHeight: "100px",
//               whiteSpace: "pre-wrap",
//               marginTop: "1vh",
//             }}
//           >
//             <div>
//               <strong style={{ paddingBottom: "15px", paddingTop: "8px" }}>
//                 Question:
//               </strong>
//               <div
//                 style={{ padding: "8px" }}
//                 dangerouslySetInnerHTML={{
//                   __html: processText(content),
//                 }}
//               ></div>
//             </div>
//             <div>{renderRightOptions()}</div>
//           </div>
//         </div>
//       </div>

//       <Modal show={showModal} onClose={() => setShowModal(false)}>
//         <h2 style={{ color: "white" }}>MathLive Input</h2>
//         <MathLive onLatexChange={handleLatexChange} />
//         <button
//           onClick={sendToTextBox}
//           style={{ marginTop: "10px", cursor: "pointer" }}
//         >
//           Send to Text Box
//         </button>
//       </Modal>
//     </div>
//   );
// };

// export default React.memo(ReviewComponent);

// import React, { useState, useRef, useEffect } from "react";
// import Modal from "../../POP/Modal"; // Import the modal component
// import MathLive from "../../POP/FileComp7"; // Import MathLive component
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
// import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
// import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
// import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
// import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";
// import DeleteBin from "../../../Assets/Images/CommanImages/Delete.png";
// const ReviewComponent = ({
//   width = "100%",
//   height = "auto",
//   htmlContent,
//   questionCounter,
//   currentQuestion,
//   questionText,
//   optionFromAnotherPage,
//   quesType,
//   quesNo,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   onQuestionUpdate,
//   setCurrentQuestion,
//   fetchNewUpdatedDataValues,
// }) => {
//   const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
//   const recognitionRef = useRef(null); // Ref for the speech recognition object
//   const contentEditableRef = useRef(null);
//   const [images, setImages] = useState([]); // Stores actual image files
//   const [showModal, setShowModal] = useState(false); // Modal state
//   const [latex, setLatex] = useState(""); // MathLive LaTeX content state
//   const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
//   const [isClicked, setIsClicked] = useState(false);
//   const fileInputRef = useRef(null); // Ref for the hidden file input
//   const [questionType, setQuestionType] = useState("multi-select"); // Tracks question type0
//   const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
//   const [hasCounterChanged, setHasCounterChanged] = useState(false);
//   const [checkedOptions, setCheckedOptions] = useState({});
//   const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)
//   const [initialOptions, setInitialOptions] = useState([]); // Store the initial options
//   const [content, setContent] = useState(htmlContent || "");
//   const [isDragging, setIsDragging] = useState(false);
//   const [dividerPosition, setDividerPosition] = useState(50);
//   const containerRef = useRef(null);
//   const [editableOptions, setEditableOptions] = useState([]);

//   // const [editableOptions, setEditableOptions] = useState(
//   //   optionFromAnotherPage?.map((opt) => ({
//   //     ...opt,
//   //     id: opt.option_no,
//   //     content: opt.option_text,
//   //     isChecked: opt.option_correct_flag === 1,
//   //   })) || []
//   // );
//   useEffect(() => {
//     if (optionFromAnotherPage) {
//       const timer = setTimeout(() => {
//         setEditableOptions(
//           optionFromAnotherPage.map((opt) => ({
//             ...opt,
//             id: opt.option_no,
//             content: opt.option_text,
//             isChecked: opt.option_correct_flag === 1, // Delayed setting of isChecked
//           }))
//         );
//       }, 1500); // 2-second delay

//       // Clear timer if component unmounts or optionFromAnotherPage changes
//       return () => clearTimeout(timer);
//     }
//   }, [optionFromAnotherPage]);

//   const handleCheckboxChange = (index) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((opt, idx) => ({
//         ...opt,
//         isChecked: idx === index ? !opt.isChecked : opt.isChecked,
//         option_correct_flag:
//           idx === index ? (opt.isChecked ? 0 : 1) : opt.option_correct_flag,
//       }))
//     );
//   };

//   const handleMouseDown = () => {
//     setIsDragging(true);
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging && containerRef.current) {
//       const containerRect = containerRef.current.getBoundingClientRect();
//       const newPosition =
//         ((e.clientX - containerRect.left) / containerRect.width) * 100;
//       setDividerPosition(Math.min(Math.max(newPosition, 20), 80));
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   useEffect(() => {
//     if (isDragging) {
//       document.addEventListener("mousemove", handleMouseMove);
//       document.addEventListener("mouseup", handleMouseUp);
//     }
//     return () => {
//       document.removeEventListener("mousemove", handleMouseMove);
//       document.removeEventListener("mouseup", handleMouseUp);
//     };
//   }, [isDragging]);

//   useEffect(() => {
//     const mapQuesTypeToQuestionType = {
//       1: "multi-select",
//       2: "multi-select",
//       3: "fill-in-blanks",
//       4: "boolean",
//     };
//     const initialQuestionType =
//       mapQuesTypeToQuestionType[quesType] || "multi-select";
//     setQuestionType(initialQuestionType);
//   }, [quesType]);

//   const mainEditableRef = useRef(null);
//   const refs = useRef([]); // Refs for all editable options

//   useEffect(() => {
//     if (optionFromAnotherPage && optionFromAnotherPage.length > 0) {
//       // Save initial options
//       setInitialOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           ...opt,
//           id: opt.id || index + 1,
//         }))
//       );

//       // Create editable options
//       setEditableOptions(
//         optionFromAnotherPage.map((opt, index) => ({
//           id: opt.id || index + 1,
//           content: opt.option_text || "",
//         }))
//       );
//     }
//   }, [optionFromAnotherPage]);

//   // Populate refs dynamically for all options
//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   useEffect(() => {
//     if (htmlContent !== content) {
//       setContent(htmlContent);
//     }
//   }, [htmlContent]);
//   const renderLatexToHTML = (text) => {
//     try {
//       let html = text;

//       // Replace LaTeX
//       html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//           displayMode: true,
//         })
//       );

//       html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
//         katex.renderToString(latex, {
//           throwOnError: false,
//         })
//       );

//       // Replace image placeholders with actual images
//       images.forEach((image) => {
//         const placeholder = `[${image.id}_${image.alt}]`;
//         const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
//         html = html.replace(placeholder, imgTag);
//       });

//       return html;
//     } catch (error) {
//       console.error("Error rendering HTML:", error);
//       return text;
//     }
//   };
//   const handleDeleteOption = (id) => {
//     setEditableOptions((prevOptions) =>
//       prevOptions.filter((option) => option.id !== id)
//     );
//   };

//   const handleInput = (id = "main") => {
//     const ref =
//       id === "main"
//         ? mainEditableRef.current
//         : refs.current.find((r, i) => i + 1 === id)?.current;

//     if (!ref) {
//       console.warn(`No ref found for id: ${id}`);
//       return;
//     }

//     // Save current selection (cursor position)
//     const selection = window.getSelection();
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Update content state
//     const contentHTML = ref.innerHTML.trim();
//     if (id === "main") {
//       console.log("questionEditing");
//       setContent(contentHTML);
//     } else {
//       console.log("optEditing", id);
//       setEditableOptions((prevOptions) =>
//         prevOptions.map((option) =>
//           option.id === id ? { ...option, content: contentHTML } : option
//         )
//       );
//     }

//     // Restore cursor position after the DOM updates
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function setCursor(node) {
//         if (node.nodeType === 3) {
//           // Text node
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (setCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }
//       setCursor(ref);
//     }, 0);
//   };

//   useEffect(() => {
//     refs.current = editableOptions.map(
//       (_, i) => refs.current[i] || React.createRef()
//     );
//   }, [editableOptions]);

//   const startSpeechToText = () => {
//     if (
//       !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
//     ) {
//       alert("Speech-to-text is not supported in this browser.");
//       return;
//     }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!recognitionRef.current) {
//       const recognition = new SpeechRecognition();
//       recognition.lang = "en-US";
//       recognition.interimResults = true;
//       recognition.continuous = true;

//       recognition.onstart = () => setIsRecording(true);

//       recognition.onresult = (event) => {
//         const mainDiv = mainEditableRef.current; // Main contentEditable div
//         const selection = window.getSelection();
//         const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

//         for (let i = event.resultIndex; i < event.results.length; i++) {
//           const transcript = event.results[i][0].transcript;

//           if (event.results[i].isFinal) {
//             const textNode = document.createTextNode(transcript + " ");
//             if (range) {
//               range.deleteContents();
//               range.insertNode(textNode);
//               range.setStartAfter(textNode);
//               range.setEndAfter(textNode);
//               selection.removeAllRanges();
//               selection.addRange(range);
//             } else {
//               mainDiv.appendChild(textNode);
//             }
//             handleInput("main"); // Update state after inserting speech text
//           }
//         }
//       };

//       recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error);
//         setIsRecording(false);
//       };

//       recognition.onend = () => setIsRecording(false);

//       recognitionRef.current = recognition;
//     }

//     recognitionRef.current.start();
//   };

//   const stopSpeechToText = () => {
//     if (recognitionRef.current) {
//       recognitionRef.current.stop();
//       setIsRecording(false);
//     }
//   };
//   const toggleSpeechToText = () => {
//     if (isRecording) {
//       stopSpeechToText();
//     } else {
//       startSpeechToText();
//     }
//   };

//   // const handleFileSelect = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     const reader = new FileReader();
//   //     reader.onload = (event) => {
//   //       const img = document.createElement("img");
//   //       img.src = event.target.result;
//   //       img.alt = file.name || "selected-image";
//   //       img.classList.add("inserted-image"); // Add the CSS class

//   //       // Insert image at the current cursor position
//   //       const selection = window.getSelection();
//   //       const range = selection.getRangeAt(0);
//   //       range.deleteContents();
//   //       range.insertNode(img);

//   //       handleInput();
//   //     };
//   //     reader.readAsDataURL(file);
//   //   }
//   // };
//   const handleFileSelect = (e, id = "main") => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const imageIndex = images.length + 1;
//         const imageName = `image${imageIndex}.png`;
//         const placeholder = `#<${imageName}>#`;

//         // Insert image in the editor at the current cursor position
//         const img = document.createElement("img");
//         img.src = event.target.result;
//         img.classList.add("Img-RQ-QnsAns");
//         img.alt = imageName;

//         const selection = window.getSelection();
//         const range = selection.getRangeAt(0);
//         range.deleteContents();
//         range.insertNode(img);

//         // Store the image data
//         setImages((prevImages) => [
//           ...prevImages,
//           { name: imageName, src: event.target.result, placeholder },
//         ]);

//         // Trigger appropriate input handler to update content
//         if (id === "main") {
//           handleInput("main");
//         } else {
//           const index = editableOptions.findIndex((opt) => opt.id === id);
//           if (index !== -1) handleOptionInput(index);
//         }
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // const handleFileSelect = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     const reader = new FileReader();
//   //     reader.onload = (event) => {
//   //       const imageName = `image${images.length + 1}.png`;
//   //       const imageTag = `#<${imageName}>#`;

//   //       // Insert the image tag at the current cursor position
//   //       const selection = window.getSelection();
//   //       const range = selection.getRangeAt(0);
//   //       range.deleteContents();
//   //       const textNode = document.createTextNode(imageTag);
//   //       range.insertNode(textNode);

//   //       // Add the image to the images list
//   //       setImages((prevImages) => [
//   //         ...prevImages,
//   //         { name: imageName, src: event.target.result },
//   //       ]);

//   //       handleInput();
//   //     };
//   //     reader.readAsDataURL(file);
//   //   }
//   // };

//   const handleAddOption = () => {
//     const newOption = {
//       id: editableOptions.length + 1,
//       content: "",
//       weight: "",
//     };
//     setEditableOptions([...editableOptions, newOption]);
//   };

//   // const handlePaste = (e, id = "main") => {
//   //   e.preventDefault();
//   //   const ref =
//   //     id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//   //   const items = e.clipboardData.items;

//   //   for (let item of items) {
//   //     if (item.type.startsWith("image/")) {
//   //       const blob = item.getAsFile();
//   //       const imageId = images.length + 1; // Assign serial number
//   //       const imageName = blob.name || `pasted-image-${imageId}`;

//   //       // Create a placeholder text for the image
//   //       const placeholderText = `[${imageId}_${imageName}]`;

//   //       // Insert placeholder text in the editable div
//   //       document.execCommand("insertText", false, placeholderText);

//   //       // Read and store the actual image for rendering
//   //       const reader = new FileReader();
//   //       reader.onload = (event) => {
//   //         setImages((prevImages) => [
//   //           ...prevImages,
//   //           { id: imageId, src: event.target.result, alt: imageName },
//   //         ]);
//   //       };
//   //       reader.readAsDataURL(blob);

//   //       handleInput(id);
//   //     } else if (item.type === "text/plain") {
//   //       const text = e.clipboardData.getData("text/plain");
//   //       document.execCommand("insertText", false, text);
//   //       handleInput(id);
//   //     }
//   //   }
//   // };
//   const handlePaste = (e, id = "main") => {
//     e.preventDefault();
//     const ref =
//       id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
//     const items = e.clipboardData.items;

//     for (let item of items) {
//       if (item.type.startsWith("image/")) {
//         const blob = item.getAsFile();
//         const imageId = images.length + 1;
//         const imageName = blob.name || `pasted-image-${imageId}`;
//         const placeholderText = `#<${imageName}>#`;

//         // Insert placeholder text in the editable div
//         document.execCommand("insertText", false, placeholderText);

//         // Read and store the actual image
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImages((prevImages) => [
//             ...prevImages,
//             { id: imageId, src: event.target.result, alt: imageName, placeholder: placeholderText },
//           ]);
//         };
//         reader.readAsDataURL(blob);

//         if (id === "main") {
//           handleInput("main");
//         } else {
//           const index = editableOptions.findIndex((opt) => opt.id === id);
//           if (index !== -1) handleOptionInput(index);
//         }
//       } else if (item.type === "text/plain") {
//         const text = e.clipboardData.getData("text/plain");
//         document.execCommand("insertText", false, text);
//         handleInput(id);
//       }
//     }
//   };

//   const handleLatexChange = (newLatex) => {
//     setLatex(newLatex);
//   };

//   const sendToTextBox = () => {
//     const mathLatex = `\\(${latex}\\)`;

//     if (focusedOption === "main") {
//       // Append to main editable div
//       if (mainEditableRef.current) {
//         mainEditableRef.current.innerHTML += mathLatex;
//         handleInput("main"); // Update the state
//       }
//     } else {
//       // Append to specific option
//       const focusedRef = refs.current.find(
//         (ref, index) => ref.current && index + 1 === focusedOption
//       )?.current;
//       if (focusedRef) {
//         focusedRef.innerHTML += mathLatex;
//         handleInput(focusedOption); // Update the state for the specific option
//       }
//     }

//     setShowModal(false); // Close the modal
//   };

//   const fileInputRefs = useRef([]); // File input refs for each option
//   const renderActionButtons = (index, id) => {
//     return (
//       focusedOption === id && (
//         <>
//           {/* Formula Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "110px",
//               cursor: "pointer",
//             }}
//             onClick={() => setShowModal(true)}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={Formulafx}
//               alt="Formula"
//             />
//           </div>

//           {/* Image Upload Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "70px",
//               cursor: "pointer",
//             }}
//             onClick={() => fileInputRefs.current[index].click()}
//           >
//             <img
//               style={{ height: "18px", width: "17px" }}
//               src={ImgIcon}
//               alt="Image Icon"
//             />
//             <input
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[index] = el)}
//               style={{ display: "none" }}
//               onChange={(e) => handleFileSelect(e, id)}
//             />
//           </div>

//           {/* Recording Button */}
//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "30px",
//               cursor: "pointer",
//             }}
//             onClick={() => toggleSpeechToText(id)}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//                 animation: isRecording ? "blink 1s infinite" : "none",
//               }}
//               src={isRecording ? RecordingActive : RecordingStatic}
//               alt="Recording Icon"
//             />
//           </div>

//           <div
//             style={{
//               position: "absolute",
//               top: "5px",
//               right: "150px",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               style={{
//                 height: "18px",
//                 width: "17px",
//               }}
//               onClick={() => handleDeleteOption(id)} // Call delete handler
//               src={DeleteBin}
//               alt="DeleteBin"
//             />
//           </div>
//         </>
//       )
//     );
//   };
//   const renderOptions = () => {
//     switch (questionType) {
//       case "multi-select":
//         return editableOptions.map((opt, index) => (
//           <div
//             key={opt.id || index}
//             style={{
//               display: "flex",
//               flexDirection: "column", // Ensure elements are stacked vertically
//               marginBottom: "10px",
//               position: "relative",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <input
//                 type="checkbox"
//                 checked={opt.isChecked}
//                 onChange={() => handleCheckboxChange(index)}
//                 style={{
//                   marginRight: "10px",
//                   cursor: "pointer",
//                   accentColor: "##D6D6D6",
//                 }}
//               />

//               <input
//                 type="number"
//                 placeholder="Weight"
//                 value={opt.weight || ""}
//                 onChange={(e) =>
//                   setEditableOptions((prevOptions) =>
//                     prevOptions.map((o, i) =>
//                       i === index ? { ...o, weight: e.target.value } : o
//                     )
//                   )
//                 }
//                 style={{
//                   marginRight: "10px",
//                   width: "60px",
//                   border: "1px solid #6A6A6A",
//                   padding: "5px",
//                 }}
//               />
//               <div
//                 contentEditable
//                 ref={(el) => (refs.current[index] = { current: el })}
//                 onFocus={() => setFocusedOption(opt.id)}
//                 onInput={() => handleOptionInput(index)}
//                 onPaste={(e) => handlePaste(e, opt.id)}
//                 style={{
//                   border: "1px solid #6A6A6A",
//                   padding: "10px",
//                   minHeight: "40px",
//                   width: "100%",
//                   backgroundColor: "#fff",
//                   paddingTop: "25px",
//                 }}
//                 dangerouslySetInnerHTML={{
//                   __html: processTextSecond(opt.content || ""),
//                 }}
//               ></div>
//               {renderActionButtons(index, opt.id)}
//             </div>
//             <div style={{ textAlign: "right", marginTop: "10px" }}>
//               {index === editableOptions.length - 1 &&
//                 focusedOption === opt.id && (
//                   <img
//                     onClick={handleAddOption}
//                     src={YellowPlus}
//                     alt="Option_Add"
//                     className="YellowPlus-RC-Button"
//                   />
//                 )}
//             </div>
//           </div>
//         ));
//       case "fill-in-blanks":
//         return (
//           <div style={{ position: "relative" }}>
//             <div
//               contentEditable
//               ref={(el) => (refs.current[0] = { current: el })}
//               onFocus={() => setFocusedOption(editableOptions[0]?.id || 1)}
//               onInput={() => handleInput(editableOptions[0]?.id || 1)}
//               onPaste={(e) => handlePaste(e, editableOptions[0]?.id || 1)}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "10px",
//                 minHeight: "40px",
//                 width: "100%",
//                 backgroundColor: "#fff",
//                 paddingTop: "25px",
//               }}
//               dangerouslySetInnerHTML={{
//                 __html: editableOptions[0]?.content,
//               }}
//             ></div>

//             {/* Action Buttons */}
//             {renderActionButtons(0, editableOptions[0]?.id || 1)}
//           </div>
//         );

//       case "boolean":
//         return (
//           <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="true" />
//               <span style={{ marginLeft: "10px" }}>True</span>
//             </label>
//             <label style={{ display: "flex", alignItems: "center" }}>
//               <input type="radio" name="boolean" value="false" />
//               <span style={{ marginLeft: "10px" }}>False</span>
//             </label>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   useEffect(() => {
//     if (hasCounterChanged) {
//     } else {
//       setHasCounterChanged(true); // Mark the initial render
//     }
//   }, [questionCounter]);

//   useEffect(() => {
//     if (questionText !== content) {
//       setContent(questionText);
//     }
//   }, [questionText]);

//   const processTextSecond = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     return text;
//   };

//   const processText = (text) => {
//     // Replace custom <image> tags with standard <img> tags
//     text = text.replace(
//       /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
//       '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
//     );

//     // Replace `imgsrc` placeholders with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     // Render LaTeX expressions
//     const latexRegex = /\\\((.*?)\\\)/g;
//     text = text.replace(latexRegex, (match, p1) => {
//       return katex.renderToString(p1, { throwOnError: false });
//     });

//     return text;
//   };

//   // const handleOptionInput = (index) => {
//   //   console.log("Handling input for option:", index);

//   //   // Ensure the ref exists for the current option
//   //   const ref = refs.current[index]?.current;
//   //   if (!ref) {
//   //     console.warn(`No ref found for option at index: ${index}`);
//   //     return;
//   //   }

//   //   // Get the current content of the editable div

//   //   // Update the state for the editable option
//   //   setEditableOptions((prevOptions) =>
//   //     prevOptions.map((option, i) =>
//   //       i === index ? { ...option, content: contentHTML } : option
//   //     )
//   //   );

//   //   // Save cursor position
//   //   const selection = window.getSelection();
//   //   const range = selection.getRangeAt(0);
//   //   const preCaretRange = range.cloneRange();
//   //   preCaretRange.selectNodeContents(ref);
//   //   preCaretRange.setEnd(range.endContainer, range.endOffset);
//   //   const cursorPosition = preCaretRange.toString().length;

//   //   // Get current content from the editable div
//   //   const contentHTML = ref.innerHTML.trim();
//   //   console.log(`Content for option ${index}:`, contentHTML);

//   //   // Use the dedicated function to update editableOptions
//   //   handleOptionContentUpdate(index, contentHTML);

//   //   // Restore cursor position after DOM update
//   //   setTimeout(() => {
//   //     const newRange = document.createRange();
//   //     const newSelection = window.getSelection();
//   //     let charCount = 0;

//   //     function restoreCursor(node) {
//   //       if (node.nodeType === 3) {
//   //         const nextCharCount = charCount + node.length;
//   //         if (cursorPosition <= nextCharCount) {
//   //           newRange.setStart(node, cursorPosition - charCount);
//   //           newRange.collapse(true);
//   //           newSelection.removeAllRanges();
//   //           newSelection.addRange(newRange);
//   //           return true;
//   //         }
//   //         charCount = nextCharCount;
//   //       } else {
//   //         for (let i = 0; i < node.childNodes.length; i++) {
//   //           if (restoreCursor(node.childNodes[i])) return true;
//   //         }
//   //       }
//   //       return false;
//   //     }

//   //     restoreCursor(ref);
//   //   }, 0);
//   // };
//   const handleOptionInput = (index) => {
//     console.log("Handling input for option:", index);

//     const ref = refs.current[index]?.current;
//     if (!ref) {
//       console.warn(`No ref found for option at index: ${index}`);
//       return;
//     }

//     // Save current selection (cursor position)
//     const selection = window.getSelection();
//     if (!selection || selection.rangeCount === 0) {
//       console.warn("No valid selection detected.");
//       return;
//     }
//     const range = selection.getRangeAt(0);
//     const preCaretRange = range.cloneRange();
//     preCaretRange.selectNodeContents(ref);
//     preCaretRange.setEnd(range.endContainer, range.endOffset);
//     const cursorPosition = preCaretRange.toString().length;

//     // Get the current content from the editable div
//     const contentHTML = ref.innerHTML.trim();
//     console.log(`Content for option ${index}:`, contentHTML);

//     // Update the state for the specific option
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: contentHTML } : option
//       )
//     );

//     // Restore cursor position after DOM update
//     setTimeout(() => {
//       const newRange = document.createRange();
//       const newSelection = window.getSelection();
//       let charCount = 0;

//       function restoreCursor(node) {
//         if (node.nodeType === 3) {
//           const nextCharCount = charCount + node.length;
//           if (cursorPosition <= nextCharCount) {
//             newRange.setStart(node, cursorPosition - charCount);
//             newRange.collapse(true);
//             newSelection.removeAllRanges();
//             newSelection.addRange(newRange);
//             return true;
//           }
//           charCount = nextCharCount;
//         } else {
//           for (let i = 0; i < node.childNodes.length; i++) {
//             if (restoreCursor(node.childNodes[i])) return true;
//           }
//         }
//         return false;
//       }
//       restoreCursor(ref);
//     }, 0);
//   };

//   const renderRightOptions = () => {
//     return editableOptions.map((opt, index) => (
//       <div
//         key={opt.id}
//         style={{
//           marginBottom: "10px",
//           padding: "10px",
//           display: "flex",
//           alignItems: "flex-start",
//           gap: "10px",
//         }}
//       >
//         {/* <input
//           type="checkbox"
//           style={{
//             marginTop: "5px",
//             flexShrink: 0,
//           }}
//         /> */}
//         <strong   style={{
//             marginTop: "5px",
//             flexShrink: 0,
//           }}>Option {index + 1}:</strong>
//         <div
//           style={{
//             padding: "5px",
//             flex: 1,
//           }}
//           dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
//         />
//       </div>
//     ));
//   };

//   const handleOptionContentUpdate = (index, newContent) => {
//     console.log(`Updating content for option ${index}:`, newContent);
//     setEditableOptions((prevOptions) =>
//       prevOptions.map((option, i) =>
//         i === index ? { ...option, content: newContent } : option
//       )
//     );
//   };

//   // useEffect(() => {
//   //   if (onQuestionUpdate) {
//   //     onQuestionUpdate({
//   //       question_text: content, // Pass updated question text
//   //       options: editableOptions.map((opt) => ({
//   //         option_no: opt.id,
//   //         option_text: opt.content, // Pass updated option text
//   //         option_correct_flag: opt.isChecked ? 1 : 0,
//   //       })),
//   //     });
//   //   }
//   // }, [content, editableOptions, onQuestionUpdate]);

//   useEffect(() => {
//     if (onQuestionUpdate) {
//       onQuestionUpdate({
//         question_text: questionText, // Updated question text
//         options: optionFromAnotherPage, // Updated options
//       });
//     }
//   }, [questionText, optionFromAnotherPage, onQuestionUpdate]);

//   // const handleQuestionEdit = (updatedData) => {
//   //   setCurrentQuestion((prevQuestion) => ({
//   //     ...prevQuestion,
//   //     question_text: updatedData.question_text,
//   //     options: updatedData.options,
//   //   }));
//   // };

//   // const handleFetchDataClick = () => {
//   //   const updatedData = fetchNewUpdatedDataValues();
//   //   console.log("Updated Data:", updatedData);
//   // };
//   const handleFetchAndUpdate = () => {
//     const updatedData = {
//       question_text: content,
//       options: editableOptions.map((opt) => ({
//         option_no: opt.id,
//         option_text: opt.content,
//         option_correct_flag: opt.isChecked ? 1 : 0,
//       })),
//       images, // Include the images list
//     };
//     console.log("Updated Data:", updatedData);

//     if (fetchNewUpdatedDataValues) {
//       fetchNewUpdatedDataValues(updatedData); // Send updated data to parent
//     }
//   };

//   // Example: Sending the images list to the parent component
//   // useEffect(() => {
//   //   if (fetchNewUpdatedDataValues) {
//   //     fetchNewUpdatedDataValues({ images });
//   //   }
//   // }, [images, fetchNewUpdatedDataValues]);

//   // Trigger handleFetchAndUpdate when content or options change
//   // useEffect(() => {
//   //   handleFetchAndUpdate();
//   // }, [content, editableOptions]);
//   // Trigger handleFetchAndUpdate when content, options, or images change
//   useEffect(() => {
//     handleFetchAndUpdate();
//   }, [content, editableOptions, images]);

//   // console.log(content + "contetn");
//   // console.log(htmlContent + "htmlContent");
//   // console.log("Editable Options:", JSON.stringify(editableOptions, null, 2));
//   // useEffect(() => {
//   //   console.log("htmlContent updated:", htmlContent);
//   //   console.log("Editable options updated:", editableOptions);
//   // }, [htmlContent, editableOptions]);
//   // console.log("Refs after rendering:", refs.current);
//   // useEffect(() => {
//   //   console.log("Updated editableOptions:", editableOptions);
//   // }, [editableOptions]);
//   // useEffect(() => {
//   //   console.log("Refs after rendering:", refs.current);
//   // }, [editableOptions]);

//   return (
//     <div
//       style={{
//         position: "relative",
//         width,
//         height,
//         backgroundColor: "#FBFBFB",
//         padding: "10px",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           width: "100%",
//           gap: "20px",
//           userSelect: isDragging ? "none" : "auto",
//         }}
//         ref={containerRef}
//       >
//         {/* Left Section */}
//         <div style={{ width: `${dividerPosition}%` }}>
//           {/* Main editable div */}

//           <p style={{ marginTop: "20px", marginBottom: "10px" }}>
//             Question Text :
//           </p>
//           <div style={{ position: "relative" }}>
//             {/* Main ContentEditable Div */}
//             <div
//               contentEditable
//               ref={mainEditableRef}
//               onFocus={() => setFocusedOption("main")}
//               onInput={() => handleInput("main")}
//               onPaste={(e) => handlePaste(e, "main")}
//               style={{
//                 border: "1px solid #6A6A6A",
//                 padding: "22px 10px 10px", // top, left/right, bottom
//                 marginBottom: "20px",
//                 minHeight: "100px",
//                 backgroundColor: "white",
//               }}
//               dangerouslySetInnerHTML={{ __html: processTextSecond(content) }}
//             ></div>

//             {/* Formula Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "110px",
//                 cursor: "pointer",
//               }}
//               onClick={() => setShowModal(true)}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={Formulafx}
//                 alt="Formula"
//               />
//             </div>

//             {/* Image Upload Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "70px",
//                 cursor: "pointer",
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               <img
//                 style={{ height: "18px", width: "17px" }}
//                 src={ImgIcon}
//                 alt="Image Icon"
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileSelect(e, "main")}
//               />
//             </div>

//             {/* Recording Button */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "5px",
//                 right: "30px",
//                 cursor: "pointer",
//               }}
//               onClick={() => toggleSpeechToText("main")}
//             >
//               <img
//                 style={{
//                   height: "18px",
//                   width: "17px",
//                   animation: isRecording ? "blink 1s infinite" : "none",
//                 }}
//                 src={isRecording ? RecordingActive : RecordingStatic}
//                 alt="Recording Icon"
//               />
//             </div>
//           </div>

//           {/* Additional buttons */}
//           {renderOptions()}
//         </div>

//         {/* Draggable divider */}
//         <div
//           style={{
//             position: "relative",
//             cursor: "col-resize",
//             width: "10px",
//             margin: "0 -5px",
//             zIndex: 20,
//           }}
//           onMouseDown={handleMouseDown}
//         >
//           <div
//             style={{
//               marginTop: "5vh",
//               position: "absolute",
//               top: 0,
//               bottom: 0,
//               left: "50%",
//               borderLeft: "2px dotted #ccc",
//               height: "87%",
//             }}
//           >
//             {/* Triangle pointer */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 right: "-6px",
//                 width: 0,
//                 height: 0,
//                 borderTop: "6px solid transparent",
//                 borderBottom: "6px solid transparent",
//                 borderLeft: "6px solid #ccc",
//                 transform: "translateY(-50%)",
//               }}
//             />
//           </div>
//         </div>

//         {/* Right side with options */}

//         {/* Right Section */}

//         <div style={{ width: `${100 - dividerPosition}%` }}>
//           <p style={{ marginTop: "2.2vh" }}>Preview :</p>

//           <div
//             style={{
//               width: "100%",
//               border: "1px solid #ccc",
//               padding: "10px",
//               backgroundColor: "white",
//               minHeight: "100px",
//               whiteSpace: "pre-wrap",
//               marginTop: "1vh",
//             }}
//           >
//             <div>
//               <strong style={{ paddingBottom: "15px", paddingTop: "8px" }}>
//                 Question:
//               </strong>
//               <div
//                 style={{ padding: "8px" }}
//                 dangerouslySetInnerHTML={{
//                   __html: processText(content),
//                 }}
//               ></div>
//             </div>
//             <div>{renderRightOptions()}</div>
//           </div>
//         </div>
//       </div>

//       <Modal show={showModal} onClose={() => setShowModal(false)}>
//         <h2 style={{ color: "white" }}>MathLive Input</h2>
//         <MathLive onLatexChange={handleLatexChange} />
//         <button
//           onClick={sendToTextBox}
//           style={{ marginTop: "10px", cursor: "pointer" }}
//         >
//           Send to Text Box
//         </button>
//       </Modal>
//     </div>
//   );
// };

// export default React.memo(ReviewComponent);

import React, { useState, useRef, useEffect } from "react";
import Modal from "../../POP/Modal"; // Import the modal component
import MathLive from "../../POP/FileComp7"; // Import MathLive component
import katex from "katex";
import "katex/dist/katex.min.css";
import ThreeDots from "../../../Assets/Images/CommanImages/ThreeDotsVertical.png";
import RecordingStatic from "../../../Assets/Images/CommanImages/RecordingStatic.png";
import RecordingActive from "../../../Assets/Images/CommanImages/RecordingActive.png";
import Formulafx from "../../../Assets/Images/CommanImages/Formula.png";
import ImgIcon from "../../../Assets/Images/CommanImages/imgIcon.png";
import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";
import DeleteBin from "../../../Assets/Images/CommanImages/Delete.png";
import Colors from "../../../Constants/Colors";
const ReviewComponent = ({
  width = "100%",
  height = "auto",
  htmlContent,
  questionCounter,
  currentQuestion,
  questionText,
  optionFromAnotherPage,
  quesType,
  quesNo,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  onQuestionUpdate,
  setCurrentQuestion,
  fetchNewUpdatedDataValues,
  globalImageCounter,
  setGlobalImageCounter,
  videoUrl,
  setVideoUrl,
  explanation,
  setExplanation,
}) => {
  const [solutionHTML, setSolutionHTML] = useState(explanation || "");
  const [videoLink, setVideoLink] = useState(videoUrl || "");

  const [isRecording, setIsRecording] = useState(false); // Speech-to-text state
  const recognitionRef = useRef(null); // Ref for the speech recognition object
  const contentEditableRef = useRef(null);
  const [images, setImages] = useState([]); // Stores actual image files
  const [showModal, setShowModal] = useState(false); // Modal state
  const [latex, setLatex] = useState(""); // MathLive LaTeX content state
  const [renderHtml, setRenderHtml] = useState(""); // Rendered HTML content
  const [isClicked, setIsClicked] = useState(false);
  const fileInputRef = useRef(null); // Ref for the hidden file input
  const [questionType, setQuestionType] = useState("multi-select"); // Tracks question type0
  const [questionTypeValue, setQuestionTypeValue] = useState(1); // New state for type value
  const [hasCounterChanged, setHasCounterChanged] = useState(false);
  const [checkedOptions, setCheckedOptions] = useState({});
  const [focusedOption, setFocusedOption] = useState("main"); // Tracks currently focused div (main or option)
  const [initialOptions, setInitialOptions] = useState([]); // Store the initial options
  const [content, setContent] = useState(htmlContent || "");
  const [isDragging, setIsDragging] = useState(false);
  const [dividerPosition, setDividerPosition] = useState(50);
  const containerRef = useRef(null);
  const [editableOptions, setEditableOptions] = useState([]);

  const solutionEditableRef = useRef(null);
  const [isSolutionRecording, setIsSolutionRecording] = useState(false);
  const solutionRecognitionRef = useRef(null);

  useEffect(() => {
    if (typeof setExplanation === "function") {
      setExplanation(solutionHTML);
    }
  }, [solutionHTML, setExplanation]);

  useEffect(() => {
    if (typeof setVideoUrl === "function") {
      setVideoUrl(videoLink);
    }
  }, [videoLink, setVideoUrl]);

  useEffect(() => {
    if (optionFromAnotherPage) {
      const timer = setTimeout(() => {
        setEditableOptions(
          optionFromAnotherPage.map((opt) => ({
            ...opt,
            id: opt.option_no,
            content: opt.option_text,
            isChecked: opt.option_correct_flag === 1, // Delayed setting of isChecked
          }))
        );
      }, 1500); // 2-second delay

      // Clear timer if component unmounts or optionFromAnotherPage changes
      return () => clearTimeout(timer);
    }
  }, [optionFromAnotherPage]);

  const handleCheckboxChange = (index) => {
    setEditableOptions((prevOptions) =>
      prevOptions.map((opt, idx) => ({
        ...opt,
        isChecked: idx === index ? !opt.isChecked : opt.isChecked,
        option_correct_flag:
          idx === index ? (opt.isChecked ? 0 : 1) : opt.option_correct_flag,
      }))
    );
  };

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseMove = (e) => {
    if (isDragging && containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const newPosition =
        ((e.clientX - containerRect.left) / containerRect.width) * 100;
      setDividerPosition(Math.min(Math.max(newPosition, 20), 80));
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    }
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging]);

  useEffect(() => {
    const mapQuesTypeToQuestionType = {
      1: "multi-select",
      2: "multi-select",
      3: "fill-in-blanks",
      4: "boolean",
    };
    const initialQuestionType =
      mapQuesTypeToQuestionType[quesType] || "multi-select";
    setQuestionType(initialQuestionType);
  }, [quesType]);

  const mainEditableRef = useRef(null);
  const refs = useRef([]); // Refs for all editable options

  useEffect(() => {
    if (optionFromAnotherPage && optionFromAnotherPage.length > 0) {
      // Save initial options
      setInitialOptions(
        optionFromAnotherPage.map((opt, index) => ({
          ...opt,
          id: opt.id || index + 1,
        }))
      );

      // Create editable options
      setEditableOptions(
        optionFromAnotherPage.map((opt, index) => ({
          id: opt.id || index + 1,
          content: opt.option_text || "",
        }))
      );
    }
  }, [optionFromAnotherPage]);

  // Populate refs dynamically for all options
  useEffect(() => {
    refs.current = editableOptions.map(
      (_, i) => refs.current[i] || React.createRef()
    );
  }, [editableOptions]);

  useEffect(() => {
    if (htmlContent !== content) {
      setContent(htmlContent);
    }
  }, [htmlContent]);
  const renderLatexToHTML = (text) => {
    try {
      let html = text;

      // Replace LaTeX
      html = html.replace(/\\\[(.*?)\\\]/gs, (_, latex) =>
        katex.renderToString(latex, {
          throwOnError: false,
          displayMode: true,
        })
      );

      html = html.replace(/\\\((.*?)\\\)/g, (_, latex) =>
        katex.renderToString(latex, {
          throwOnError: false,
        })
      );

      // Replace image placeholders with actual images
      images.forEach((image) => {
        const placeholder = `[${image.id}_${image.alt}]`;
        const imgTag = `<img src="${image.src}" alt="${image.alt}" style="max-width: 100px; max-height: 50px;" />`;
        html = html.replace(placeholder, imgTag);
      });

      return html;
    } catch (error) {
      console.error("Error rendering HTML:", error);
      return text;
    }
  };
  const handleDeleteOption = (id) => {
    setEditableOptions((prevOptions) =>
      prevOptions.filter((option) => option.id !== id)
    );
  };

  const handleInput = (id = "main") => {
    const ref =
      id === "main"
        ? mainEditableRef.current
        : refs.current.find((r, i) => i + 1 === id)?.current;

    if (!ref) {
      console.warn(`No ref found for id: ${id}`);
      return;
    }

    // Save current selection (cursor position)
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(ref);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    const cursorPosition = preCaretRange.toString().length;

    // Update content state
    const contentHTML = ref.innerHTML.trim();
    if (id === "main") {
      console.log("questionEditing");
      setContent(contentHTML);
    } else {
      console.log("optEditing", id);
      setEditableOptions((prevOptions) =>
        prevOptions.map((option) =>
          option.id === id ? { ...option, content: contentHTML } : option
        )
      );
    }

    // Restore cursor position after the DOM updates
    setTimeout(() => {
      const newRange = document.createRange();
      const newSelection = window.getSelection();
      let charCount = 0;

      function setCursor(node) {
        if (node.nodeType === 3) {
          // Text node
          const nextCharCount = charCount + node.length;
          if (cursorPosition <= nextCharCount) {
            newRange.setStart(node, cursorPosition - charCount);
            newRange.collapse(true);
            newSelection.removeAllRanges();
            newSelection.addRange(newRange);
            return true;
          }
          charCount = nextCharCount;
        } else {
          for (let i = 0; i < node.childNodes.length; i++) {
            if (setCursor(node.childNodes[i])) return true;
          }
        }
        return false;
      }
      setCursor(ref);
    }, 0);
  };

  useEffect(() => {
    refs.current = editableOptions.map(
      (_, i) => refs.current[i] || React.createRef()
    );
  }, [editableOptions]);

  const startSpeechToText = () => {
    if (
      !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
    ) {
      alert("Speech-to-text is not supported in this browser.");
      return;
    }

    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!recognitionRef.current) {
      const recognition = new SpeechRecognition();
      recognition.lang = "en-US";
      recognition.interimResults = true;
      recognition.continuous = true;

      recognition.onstart = () => setIsRecording(true);

      recognition.onresult = (event) => {
        const mainDiv = mainEditableRef.current; // Main contentEditable div
        const selection = window.getSelection();
        const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;

          if (event.results[i].isFinal) {
            const textNode = document.createTextNode(transcript + " ");
            if (range) {
              range.deleteContents();
              range.insertNode(textNode);
              range.setStartAfter(textNode);
              range.setEndAfter(textNode);
              selection.removeAllRanges();
              selection.addRange(range);
            } else {
              mainDiv.appendChild(textNode);
            }
            handleInput("main"); // Update state after inserting speech text
          }
        }
      };

      recognition.onerror = (event) => {
        console.error("Speech recognition error:", event.error);
        setIsRecording(false);
      };

      recognition.onend = () => setIsRecording(false);

      recognitionRef.current = recognition;
    }

    recognitionRef.current.start();
  };

  const stopSpeechToText = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
      setIsRecording(false);
    }
  };
  const toggleSpeechToText = () => {
    if (isRecording) {
      stopSpeechToText();
    } else {
      startSpeechToText();
    }
  };

  const handleFileSelect = (e, id = "main") => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const imageIndex = globalImageCounter + 1; // Use global counter
        const imageName = `image${imageIndex}.png`;
        const placeholder = `#<${imageName}>#`;

        // Increment the global counter
        setGlobalImageCounter(imageIndex);

        // Insert image in the editor at the current cursor position
        const img = document.createElement("img");
        img.src = event.target.result;
        img.classList.add("Img-RQ-QnsAns");
        img.alt = imageName;

        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        range.deleteContents();
        range.insertNode(img);

        // Store the image data
        setImages((prevImages) => [
          ...prevImages,
          { name: imageName, src: event.target.result, placeholder },
        ]);

        // Trigger appropriate input handler to update content
        if (id === "main") {
          handleInput("main");
        } else {
          const index = editableOptions.findIndex((opt) => opt.id === id);
          if (index !== -1) handleOptionInput(index);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddOption = () => {
    const newOption = {
      id: editableOptions.length + 1,
      content: "",
      weight: "",
    };
    setEditableOptions([...editableOptions, newOption]);
  };

  const handlePaste = (e, id = "main") => {
    e.preventDefault();
    const ref =
      id === "main" ? mainEditableRef.current : refs.current[id - 1]?.current;
    const items = e.clipboardData.items;

    for (let item of items) {
      if (item.type.startsWith("image/")) {
        const blob = item.getAsFile();
        const imageId = images.length + 1;
        const imageName = blob.name || `pasted-image-${imageId}`;
        const placeholderText = `#<${imageName}>#`;

        // Insert placeholder text in the editable div
        document.execCommand("insertText", false, placeholderText);

        // Read and store the actual image
        const reader = new FileReader();
        reader.onload = (event) => {
          setImages((prevImages) => [
            ...prevImages,
            {
              id: imageId,
              src: event.target.result,
              alt: imageName,
              placeholder: placeholderText,
            },
          ]);
        };
        reader.readAsDataURL(blob);

        if (id === "main") {
          handleInput("main");
        } else {
          const index = editableOptions.findIndex((opt) => opt.id === id);
          if (index !== -1) handleOptionInput(index);
        }
      } else if (item.type === "text/plain") {
        const text = e.clipboardData.getData("text/plain");
        document.execCommand("insertText", false, text);
        handleInput(id);
      }
    }
  };

  const handleLatexChange = (newLatex) => {
    setLatex(newLatex);
  };
  // In src/Pages/Parser/ReviewQuestion/ReviewComponent.jsx
  // Update the sendToTextBox function to properly handle different targets

  const sendToTextBox = () => {
    const mathLatex = `\\(${latex}\\)`;

    // If no target is focused, default to main
    if (!focusedOption) {
      if (mainEditableRef.current) {
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const textNode = document.createTextNode(mathLatex);
        range.deleteContents();
        range.insertNode(textNode);
        handleInput("main");
      }
      setShowModal(false);
      return;
    }

    // Handle main question text
    if (focusedOption === "main") {
      if (mainEditableRef.current) {
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const textNode = document.createTextNode(mathLatex);
        range.deleteContents();
        range.insertNode(textNode);
        handleInput("main");
      }
    }
    // Handle options text
    else {
      const optionRef = refs.current.find((ref) => ref?.current)?.current;
      if (optionRef) {
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const textNode = document.createTextNode(mathLatex);
        range.deleteContents();
        range.insertNode(textNode);
        handleInput(focusedOption);
      }
    }

    setShowModal(false);
    setLatex(""); // Clear latex after inserting
  };
  //   const sendToTextBox = () => {
  //     const mathLatex = `\\(${latex}\\)`;

  //     if (focusedOption === "main") {
  //       if (mainEditableRef.current) {
  //         mainEditableRef.current.innerHTML += mathLatex;
  //         handleInput("main");
  //       }
  //     } else if (focusedOption === "solution") {
  //       const el = solutionEditableRef.current;
  //       if (el) {
  //         el.focus();
  //         const selection = window.getSelection();
  //         if (
  //           selection &&
  //           selection.rangeCount > 0 &&
  //           el.contains(selection.anchorNode)
  //         ) {
  //           const range = selection.getRangeAt(0);
  //           // Insert as HTML so LaTeX is not escaped
  //           const span = document.createElement("span");
  //           span.innerHTML = mathLatex;
  //           range.deleteContents();
  //           range.insertNode(span);
  //           // Move cursor after inserted node
  //           range.setStartAfter(span);
  //           range.collapse(true);
  //           selection.removeAllRanges();
  //           selection.addRange(range);
  //         } else {
  //           // fallback: append at end
  //           el.innerHTML += mathLatex;
  //         }
  //         handleSolutionInput();
  //       }
  //     } else {
  //       // Option
  //       const focusedRef = refs.current.find(
  //         (ref, index) => ref.current && ref.current.id === focusedOption
  //       )?.current;
  //       if (focusedRef) {
  //         focusedRef.innerHTML += mathLatex;
  //         handleInput(focusedOption);
  //       }
  //     }

  //     setShowModal(false);
  //   };

  const fileInputRefs = useRef([]); // File input refs for each option
  const renderActionButtons = (index, id) => {
    return (
      focusedOption === id && (
        <>
          {/* Formula Button */}
          <div
            style={{
              position: "absolute",
              top: "5px",
              right: "110px",
              cursor: "pointer",
            }}
            onClick={() => setShowModal(true)}
          >
            <img
              style={{ height: "18px", width: "17px" }}
              src={Formulafx}
              alt="Formula"
            />
          </div>

          {/* Image Upload Button */}
          <div
            style={{
              position: "absolute",
              top: "5px",
              right: "70px",
              cursor: "pointer",
            }}
            onClick={() => fileInputRefs.current[index].click()}
          >
            <img
              style={{ height: "18px", width: "17px" }}
              src={ImgIcon}
              alt="Image Icon"
            />
            <input
              type="file"
              accept="image/*"
              ref={(el) => (fileInputRefs.current[index] = el)}
              style={{ display: "none" }}
              onChange={(e) => handleFileSelect(e, id)}
            />
          </div>

          {/* Recording Button */}
          <div
            style={{
              position: "absolute",
              top: "5px",
              right: "30px",
              cursor: "pointer",
            }}
            onClick={() => toggleSpeechToText(id)}
          >
            <img
              style={{
                height: "18px",
                width: "17px",
                animation: isRecording ? "blink 1s infinite" : "none",
              }}
              src={isRecording ? RecordingActive : RecordingStatic}
              alt="Recording Icon"
            />
          </div>

          <div
            style={{
              position: "absolute",
              top: "5px",
              right: "150px",
              cursor: "pointer",
            }}
          >
            <img
              style={{
                height: "18px",
                width: "17px",
              }}
              onClick={() => handleDeleteOption(id)} // Call delete handler
              src={DeleteBin}
              alt="DeleteBin"
            />
          </div>
        </>
      )
    );
  };
  const renderOptions = () => {
    switch (questionType) {
      case "multi-select":
        return editableOptions.map((opt, index) => (
          <div
            key={opt.id || index}
            style={{
              display: "flex",
              flexDirection: "column", // Ensure elements are stacked vertically
              marginBottom: "10px",
              position: "relative",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <input
                type="checkbox"
                className="delete-question-checkbox-dqc"
                checked={opt.isChecked}
                onChange={() => handleCheckboxChange(index)}
                style={{
                  marginRight: "10px",
                  cursor: "pointer",
                  accentColor: "##D6D6D6",
                }}
              />

              <input
                type="number"
                placeholder="Weight"
                value={opt.weight || ""}
                onChange={(e) =>
                  setEditableOptions((prevOptions) =>
                    prevOptions.map((o, i) =>
                      i === index ? { ...o, weight: e.target.value } : o
                    )
                  )
                }
                style={{
                  marginRight: "10px",
                  width: "60px",
                  border: "1px solid #6A6A6A",
                  padding: "5px",
                }}
              />
              <div
                contentEditable
                ref={(el) => (refs.current[index] = { current: el })}
                onFocus={() => setFocusedOption(opt.id)}
                onInput={() => handleOptionInput(index)}
                onPaste={(e) => handlePaste(e, opt.id)}
                style={{
                  border: "1px solid #6A6A6A",
                  padding: "10px",
                  minHeight: "40px",
                  width: "100%",
                  backgroundColor: "#fff",
                  paddingTop: "25px",
                }}
                dangerouslySetInnerHTML={{
                  __html: processTextSecond(opt.content || ""),
                }}
              ></div>
              {renderActionButtons(index, opt.id)}
            </div>
            <div style={{ textAlign: "right", marginTop: "10px" }}>
              {index === editableOptions.length - 1 &&
                focusedOption === opt.id && (
                  <img
                    onClick={handleAddOption}
                    src={YellowPlus}
                    alt="Option_Add"
                    className="YellowPlus-RC-Button"
                  />
                )}
            </div>
          </div>
        ));
      case "fill-in-blanks":
        return (
          <div style={{ position: "relative" }}>
            <div
              contentEditable
              ref={(el) => (refs.current[0] = { current: el })}
              onFocus={() => setFocusedOption(editableOptions[0]?.id || 1)}
              onInput={() => handleInput(editableOptions[0]?.id || 1)}
              onPaste={(e) => handlePaste(e, editableOptions[0]?.id || 1)}
              style={{
                border: "1px solid #6A6A6A",
                padding: "10px",
                minHeight: "40px",
                width: "100%",
                backgroundColor: "#fff",
                paddingTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: editableOptions[0]?.content,
              }}
            ></div>

            {/* Action Buttons */}
            {renderActionButtons(0, editableOptions[0]?.id || 1)}
          </div>
        );

      case "boolean":
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <label style={{ display: "flex", alignItems: "center" }}>
              <input type="radio" name="boolean" value="true" />
              <span style={{ marginLeft: "10px" }}>True</span>
            </label>
            <label style={{ display: "flex", alignItems: "center" }}>
              <input type="radio" name="boolean" value="false" />
              <span style={{ marginLeft: "10px" }}>False</span>
            </label>
          </div>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (hasCounterChanged) {
    } else {
      setHasCounterChanged(true); // Mark the initial render
    }
  }, [questionCounter]);

  useEffect(() => {
    if (questionText !== content) {
      setContent(questionText);
    }
  }, [questionText]);

  const processTextSecond = (text) => {
    if (!text) return "";

    text = text.replace(/&gt;/g, ">");
    text = text.replace(/&lt;/g, "<");
    text = text.replace(/&amp;/g, "&");

    text = text.replace(
      /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
      '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
    );

    text = text.replace(/(?:\s|^)(\S*?)imgsrc=([^\s]+)/g, (_, pre, url) => {
      const safePrefix = pre ? `${pre} ` : "";
      return `${safePrefix}<img src="${url}" class="Img-RQ-QnsAns" alt="image" />`;
    });

    return text;
  };

  const processText = (text) => {
    if (!text) return "";

    // Decode HTML entities
    text = text.replace(/&gt;/g, ">");
    text = text.replace(/&lt;/g, "<");
    text = text.replace(/&amp;/g, "&");

    // Handle <image .../> tags
    text = text.replace(
      /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
      '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
    );

    // Handle imgsrc=... placeholders
    // text = text.replace(
    //   /imgsrc=([^ ]+)/g,
    //   '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
    // );
    text = text.replace(
      /(?:\s|^)(\S*?)imgsrc=([^\s]+)/g,
      (_, textBefore, imgUrl) => {
        const cleanedText = textBefore ? `${textBefore} ` : "";
        return `${cleanedText}<img src="${imgUrl}" class="Img-RQ-QnsAns" alt="image" />`;
      }
    );

    // ✅ Handle multiline and inline LaTeX using the dotAll flag `s`
    // Block LaTeX: \[ ... \]
    text = text.replace(/\\\[(.+?)\\\]/gs, (_, latex) => {
      return katex.renderToString(latex, {
        throwOnError: false,
        displayMode: true,
      });
    });

    // Inline LaTeX: \( ... \)
    text = text.replace(/\\\((.+?)\\\)/gs, (_, latex) => {
      return katex.renderToString(latex, {
        throwOnError: false,
        displayMode: false,
      });
    });

    return text;
  };

  const handleOptionInput = (index) => {
    console.log("Handling input for option:", index);

    const ref = refs.current[index]?.current;
    if (!ref) {
      console.warn(`No ref found for option at index: ${index}`);
      return;
    }

    // Save current selection (cursor position)
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      console.warn("No valid selection detected.");
      return;
    }
    const range = selection.getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(ref);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    const cursorPosition = preCaretRange.toString().length;

    // Get the current content from the editable div
    const contentHTML = ref.innerHTML.trim();
    console.log(`Content for option ${index}:`, contentHTML);

    // Update the state for the specific option
    setEditableOptions((prevOptions) =>
      prevOptions.map((option, i) =>
        i === index ? { ...option, content: contentHTML } : option
      )
    );

    // Restore cursor position after DOM update
    setTimeout(() => {
      const newRange = document.createRange();
      const newSelection = window.getSelection();
      let charCount = 0;

      function restoreCursor(node) {
        if (node.nodeType === 3) {
          const nextCharCount = charCount + node.length;
          if (cursorPosition <= nextCharCount) {
            newRange.setStart(node, cursorPosition - charCount);
            newRange.collapse(true);
            newSelection.removeAllRanges();
            newSelection.addRange(newRange);
            return true;
          }
          charCount = nextCharCount;
        } else {
          for (let i = 0; i < node.childNodes.length; i++) {
            if (restoreCursor(node.childNodes[i])) return true;
          }
        }
        return false;
      }
      restoreCursor(ref);
    }, 0);
  };

  const renderRightOptions = () => {
    return editableOptions.map((opt, index) => (
      <div
        key={opt.id}
        style={{
          marginBottom: "10px",
          padding: "10px",
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
        }}
      >
        <strong
          style={{
            marginTop: "5px",
            flexShrink: 0,
          }}
        >
          Option {index + 1}:
        </strong>
        <div
          style={{
            padding: "5px",
            flex: 1,
          }}
          dangerouslySetInnerHTML={{ __html: processText(opt.content) }}
        />
      </div>
    ));
  };

  const handleOptionContentUpdate = (index, newContent) => {
    console.log(`Updating content for option ${index}:`, newContent);
    setEditableOptions((prevOptions) =>
      prevOptions.map((option, i) =>
        i === index ? { ...option, content: newContent } : option
      )
    );
  };

  useEffect(() => {
    if (onQuestionUpdate) {
      onQuestionUpdate({
        question_text: questionText, // Updated question text
        options: optionFromAnotherPage, // Updated options
      });
    }
  }, [questionText, optionFromAnotherPage, onQuestionUpdate]);

  const handleFetchAndUpdate = () => {
    const updatedData = {
      question_text: content,
      options: editableOptions.map((opt) => ({
        option_no: opt.id,
        option_text: opt.content,
        option_correct_flag: opt.isChecked ? 1 : 0,
      })),
      images,
      solution_text: solutionHTML, // <-- ADD THIS
      video_url: videoLink, // <-- ADD THIS if needed
    };

    console.log("Updated Data:", updatedData);

    if (fetchNewUpdatedDataValues) {
      fetchNewUpdatedDataValues(updatedData);
    }
  };

  // Trigger handleFetchAndUpdate when content, options, or images change
  useEffect(() => {
    handleFetchAndUpdate();
  }, [content, editableOptions, images, solutionHTML]);

  //Add a useEffect if the props might change later
  useEffect(() => {
    setSolutionHTML(explanation || "");
    setVideoLink(videoUrl || "");
  }, [explanation, videoUrl]);

  useEffect(() => {
    setExplanation(solutionHTML);
  }, [solutionHTML, setExplanation]);

  useEffect(() => {
    setVideoUrl(videoLink);
  }, [videoLink, setVideoUrl]);

  // Start/stop speech-to-text for solution
  const startSolutionSpeechToText = () => {
    if (
      !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
    ) {
      alert("Speech-to-text is not supported in this browser.");
      return;
    }
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!solutionRecognitionRef.current) {
      const recognition = new SpeechRecognition();
      recognition.lang = "en-US";
      recognition.interimResults = true;
      recognition.continuous = true;

      recognition.onstart = () => setIsSolutionRecording(true);

      recognition.onresult = (event) => {
        const div = solutionEditableRef.current;
        const selection = window.getSelection();
        const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            const textNode = document.createTextNode(transcript + " ");
            if (range) {
              range.deleteContents();
              range.insertNode(textNode);
              range.setStartAfter(textNode);
              range.setEndAfter(textNode);
              selection.removeAllRanges();
              selection.addRange(range);
            } else {
              div.appendChild(textNode);
            }
            handleSolutionInput();
          }
        }
      };

      recognition.onerror = () => setIsSolutionRecording(false);
      recognition.onend = () => setIsSolutionRecording(false);

      solutionRecognitionRef.current = recognition;
    }
    solutionRecognitionRef.current.start();
  };

  const stopSolutionSpeechToText = () => {
    if (solutionRecognitionRef.current) {
      solutionRecognitionRef.current.stop();
      setIsSolutionRecording(false);
    }
  };

  const toggleSolutionSpeechToText = () => {
    if (isSolutionRecording) stopSolutionSpeechToText();
    else startSolutionSpeechToText();
  };

  const handleSolutionInput = () => {
    const el = solutionEditableRef.current;
    if (!el) return;

    // Capture cursor position (character offset)
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      setSolutionHTML(el.innerHTML);
      return;
    }
    const range = selection.getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(el);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    const cursorPosition = preCaretRange.toString().length;

    // Save current HTML
    setSolutionHTML(el.innerHTML);

    // Restore cursor after the update
    setTimeout(() => {
      const newRange = document.createRange();
      const newSelection = window.getSelection();
      let charCount = 0;

      function restoreCursor(node) {
        if (node.nodeType === 3) {
          const nextCharCount = charCount + node.length;
          if (cursorPosition <= nextCharCount) {
            newRange.setStart(node, cursorPosition - charCount);
            newRange.collapse(true);
            newSelection.removeAllRanges();
            newSelection.addRange(newRange);
            return true;
          }
          charCount = nextCharCount;
        } else {
          for (let i = 0; i < node.childNodes.length; i++) {
            if (restoreCursor(node.childNodes[i])) return true;
          }
        }
        return false;
      }
      restoreCursor(el);
    }, 0);
  };

  //   const handleSolutionPaste = (e) => {
  //     e.preventDefault();
  //     const ref = solutionEditableRef.current;
  //     const items = e.clipboardData.items;
  //     for (let item of items) {
  //       if (item.type.startsWith("image/")) {
  //         const blob = item.getAsFile();
  //         const reader = new FileReader();
  //         reader.onload = (event) => {
  //           const img = document.createElement("img");
  //           img.src = event.target.result;
  //           img.alt = blob.name || "solution-image";
  //           img.classList.add("inserted-image");
  //           const selection = window.getSelection();
  //           const range = selection.getRangeAt(0);
  //           range.deleteContents();
  //           range.insertNode(img);
  //           handleSolutionInput();
  //         };
  //         reader.readAsDataURL(blob);
  //       } else if (item.type === "text/plain") {
  //         const text = e.clipboardData.getData("text/plain");
  //         document.execCommand("insertText", false, text);
  //         handleSolutionInput();
  //       }
  //     }
  //   };

  const solutionFileInputRef = useRef(null);
  //   const handleSolutionFileSelect = (e) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //       const reader = new FileReader();
  //       reader.onload = (event) => {
  //         const img = document.createElement("img");
  //         img.src = event.target.result;
  //         img.alt = file.name || "solution-image";
  //         img.classList.add("inserted-image");
  //         const selection = window.getSelection();
  //         const range = selection.getRangeAt(0);
  //         range.deleteContents();
  //         range.insertNode(img);
  //         handleSolutionInput();
  //       };
  //       reader.readAsDataURL(file);
  //     }
  //   };

  const handleSolutionFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const imageIndex = globalImageCounter + 1;
        const imageName = `image${imageIndex}.png`; // Sequential, like question/options
        setGlobalImageCounter(imageIndex);

        const img = document.createElement("img");
        img.src = event.target.result;
        img.alt = imageName;
        img.classList.add("Img-RQ-QnsAns");
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        range.deleteContents();
        range.insertNode(img);
        handleSolutionInput();
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSolutionPaste = (e) => {
    e.preventDefault();
    const ref = solutionEditableRef.current;
    const items = e.clipboardData.items;
    for (let item of items) {
      if (item.type.startsWith("image/")) {
        const blob = item.getAsFile();
        const reader = new FileReader();
        reader.onload = (event) => {
          const imageIndex = globalImageCounter + 1;
          const imageName = `image${imageIndex}.png`;
          setGlobalImageCounter(imageIndex);

          const img = document.createElement("img");
          img.src = event.target.result;
          img.alt = imageName;
          img.classList.add("Img-RQ-QnsAns");
          const selection = window.getSelection();
          const range = selection.getRangeAt(0);
          range.deleteContents();
          range.insertNode(img);
          handleSolutionInput();
        };
        reader.readAsDataURL(blob);
      } else if (item.type === "text/plain") {
        const text = e.clipboardData.getData("text/plain");
        document.execCommand("insertText", false, text);
        handleSolutionInput();
      }
    }
  };

  const insertSolutionLatex = (latex) => {
    if (solutionEditableRef.current) {
      solutionEditableRef.current.innerHTML += `\\(${latex}\\)`;
      handleSolutionInput();
    }
  };
  return (
    <div
      style={{
        position: "relative",
        width,
        height,
        backgroundColor: "#FBFBFB",
        padding: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          gap: "20px",
          userSelect: isDragging ? "none" : "auto",
        }}
        ref={containerRef}
      >
        {/* Left Section */}
        <div style={{ width: `${dividerPosition}%` }}>
          {/* Main editable div */}

          <p style={{ marginTop: "20px", marginBottom: "10px" }}>
            Question Text :
          </p>
          <div style={{ position: "relative" }}>
            {/* Main ContentEditable Div */}
            <div
              contentEditable
              ref={mainEditableRef}
              onFocus={() => setFocusedOption("main")}
              onInput={() => handleInput("main")}
              onPaste={(e) => handlePaste(e, "main")}
              style={{
                border: "1px solid #6A6A6A",
                padding: "22px 10px 10px", // top, left/right, bottom
                marginBottom: "20px",
                minHeight: "100px",
                backgroundColor: "white",
              }}
              dangerouslySetInnerHTML={{ __html: processTextSecond(content) }}
            ></div>

            {/* Formula Button */}
            <div
              style={{
                position: "absolute",
                top: "5px",
                right: "110px",
                cursor: "pointer",
              }}
              onClick={() => setShowModal(true)}
            >
              <img
                style={{ height: "18px", width: "17px" }}
                src={Formulafx}
                alt="Formula"
              />
            </div>

            {/* Image Upload Button */}
            <div
              style={{
                position: "absolute",
                top: "5px",
                right: "70px",
                cursor: "pointer",
              }}
              onClick={() => fileInputRef.current.click()}
            >
              <img
                style={{ height: "18px", width: "17px" }}
                src={ImgIcon}
                alt="Image Icon"
              />
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={(e) => handleFileSelect(e, "main")}
              />
            </div>

            {/* Recording Button */}
            <div
              style={{
                position: "absolute",
                top: "5px",
                right: "30px",
                cursor: "pointer",
              }}
              onClick={() => toggleSpeechToText("main")}
            >
              <img
                style={{
                  height: "18px",
                  width: "17px",
                  animation: isRecording ? "blink 1s infinite" : "none",
                }}
                src={isRecording ? RecordingActive : RecordingStatic}
                alt="Recording Icon"
              />
            </div>
          </div>

          {/* Additional buttons */}
          {renderOptions()}

          {/* ////////////////new code */}
          <div style={{ marginTop: "20px" }}>
            <label style={{ display: "block", marginBottom: "5px" }}>
              Solution :
            </label>
            <div style={{ position: "relative" }}>
              <div
                contentEditable
                ref={solutionEditableRef}
                onFocus={() => setFocusedOption("solution")}
                onInput={handleSolutionInput}
                onPaste={handleSolutionPaste}
                style={{
                  width: "100%",
                  minHeight: "120px",
                  border: `1px solid ${Colors.color3}`,
                  padding: "25px",
                  backgroundColor: "#fff",
                  color: Colors.color1,
                  resize: "vertical",
                }}
                dangerouslySetInnerHTML={{
                  __html: solutionHTML
                    ? solutionHTML.replace(/\n/g, "<br>")
                    : "",
                }}
              />
              {/* Formula Button */}
              <div
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "110px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setFocusedOption("solution");
                  setShowModal(true);
                }}
              >
                <img
                  style={{ height: "18px", width: "17px" }}
                  src={Formulafx}
                  alt="Formula"
                />
              </div>
              {/* Image Upload Button */}
              <div
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "70px",
                  cursor: "pointer",
                }}
                onClick={() => solutionFileInputRef.current.click()}
              >
                <img
                  style={{ height: "18px", width: "17px" }}
                  src={ImgIcon}
                  alt="Image Icon"
                />
                <input
                  type="file"
                  accept="image/*"
                  ref={solutionFileInputRef}
                  style={{ display: "none" }}
                  onChange={handleSolutionFileSelect}
                />
              </div>
              {/* Recording Button */}
              <div
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "30px",
                  cursor: "pointer",
                }}
                onClick={toggleSolutionSpeechToText}
              >
                <img
                  style={{
                    height: "18px",
                    width: "17px",
                    animation: isSolutionRecording
                      ? "blink 1s infinite"
                      : "none",
                  }}
                  src={isSolutionRecording ? RecordingActive : RecordingStatic}
                  alt="Recording Icon"
                />
              </div>
            </div>

            <label
              style={{
                // fontWeight: "bold",
                marginTop: "15px",
                display: "block",
                marginBottom: "5px",
              }}
            >
              Video Link (optional):
            </label>
            <input
              type="text"
              placeholder="https://youtube.com/..."
              value={videoLink}
              onChange={(e) => setVideoLink(e.target.value)}
              style={{
                width: "100%",
                border: `1px solid ${Colors.color3}`,
                padding: "10px",
                color: `${Colors.color1}`,
                backgroundColor: "#fff",
              }}
            />
          </div>
        </div>

        {/* Draggable divider */}
        <div
          style={{
            position: "relative",
            cursor: "col-resize",
            width: "10px",
            margin: "0 -5px",
            zIndex: 20,
          }}
          onMouseDown={handleMouseDown}
        >
          <div
            style={{
              marginTop: "5vh",
              position: "absolute",
              top: 0,
              bottom: 0,
              left: "50%",
              borderLeft: "2px dotted #ccc",
              height: "87%",
            }}
          >
            {/* Triangle pointer */}
            <div
              style={{
                position: "absolute",
                top: "50%",
                right: "-6px",
                width: 0,
                height: 0,
                borderTop: "6px solid transparent",
                borderBottom: "6px solid transparent",
                borderLeft: "6px solid #ccc",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>

        {/* Right side with options */}

        {/* Right Section */}

        <div style={{ width: `${100 - dividerPosition}%` }}>
          <p style={{ marginTop: "2.2vh" }}>Preview :</p>

          <div
            style={{
              width: "100%",
              border: "1px solid #ccc",
              padding: "10px",
              backgroundColor: "white",
              minHeight: "100px",
              whiteSpace: "pre-wrap",
              marginTop: "1vh",
            }}
          >
            <div>
              <div style={{ paddingBottom: "15px", paddingTop: "8px" }}>
                Question:
              </div>
              <div
                style={{ padding: "8px" }}
                dangerouslySetInnerHTML={{
                  __html: processText(content),
                }}
              ></div>
            </div>
            <div>{renderRightOptions()}</div>
            <div style={{ marginTop: "20px" }}>
              <div>Solution:</div>
              {/* <div
                style={{ padding: "10px" }}
                dangerouslySetInnerHTML={{ __html: solutionHTML }}
              /> */}
              <div
                style={{ padding: "10px" }}
                dangerouslySetInnerHTML={{ __html: processText(solutionHTML) }}
              />

              {videoLink && (
                <div style={{ marginTop: "10px" }}>
                  <div>Video Link:</div>
                  {videoLink.includes("<iframe") ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: videoLink }}
                      style={{ marginTop: "10px", marginLeft: "12px" }}
                    />
                  ) : (
                    <a
                      style={{
                        color: Colors.color12,
                        marginLeft: "12px",
                        marginTop: "10px",
                      }}
                      href={videoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {videoLink}
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal show={showModal} onClose={() => setShowModal(false)}>
        <h2 style={{ color: "white" }}>MathLive Input</h2>
        <MathLive onLatexChange={handleLatexChange} />
        <button
          onClick={sendToTextBox}
          style={{
            marginTop: "10px",
            cursor: "pointer",
            backgroundColor: "#f0f0f0",
            color: "black",
            padding: "10px 20px",
            border: "1px solid black",
            borderRadius: "5px",
            fontWeight: "600",
          }}
        >
          Send to Text Box
        </button>
      </Modal>
    </div>
  );
};

export default React.memo(ReviewComponent);
